import { onAuthStateChanged } from "firebase/auth";
import { useEffect, useRef, useState } from "react";
import { auth, db } from "../firebase-config";
import { useLocation, useNavigate } from "react-router-dom";
import { addDoc, and, collection, deleteDoc, doc, getDoc, getDocs, limit, or, orderBy, query, setDoc, updateDoc, where } from "firebase/firestore";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from '../redux/userReducer'
import { checkEmailInValid, findCurrentWeekActivity, getClassType, getFirebaseDocs, getUrlParams, randomString, resolveWeekActivity, updateHoursAndMinutesAndDay } from '../common'
import Header from '../components/Header'
import Input from "../components/Input";
import Dropdown from "../components/Dropdown";
import { addDays, addMonths, differenceInDays, eachMonthOfInterval, endOfDay, endOfMonth, endOfYear, format, getMonth, getWeek, getWeekOfMonth, getWeekYear, isAfter, isBefore, isSameYear, startOfDay, startOfMonth, startOfWeek, startOfYear, subDays, subMonths, subWeeks, subYears } from "date-fns";
import { Scheduler } from "@aldabil/react-scheduler";
import { RRule } from "rrule";
import MyCalendar from "../components/Calendar";
import ModalComp from "../components/Modal";
import Tabs from "../components/Tabs";
import Checkbox from "../components/Checkbox";
import AutoComplete from "react-google-autocomplete";
import Map from "../components/Map";
import MyDropzone from "../components/MyDropzone";
import CsvUploader from "../components/PendingInvoice";
import InvoicesByState from "../components/InvoicesByState";
import { fromZonedTime, toZonedTime } from 'date-fns-tz'

const getFunctionUrl = (name) => `https://australia-southeast2-mini-monstars-au.cloudfunctions.net/${name}`

const Calendar = () => {

    const townsByState = {
        VIC: ['Geelong', 'Bendigo', 'Ballarat', 'Gippsland', 'Melbourne'],
        NSW: ['Newcastle', 'Central Coast', 'Wollongong', 'Sydney', 'Canberra', 'Port Macquarie', 'Albury-Wodonga', 'Wagga Wagga', 'Coffs Harbour', 'Tamworth', 'Dubbo', 'Orange', 'Bathurst'],
        QLD: ['Toowoomba', 'Gold Coast', 'Sunshine Coast', 'Mackay', 'Rockhampton', 'Townsville', 'Cairns', 'Brisbane'],
        SA: ['Adelaide'],
        TAS: ['Launceston', 'Hobart'],
        WA: ['Perth']
    }
    const stateOptions = Object.keys(townsByState)
    const getTownOptionsForState = (stateValue) => stateValue && townsByState[stateValue] ? townsByState[stateValue] : []
    const normalizeAustralianPhone = (value = '') => {
        const digitsOnly = String(value || '').replace(/\D/g, '')
        let localDigits = digitsOnly

        if (localDigits.startsWith('61')) {
            localDigits = localDigits.slice(2)
        }

        if (localDigits.startsWith('0')) {
            localDigits = localDigits.slice(1)
        }

        localDigits = localDigits.slice(0, 9)

        if (!localDigits) {
            return ''
        }

        if (localDigits.length <= 3) {
            return `+61 ${localDigits}`
        }

        if (localDigits.length <= 6) {
            return `+61 ${localDigits.slice(0, 3)} ${localDigits.slice(3)}`
        }

        return `+61 ${localDigits.slice(0, 3)} ${localDigits.slice(3, 6)} ${localDigits.slice(6)}`
    }

    const musicFTOptions = ['musicFastOne', 'musicFastTwo', 'musicFastThree', 'musicFastFour']
    const gymFTOptions = ['gymFastOne', 'gymFastTwo', 'gymFastThree', 'gymFastFour']
    const equipmentCategories = ['Sports', 'Music', 'Gymnastics', 'Yoga', 'Sensory Fusion', 'Other']
    const equipmentCategoriesWithoutOther = equipmentCategories.filter(category => category !== 'Other')
    const educationCenterStatuses = ['New Center', 'Ongoing', 'One Off', 'Offer', 'Offer Closed', 'Short Bookings', 'Short Bookings Closed', 'Trial', 'Trial Closed', 'Closed']
    // Deliberately excludes 'Short Bookings'. Churn measures ongoing centers we
    // lose, and a short booking ending is the expected outcome rather than a loss,
    // so it must not land in either side of the churn ratio.
    const activeStatsCenterStatuses = ['New Center', 'Ongoing', 'Offer']
    const closedEducationCenterStatuses = ['Offer Closed', 'Short Bookings Closed', 'Trial Closed', 'Closed']


    const [page, setPage] = useState('Calendar')
    const [viewMode, setViewMode] = useState('month')
    const [returnedUsers, setReturnedUsers] = useState([])
    const [feedbackSubmitters, setFeedbackSubmitters] = useState([])

    const [centerEquipments, setCenterEquipments] = useState({})

    const [coachFilter, setCoachFilter] = useState([])
    const [search, setSearch] = useState('')

    const [events, setEvents] = useState([])
    const [calendarDate, setCalendarDate] = useState(new Date()) // Date in current calendars view. used to figure start/end dates to fetch calendars.
    const [educationCentersList, setEducationCentersList] = useState([])
    const [eventsAttendance, setEventsAttendance] = useState({
        Total: [],
        Attended: [],
        Missed: [],
        Rescheduled: []
    })
    const [educationCentersTrialsList, setEducationCentersTrialsList] = useState([])

    const [centerStaffFeedbacks, setCenterStaffFeedbacks] = useState([])
    const [centerStaffFeedbacksCoach, setCenterStaffFeedbacksCoach] = useState([])
    const [centerFeedbacks, setCenterFeedbacks] = useState([])
    const [viewCenter, setViewCenter] = useState('')
    const [showAddFeedbackModal, setShowAddFeedbackModal] = useState('')
    const [showAddGeneralFeedbackModal, setShowAddGeneralFeedbackModal] = useState('')
    const [rescheduledSessionsOfCenter, setRescheduledSessionsOfCenter] = useState([])
    const [attendedSessionsOfCenter, setAttendedSessionsOfCenter] = useState([])
    const [missedSessionsOfCenter, setMissedSessionsOfCenter] = useState([])
    const [coveredSessionsOfCenter, setCoveredSessionsOfCenter] = useState([])

    const [loading, setLoading] = useState(false)
    const [showDeletePopup, setShowDeletePopup] = useState(false)
    const [churnRates, setChurnRates] = useState({ centersLostThatMonth: [], centersOngoingTillPrevMonth: [] })

    const [cityFilterOptions, setCityFilterOptions] = useState(stateOptions)
    const [cityFilterOptionsCoach, setCityFilterOptionsCoach] = useState(stateOptions)
    const [nameFilterOptionsFeedback, setNameFilterOptionsFeedback] = useState([])
    const [statusFilter, setStatusFilter] = useState('All')
    const [cityFilter, setCityFilter] = useState('All')
    const [townFilter, setTownFilter] = useState('All')
    const [stockRoomFilter, setStockRoomFilter] = useState('Stock Room')
    const [statsDate, setStatsDate] = useState(new Date())
    const [statsType, setStatsType] = useState('YTD')
    const [statsYear, setStatsYear] = useState(new Date().getFullYear())
    const [sessionFilter, setSessionFilter] = useState('All')
    const [sessionTypeFilter, setSessionTypeFilter] = useState('All')
    const [nameFilter, setNameFilter] = useState('All') //Name Filter used in Feedbacks
    const [categoryFilter, setCategoryFilter] = useState('All')
    const [stateFilter, setStateFilter] = useState('All')
    const [onboardingStatusFilter, setOnboardingStatusFilter] = useState('All')
    const [yearFilter, setYearFilter] = useState(format(new Date(), 'yyyy'))
    const [closedReasonFilter, setClosedReasonFilter] = useState('Our Fault')
    const [trialFilter, setTrialFilter] = useState('All')
    const [inHouseFilter, setInHouseFilter] = useState('All')
    const [fourSessionNoticeFilter, setFourSessionNoticeFilter] = useState('All')
    const [centerSortConfig, setCenterSortConfig] = useState({ property: '', direction: 'desc' })


    const [confirmDeleteEducationCenter, setConfirmDeleteEducationCenter] = useState(false)
    const [addEducationCenterId, setAddEducationCenterId] = useState('')
    const [addEducationCenterText, setAddEducationCenterText] = useState('')
    const [addEducationCenterInvoiceName, setAddEducationCenterInvoiceName] = useState('')
    const [addEducationCenterStudentCount, setAddEducationCenterStudentCount] = useState('')
    const [addEducationCenterProgramCode, setAddEducationCenterProgramCode] = useState('')
    const [addEducationCenterAddress, setAddEducationCenterAddress] = useState('')
    const [addEducationCenterCoords, setAddEducationCenterCoords] = useState('')
    const [addEducationCenterCity, setAddEducationCenterCity] = useState('')
    const [addEducationCenterTown, setAddEducationCenterTown] = useState('')

    const [addEducationCenterPhone, setAddEducationCenterPhone] = useState('')
    const [addEducationCenterEmail, setAddEducationCenterEmail] = useState('')
    const [addEducationCenterPoints, setAddEducationCenterPoints] = useState('')
    const [addEducationCenterPointsType, setAddEducationCenterPointsType] = useState('')
    const [addEducationCenterDirectorName, setAddEducationCenterDirectorName] = useState('')
    const [addEducationCenterManagedBy, setAddEducationCenterManagedBy] = useState('')
    const [addEducationCenterStaffDeliverSessions, setAddEducationCenterStaffDeliverSessions] = useState(false)
    const [addEducationCenterSoldBy, setAddEducationCenterSoldBy] = useState('')
    const [addEducationCenterMikeyAppPoster, setAddEducationCenterMikeyAppPoster] = useState({ label: 'No', value: 'No' })
    const [addEducationCenterStartDate, setAddEducationCenterStartDate] = useState(new Date())
    const [addEducationCenterNotes, setAddEducationCenterNotes] = useState('')
    const [addEducationCenterCategories, setAddEducationCenterCategories] = useState([])
    const [addEducationCenterStatus, setAddEducationCenterStatus] = useState('')
    const [addEducationCenterStatusPrevious, setAddEducationCenterStatusPrevious] = useState('')
    const [addEducationCenterTrialReason, setAddEducationCenterTrialReason] = useState('')
    const [addEducationCenterCoaches, setAddEducationCenterCoaches] = useState([])
    const [addEducationCenterFourSessionNotice, setAddEducationCenterFourSessionNotice] = useState({ label: 'No', value: 'No' })
    const [addEducationCenterFourSessionNoticeReason, setAddEducationCenterFourSessionNoticeReason] = useState('')
    const [addEducationCenterCompletedOnboardingSteps, setAddEducationCenterCompletedOnboardingSteps] = useState([])
    const [addEducationCenterCompletedTrialSteps, setAddEducationCenterCompletedTrialSteps] = useState([])
    const [showAddEducationCenter, setShowAddEducationCenter] = useState(false)

    const [addEducationCenterClosedDate, setAddEducationCenterClosedDate] = useState('')
    const [addEducationCenterClosedType, setAddEducationCenterClosedType] = useState('')
    const [addEducationCenterClosedDesc, setAddEducationCenterClosedDesc] = useState('')

    const [showUpdateUserInfo, setShowUpdateUserInfo] = useState(false)

    const [viewUser, setViewUser] = useState('')
    const [visibleCoachSection, setVisibleCoachSection] = useState('')
    const [visibleCenterSection, setVisibleCenterSection] = useState('')
    const [addCoachCompletedOnboardingSteps, setAddCoachCompletedOnboardingSteps] = useState([])
    const [addCoachCompletedOnboardingStepsA, setAddCoachCompletedOnboardingStepsA] = useState([])
    const [addCoachCompletedOnboardingStepsB, setAddCoachCompletedOnboardingStepsB] = useState([])
    const [addCoachOnboardingStepsType, setAddCoachOnboardingStepsType] = useState()

    const [coachFeedbacks, setCoachFeedbacks] = useState([])
    const [coachGeneralFeedbacks, setCoachGeneralFeedbacks] = useState([])
    const [coachHeadFeedbacks, setCoachHeadFeedbacks] = useState([])
    const [coachFiveStarFeedbacks, setCoachFiveStarFeedbacks] = useState([])
    const [coachAttendedStats, setCoachAttendedStats] = useState({ Attended: 0, Missed: 0, Covered: 0 })
    const [childrenCheckId, setChildrenCheckId] = useState('')

    const [childrenChecks, setChildrenChecks] = useState([])
    const [resumeReferenceChecks, setResumeReferenceChecks] = useState([])
    const [nationalSafetyTrainings, setNationalSafetyTrainings] = useState([])
    const [workRightsDocuments, setWorkRightsDocuments] = useState([])
    const [contracts, setContracts] = useState([])
    const [showCoachChildrenChecksPopup, setShowCoachChildrenChecksPopup] = useState(false)
    const [childrenCheckPopupExpiryDate, setChildrenCheckPopupExpiryDate] = useState('')
    const [childrenCheckImage, setChildrenCheckImage] = useState('')
    const [childrenCheckType, setChildrenCheckType] = useState('children-check')
    const [deleteCoachDocumentId, setDeleteCoachDocumentId] = useState('')
    const [emergencyContactFirstName, setEmergencyContactFirstName] = useState('')
    const [emergencyContactSurname, setEmergencyContactSurname] = useState('')
    const [emergencyContactMobileNumber, setEmergencyContactMobileNumber] = useState('')
    const [emergencyContactRelationship, setEmergencyContactRelationship] = useState('')

    const [addUserReceivedUniform, setAddUserReceivedUniform] = useState('')
    const [addUserId, setAddUserId] = useState('')
    const [addUserName, setAddUserName] = useState('')
    const [addUserAddress, setAddUserAddress] = useState('')
    const [addUserCoords, setAddUserCoords] = useState('')
    const [addUserCity, setAddUserCity] = useState('')
    const [addUserTown, setAddUserTown] = useState('')
    const [addUserPhone, setAddUserPhone] = useState('')
    const [addUserDateOfBirth, setAddUserDateOfBirth] = useState('')
    const [addUserTopSize, setAddUserTopSize] = useState('')
    const [addUserBankName, setAddUserBankName] = useState('')
    const [addUserBsb, setAddUserBsb] = useState('')
    const [addUserAccountNumber, setAddUserAccountNumber] = useState('')
    const [addUserTfn, setAddUserTfn] = useState('')
    const [addUserSuperNumberAndProvider, setAddUserSuperNumberAndProvider] = useState('')
    const [addUserClaimTaxFreeThreshold, setAddUserClaimTaxFreeThreshold] = useState('')
    const [addUserColor, setAddUserColor] = useState('')
    const [addUserEmail, setAddUserEmail] = useState('')
    const [addUserStartDate, setAddUserStartDate] = useState('')
    const [addUserEndDate, setAddUserEndDate] = useState('')
    const [addUserAboutMe, setAddUserAboutMe] = useState('')
    const [addUserProfilePic, setAddUserProfilePic] = useState('')
    const [addUserNotes, setAddUserNotes] = useState('')
    const [addUserCategories, setAddUserCategories] = useState([])
    const [addUserSpeciality, setAddUserSpeciality] = useState([])
    const [addUserStatus, setAddUserStatus] = useState('')
    const [addUserStatusPrevious, setAddUserStatusPrevious] = useState('')
    const [addUserInactiveDate, setAddUserInactiveDate] = useState('')
    const [addUserInactiveReason, setAddUserInactiveReason] = useState('')
    const [addUserInactiveHistory, setAddUserInactiveHistory] = useState([])
    const [addUserAvailabilities, setAddUserAvailabilities] = useState(['Available', 'Available', 'Available', 'Available', 'Available'])

    const [feedbackId, setFeedbackId] = useState('')
    const [feedbackDate, setFeedbackDate] = useState('')
    const [feedbackTitle, setFeedbackTitle] = useState('')
    const [feedbackName, setFeedbackName] = useState('')
    const [feedbackSubmittedBy, setFeedbackSubmittedBy] = useState('')
    const [feedbackDesc, setFeedbackDesc] = useState('')
    const [feedbackAttachment, setFeedbackAttachment] = useState('')
    const [feedbackCoach, setFeedbackCoach] = useState('')
    const [punctualityRating, setPunctualityRating] = useState(0)
    const [attendanceRating, setAttendanceRating] = useState(0)
    const [interactionRating, setInteractionRating] = useState(0)
    const [qualityCoachRating, setQualityCoachRating] = useState(0)
    const [qualityProgramRating, setQualityProgramRating] = useState(0)

    const [globalFeedbacks, setGlobalFeedbacks] = useState([])

    const [showDeleteFeedbackPopup, setShowDeleteFeedbackPopup] = useState(false)
    const [showDeleteGeneralFeedbackPopup, setShowDeleteGeneralFeedbackPopup] = useState(false)
    const [showAddFiveStarFeedbackModal, setShowAddFiveStarFeedbackModal] = useState(false)
    const [showDeleteFiveStarFeedbackPopup, setShowDeleteFiveStarFeedbackPopup] = useState(false)
    const [showConfirmAdminOnboardingPopup, setShowConfirmAdminOnboardingPopup] = useState(false)
    const [showConfirmResendAdminInvitePopup, setShowConfirmResendAdminInvitePopup] = useState(false)
    const [resendingAdminInvite, setResendingAdminInvite] = useState(false)
    const [addingStaffProfile, setAddingStaffProfile] = useState(false)
    const [editingStaffProfileId, setEditingStaffProfileId] = useState('')
    const [staffProfileName, setStaffProfileName] = useState('')
    const [staffProfileRoomName, setStaffProfileRoomName] = useState('')
    const [staffProfileRoomType, setStaffProfileRoomType] = useState('')
    const [staffProfileType, setStaffProfileType] = useState('manual')
    const [staffProfileIsActive, setStaffProfileIsActive] = useState(true)
    const [deleteHolidayId, setDeleteHolidayId] = useState('')
    const [height, setHeight] = useState(3500)

    const [invoicesPending, setInvoicesPending] = useState([])

    const [feedbackViewDate, setFeedbackViewDate] = useState(startOfWeek(new Date(), { weekStartsOn: 1 }))
    const [mapViewType, setMapViewType] = useState('All')
    const [fiveStarFeedbackId, setFiveStarFeedbackId] = useState('')
    const [fiveStarFeedbackDate, setFiveStarFeedbackDate] = useState('')
    const [fiveStarFeedbackRating, setFiveStarFeedbackRating] = useState('')
    const [fiveStarFeedbackComment, setFiveStarFeedbackComment] = useState('')


    const [showAssignEquipment, setShowAssignEquipment] = useState(false)
    const [showTransferEquipment, setShowTransferEquipment] = useState(false)
    const [addEquipmentType, setAddEquipmentType] = useState('')
    const [equipments, setEquipments] = useState([])
    const [holidays, setHolidays] = useState([])
    const [startDay, setStartDay] = useState('')
    const [endDay, setEndDay] = useState('')

    const [viewHolidayType, setViewHolidayType] = useState('Upcoming')
    const [holidayStateFilter, setHolidayStateFilter] = useState('All')
    const [editHoliday, setEditHoliday] = useState('')

    const [usersEquipments, setUsersEquipments] = useState([])

    const [receiverUser, setReceiverUser] = useState('')
    const [receiverEquipments, setReceiverEquipments] = useState([])

    const [showTotalCentresLost, setShowTotalCentersLost] = useState(false)
    const [showFaultCentresLost, setShowFaultCentersLost] = useState(false)
    const [showNotFaultCentresLost, setShowNotFaultCentersLost] = useState(false)
    const [centerAttendanceSortBy, setCenterAttendanceSortBy] = useState('sessionsAttended')


    const [addingAdmin, setAddingAdmin] = useState(false)

    const [adminFirstName, setAdminFirstName] = useState('')
    const [adminLastName, setAdminLastName] = useState('')
    const [adminEmail, setAdminEmail] = useState('')

    // const [mode, setMode] = useState(modes[0])
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const location = useLocation()

    // const [coachCategories, setCoachCategories] = useState([])

    const onboardingStepsOptions = [
        { label: 'Step 1 - Add New Centre to Calendar', color: '#FFFFFF' },
        { label: 'Step 2 - Welcome email and call', color: '#980000' },
        { label: 'Step 3 - 1 week away Call', color: '#ff0000' },
        { label: 'Step 4 OLD - Day before automated email (Automated)', color: '#ff9900', hidden: true },
        { label: 'Step 4 - Call post first session', color: '#ffff00' },
        { label: 'Step 6 OLD - Week 2 - App First Call', color: '#02ff00', hidden: true },
        { label: 'Step 5 - Call post 3rd Session', color: '#02ffff' },
        { label: 'Step 8 OLD - Week 5 - App Second Call', color: '#4985e8', hidden: true },
        { label: 'Step 6 - Week 6 - Call post 6th Session', color: '#0000ff' },
        { label: 'Step 10 OLD - Week 7 - App Third Call', color: '#9900ff', hidden: true },
        { label: 'Step 7 - Week 9 - Call post 9th Session', color: '#ff00ff' },
        { label: 'Step 8 -  Centre onboarded', color: '#FFFF00' },
    ]


    const trialStepsOptions = [
        { label: 'Step 1 - Lock In Trial', color: '#FFFFFF' },
        { label: 'Step 2 - Speak to Coach on what day and time would suit them', color: '#980000' },
        { label: 'Step 3 - Call centre back and lock in that time', color: '#ff0000' },
        { label: 'Step 4 - immediatly send email to centre', color: '#ff9900' },
        { label: 'Step 5 - call 1 week before trial session', color: '#ffff00' },
        { label: 'Step 6 - Automated email day before', color: '#02ff00' },
        { label: 'Step 7 - Call Day of or day after session to lock them in', color: '#02ffff' },
    ]

    const coachDocumentSections = [
        {
            key: 'children-check',
            label: 'Working With Children Check',
            storageLocation: 'ChildrenChecks',
            rows: childrenChecks
        },
        {
            key: 'resume-reference-check',
            label: 'Resume & Reference Checks',
            storageLocation: 'ResumeReferenceChecks',
            rows: resumeReferenceChecks
        },
        {
            key: 'national-safety-training',
            label: 'National Safety Training',
            storageLocation: 'NationalSafetyTraining',
            rows: nationalSafetyTrainings
        },
        {
            key: 'work-rights',
            label: 'Work Rights',
            storageLocation: 'WorkRights',
            rows: workRightsDocuments
        },
        {
            key: 'contract',
            label: 'Contract',
            storageLocation: 'CoachContracts',
            rows: contracts
        }
    ]


    const onboardingStepsCoach = ["Send Welcome Email", "Recieved back code of conduct / signed", "Organise AC sessions", "Video call to run through the app and how to view programs and see if they have Q’s", "Let HC know they will have an AC", "After first sessions - check form filled out by HC", "If HC and AC both are happy with first session send uniform"]
    const onboardingStepsCoachA = ["Set next week schedule with quality coaches", "After Second session Call with AC", "Let HC know that they will Have an AC", "Second session - let AC/HC know they will be taking Warm up", "Third session - let AC/HC know they will be taking minimum one full class/age group that day", "Onboarded / Start trying to find coach sessions / slowly continue AC work until built up their HC roles"]
    const onboardingStepsCoachB = ["Set next week schedule with quality coaches", "After Second session Call with AC", "Let HC know that they will Have an AC", "Second Week - let AC/HC know they will be taking Warm up", "Third Week - let AC/HC know they will be taking minimum one full class/age group that day", "Repeat step 6 if necessary", "ONBOARD/OFFBOARD - find coach HC sessions / slowly continue AC work until built up their HC sessions"]

    const userInfo = useSelector(state => state.user.user)
    const staffTabs = ['Calendar', 'Centers', 'Feedbacks', 'Equipment', 'Maps']
    const adminTabs = ['Calendar', 'Centers', 'Coaches', 'Availability', 'Feedbacks', 'Maps', 'Equipment', 'Holidays', 'Stats', 'Invoices Upload']
    const availableTabs = userInfo && userInfo.role === 'staff' ? staffTabs : adminTabs

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {

                const uid = user.uid
                getUserInfo(uid)
            } else {
                // User is signed out
                navigate('/login')
                // ...
            }
        })
        return () => unsubscribe()
    }, [])

    useEffect(() => {
        if (userInfo && userInfo.role === 'admin') {
            const urlParams = getUrlParams()
            if (returnedUsers.length === 0) {
                // console.log('fetching users')
                fetchUsers()
                fetchEducationCenters()
                fetchInvoicesPending()
            }

        } else if (userInfo && userInfo.role === 'staff') {
            if (returnedUsers.length === 0) {
                fetchUsers()
                fetchEducationCenters()
            }
        }
    }, [userInfo, location])

    useEffect(() => {
        if (userInfo && userInfo.role === 'staff' && !staffTabs.includes(page)) {
            setPage('Calendar')
        }
    }, [userInfo, page])

    const isStaffUser = userInfo && userInfo.role === 'staff'
    const isPdfDocument = (url = '') => String(url || '').toLowerCase().includes('.pdf')

    const getCoachDocumentSection = (type) => coachDocumentSections.find(section => section.key === type) || coachDocumentSections[0]

    const normalizeCenterProgramCode = (value = '') => String(value || '').trim().toUpperCase()

    const isValidCenterProgramCode = (value = '') => /^[A-Z0-9]{6}$/.test(normalizeCenterProgramCode(value))

    const isCenterActiveForProgram = (statusValue = '') => {
        const normalizedStatus = String(statusValue || '').trim().toLowerCase()
        return !['closed', 'trial closed', 'short bookings closed'].includes(normalizedStatus)
    }

    const generateCenterProgramCode = (usedCodes = new Set()) => {
        const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'
        let attempts = 0
        while (attempts < 1000) {
            let code = ''
            for (let index = 0; index < 6; index += 1) {
                code += chars[Math.floor(Math.random() * chars.length)]
            }
            if (!usedCodes.has(code)) {
                return code
            }
            attempts += 1
        }
        throw new Error('Unable to generate unique center code')
    }

    const getUniqueCenterProgramCode = async (usedCodes = new Set()) => {
        let attempts = 0
        while (attempts < 50) {
            const candidate = generateCenterProgramCode(usedCodes)
            const existing = await getFirebaseDocs(await getDocs(query(collection(db, 'education-centers'), where('programCode', '==', candidate), limit(1))))
            if (existing.length === 0) {
                return candidate
            }
            attempts += 1
        }
        throw new Error('Unable to reserve unique center code')
    }

    const syncParentProgramAccessForCenter = async ({ centerId, centerName, centerStatus, centerProgramCode }) => {
        if (!centerId) {
            return
        }
        const isCenterActive = isCenterActiveForProgram(centerStatus)
        const usersWithProgramAccess = await getFirebaseDocs(await getDocs(query(collection(db, 'users'), where('programAccess.centerId', '==', centerId))))

        for (let row of usersWithProgramAccess) {
            if (row.role !== 'parent' || !row.programAccess) {
                continue
            }
            await updateDoc(doc(db, 'users', row.id), {
                programAccess: {
                    ...row.programAccess,
                    centerName: centerName || row.programAccess.centerName || '',
                    centerCode: centerProgramCode || row.programAccess.centerCode || '',
                    centerStatus: centerStatus || 'Closed',
                    isActive: isCenterActive,
                    checkedAt: new Date().toISOString(),
                }
            })
        }
    }

    useEffect(() => {
        if (calendarDate) {
            fetchEvents()
        }
    }, [calendarDate])

    useEffect(() => {
        if (educationCentersList.length > 0) {
            setCityFilterOptions(stateOptions)
        }
    }, [educationCentersList])

    useEffect(() => {
        if (returnedUsers.length > 0) {
            setCityFilterOptionsCoach(stateOptions)
        }
    }, [returnedUsers])

    useEffect(() => {
        const availableTowns = getTownOptionsForState(cityFilter)
        if (cityFilter === 'All' || !availableTowns.includes(townFilter)) {
            setTownFilter('All')
        }
    }, [cityFilter, townFilter])

    useEffect(() => {
        if (!addEducationCenterCity) {
            setAddEducationCenterTown('')
            return
        }
        const availableTowns = getTownOptionsForState(addEducationCenterCity)
        if (!availableTowns.includes(addEducationCenterTown)) {
            setAddEducationCenterTown('')
        }
    }, [addEducationCenterCity, addEducationCenterTown])

    useEffect(() => {
        if (!addUserCity) {
            setAddUserTown('')
            return
        }
        const availableTowns = getTownOptionsForState(addUserCity)
        if (!availableTowns.includes(addUserTown)) {
            setAddUserTown('')
        }
    }, [addUserCity, addUserTown])


    useEffect(() => {
        if (globalFeedbacks.length > 0) {
            const names = globalFeedbacks.map(r => r.name).filter(r => r)
            setNameFilterOptionsFeedback([...new Set(names)])
            return
        }
        setNameFilterOptionsFeedback([])
        setNameFilter('All')
    }, [globalFeedbacks])

    useEffect(() => {
        if (viewCenter) {
            fetchFeedbacks()
            fetchCenterStaffFeedbacks()
            fetchMissedSessionsForCenter()
            fetchAttendedSessionsForCenter()
            fetchRescheduledSessionsForCenter()

        }
    }, [viewCenter])

    useEffect(() => {
        if (viewUser) {
            fetchFeedbacksOfCoach()
            fetchCoachDocumentsOfCoach()
            fetchGeneralFeedbacksOfCoach()
            fetchHeadFeedbacksOfCoach()
            fetchFiveStarFeedbacksOfCoach()
            fetchAttendedMissedCoveredCounts()
            refreshOnboardingStepsCoach()
            fetchCenterStaffFeedbacksCoach()
            const fallbackEmergencyName = viewUser.emergencyContactName || [viewUser.emergencyContactFirstName, viewUser.emergencyContactSurname].filter(Boolean).join(' ').trim()
            const [fallbackFirstName, ...fallbackSurnameParts] = fallbackEmergencyName.split(' ').filter(Boolean)
            setEmergencyContactFirstName(viewUser.emergencyContactFirstName || fallbackFirstName || '')
            setEmergencyContactSurname(viewUser.emergencyContactSurname || fallbackSurnameParts.join(' ') || '')
            setEmergencyContactMobileNumber(viewUser.emergencyContactPhoneNumber || viewUser.emergencyContactMobileNumber || '')
            setEmergencyContactRelationship(viewUser.emergencyContactRelationship || '')
        }
    }, [viewUser])


    useEffect(() => {
        if (!showAssignEquipment) {
            setAddEquipmentType('')
        }
    }, [showAssignEquipment])

    useEffect(() => {
        if (!addEducationCenterFourSessionNotice || addEducationCenterFourSessionNotice.value !== 'Yes') {
            setAddEducationCenterFourSessionNoticeReason('')
        }
    }, [addEducationCenterFourSessionNotice])

    const refreshOnboardingStepsCoach = () => {
        setAddCoachCompletedOnboardingSteps(viewUser.onboardingStepsCompleted || [])
        setAddCoachOnboardingStepsType(updateDropdownValue(viewUser.onboardingStepsType))
        setAddCoachCompletedOnboardingStepsA(viewUser.onboardingStepsCompletedA || [])
        setAddCoachCompletedOnboardingStepsB(viewUser.onboardingStepsCompletedB || [])
    }

    useEffect(() => {
        if (page === 'Feedbacks') {
            fetchGlobalFeedbacks()
        }
    }, [page, feedbackViewDate, userInfo])

    useEffect(() => {
        if (page === 'Coaches' || page === 'Equipment') {
            fetchEquipments()
        } else if (page === 'Holidays') {
            fetchHolidays()
        }
    }, [page])

    useEffect(() => {
        setSearch('')
    }, [page])

    useEffect(() => {
        if (page === 'Stats') {
            fetchChurn()
        }
    }, [page, stateFilter, cityFilter, statsType, statsDate, statsYear])

    useEffect(() => {
        if (page === 'Stats') {
            fetchEventsAttendance()
        }
    }, [page, statsDate.getFullYear()])

    useEffect(() => {
        if (page === 'Stats') {
            fetchEducationCenters()
        }
    }, [page])

    useEffect(() => {
        if (statsType === 'YTD' && statsDate !== new Date()) {
            setStatsDate(new Date())
        }
    }, [statsType])

    useEffect(() => {
        if (statsType !== 'Month' && centerAttendanceSortBy === 'classesScheduled') {
            setCenterAttendanceSortBy('sessionsAttended')
        }
    }, [statsType, centerAttendanceSortBy])


    useEffect(() => {
        if (centerFeedbacks && centerFeedbacks.length > 0 && viewCenter) {
            // Update average rating for center..

            if (centerFeedbacks.find(r => r.center === viewCenter.id)) {
                // Checking if feedbacks belong to that center
                const feedbacksWithAvgRating = centerFeedbacks.map(r => r.avgRating).filter(r => r)

                const sum = feedbacksWithAvgRating.reduce((partialSum, a) => partialSum + a, 0);

                let avgRating = 0
                if (feedbacksWithAvgRating.length > 0) {
                    avgRating = (sum / feedbacksWithAvgRating.length)
                } else {
                    avgRating = 0
                }

                // Update center with that average rating
                updateCenterWithAvgRating(avgRating, viewCenter.id)

            }
        }
    }, [centerFeedbacks, viewCenter])


    useEffect(() => {
        if (coachFeedbacks && coachFeedbacks.length > 0 && viewUser) {
            // Update average rating for center..

            if (coachFeedbacks.find(r => r.coach.value === viewUser.id)) {
                // Checking if feedbacks belong to that center
                const feedbacksWithAvgRating = coachFeedbacks.map(r => r.avgRating).filter(r => r)

                const sum = feedbacksWithAvgRating.reduce((partialSum, a) => partialSum + a, 0);

                let avgRating = 0
                if (feedbacksWithAvgRating.length > 0) {
                    avgRating = (sum / feedbacksWithAvgRating.length)
                } else {
                    avgRating = 0
                }

                // console.log(avgRating, viewUser.id)
                // Update coach with that average rating
                updateCoachWithAvgRating(avgRating, viewUser.id)
                // Refetch users to update avgRating.
                fetchUsers()
            }
        }
    }, [coachFeedbacks, viewUser])


    const updateCenterWithAvgRating = async (avgRating, centerId) => {

        await updateDoc(doc(db, 'education-centers', centerId), { avgRating })
    }

    const updateCoachWithAvgRating = async (avgRating, coachId) => {

        await updateDoc(doc(db, 'users', coachId), { avgRating })
    }

    const fetchEducationCenters = async () => {

        const docs = await getFirebaseDocs(await getDocs(query(collection(db, `education-centers`))))
        setEducationCentersList(docs)
        const trialDocs = await getFirebaseDocs(await getDocs(query(collection(db, `education-trials`))))
        setEducationCentersTrialsList(trialDocs.map((t => ({ ...t, isOld: true }))))
    }

    const fetchInvoicesPending = async () => {
        const documentData = await (await getDoc(doc(db, 'xero-invoices-pending-centers', 'xero-invoices-pending-centers'))).data()
        if (documentData && documentData.records) {
            setInvoicesPending(documentData.records)
        }
    }

    const fetchEventsAttendance = async () => {

        const docsTotal = await getFirebaseDocs(await getDocs(query(collection(db, `events`), where('start', '>=', startOfYear(statsDate).toISOString()), where('end', '<=', endOfYear(statsDate).toISOString()))))
        const docsAtt = await getFirebaseDocs(await getDocs(query(collection(db, `events`), where('start', '>=', startOfYear(statsDate).toISOString()), where('end', '<=', endOfYear(statsDate).toISOString()), where('sessionStatus', '==', 'Attended'))))
        const docsMiss = await getFirebaseDocs(await getDocs(query(collection(db, `events`), where('start', '>=', startOfYear(statsDate).toISOString()), where('end', '<=', endOfYear(statsDate).toISOString()), where('sessionStatus', '==', 'Missed'))))
        const docsResc = await getFirebaseDocs(await getDocs(query(collection(db, `events`), where('start', '>=', startOfYear(statsDate).toISOString()), where('end', '<=', endOfYear(statsDate).toISOString()), where('sessionStatus', '==', 'Rescheduled'))))

        setEventsAttendance({
            Total: docsTotal,
            Attended: docsAtt,
            Rescheduled: docsResc,
            Missed: docsMiss
        })
    }

    const getColorUser = (userId) => {
        const matchingUser = returnedUsers.find(r => r.id === userId)
        if (matchingUser) {
            return matchingUser.color || 'blue'
        }
        return 'blue'
    }

    const getUserName = userId => {
        const matchingUser = returnedUsers.find(r => r.id === userId)
        if (matchingUser) {
            return matchingUser.firstName + ' ' + matchingUser.lastName
        }
        return 'Deleted user'
    }


    const convertTimeToMelbourneLocal = async (r, property) => {
        // if (r.groupId && !r.individuallyEdited) {
        //     // Check if original event created in same timezone of current event.
        //     // console.log(r.groupId)
        //     const parentDoc = await (await getDoc(doc(collection(db, `events`), r.groupId))).data()
        //     if (parentDoc) {
        //         const parentOffset = new Date(parentDoc[property]).getTimezoneOffset()
        //         const childOffset = new Date(r[property]).getTimezoneOffset()
        //         if (parentOffset !== childOffset) {
        //             return addMinutes(new Date(r[property]), childOffset - parentOffset)
        //         }
        //     }
        //     // return new Date(r[property])
        // }
        // return new Date(r[property])
        return toZonedTime(new Date(r[property]), 'Australia/Melbourne')
    }

    const fetchEvents = async () => {

        const startDateMonth = startOfMonth(calendarDate)
        const endDateMonth = endOfMonth(calendarDate)

        const docs = await getFirebaseDocs(await getDocs(query(collection(db, `events`), where('start', '>=', startDateMonth.toISOString()), where('end', '<=', endDateMonth.toISOString()))))

        setEvents(await Promise.all((docs.map(async r => ({
            ...r,
            start: await convertTimeToMelbourneLocal(r, 'start'),
            end: await convertTimeToMelbourneLocal(r, 'end'), event_id: r.id,
            title: `${format(await convertTimeToMelbourneLocal(r, 'start'), 'hh:mm a')}: ${r.title}`,
            color: r.color
        })))))

    }

    const getUserInfo = async (uid) => {
        // console.log('uid', uid)
        setLoading(true)
        const userData = await (await getDoc(doc(db, 'users', uid))).data()
        // console.log('userData', userData)
        if (!userData) {
            toast.error('User doesn\'t exist. Taking you to login page.')
            setLoading(false)
            setTimeout(async () => {
                await signOutUser()
                navigate('/login')
            }, 3000)
            return
        }
        dispatch(setUser({ ...userData, id: uid }))
        // fetchUsers()
        setLoading(false)

    }

    const signOutUser = async () => {
        await auth.signOut();
    }

    const matchesLocationFilters = (row) => {
        if (!row) {
            return false
        }
        if (cityFilter !== 'All' && row.city !== cityFilter) {
            return false
        }
        if (cityFilter !== 'All' && townFilter !== 'All' && row.town !== townFilter) {
            return false
        }
        return true
    }

    const getCenterById = (centerId) => educationCentersList.find(cent => cent.id === centerId)

    const fetchUsers = async () => {
        const docs = await getFirebaseDocs(await getDocs(query(collection(db, `users`))))
        setReturnedUsers(docs.filter(r => r.role === 'coach'))
        setFeedbackSubmitters(docs
            .filter(r => r.role === 'staff' || r.role === 'admin')
            .map(r => ({ label: r.firstName || r.email, value: r.id })))

        const docEquipment = await (await getDoc(doc(db, 'equipments-in-center', 'center'))).data()

        setCenterEquipments({ id: 'center', ...docEquipment })
    }

    const calendarRef = useRef()

    const handleDelete = async (docId) => {

        // Check if groupId exists.

        const data = await (await getDoc(doc(db, 'events', docId))).data()

        if (data.groupId) {

            setShowDeletePopup(docId)

        } else {
            await deleteDoc(doc(db, 'events', docId))

            setTimeout(() => {
                fetchEvents()
            }, 1000)
        }

    }
    const updateDropdownValue = (val) => val ? ({ label: val, value: val }) : ''
    const updateTownDropdownValue = (val) => val ? ({ label: val, value: val }) : ''

    const CustomEditor = ({ event }) => {

        const [startDate, setStartDate] = useState(new Date())
        const [endDate, setEndDate] = useState(new Date())
        const [repeatUntilDate, setRepeatUntilDate] = useState(addDays(new Date(), 14))

        const [title, setTitle] = useState('')
        const [description, setDescription] = useState('')
        const [type, setType] = useState('')
        const [activity, setActivity] = useState('')
        const [fastTrackType, setFastTrackType] = useState('')
        const [originalFastTrackType, setOriginalFastTrackType] = useState('')

        const [originalWeekActivity, setOriginalWeekActivity] = useState('')
        const [originalActivity, setOriginalActivity] = useState('')
        // const [feedback, setFeedback] = useState('')
        const [educationCenter, setEducationCenter] = useState('')
        const [sessionStatus, setSessionStatus] = useState('')
        const [sessionStatusOriginal, setSessionStatusOriginal] = useState('')
        const [repeats, setRepeats] = useState('')
        const [coaches, setCoaches] = useState([])
        const [missedCoaches, setMissedCoaches] = useState([]) // Coach originally assigned but didnt attend. Filled when taken over by another coach.

        const [sendMessageToCoach, setSendMessageToCoach] = useState(false)

        const [updateFutureEvents, setUpdateFutureEvents] = useState(false)
        const [additionalMessage, setAdditionalMessage] = useState('')
        const [groupId, setGroupId] = useState('')
        const [extendSessionDates, setExtendSessionDates] = useState('')

        const eventId = event.state.event_id.value


        useEffect(() => {
            setStartDate(new Date(event.state.start.value));
            setEndDate(new Date(event.state.end.value));
            setTitle(event.state.title.value ? event.state.title.value.split(':')[0] : '')

            setUpdateFutureEvents(false)
            const matchingEvent = events.find(r => r.event_id === eventId)
            if (matchingEvent) {
                setMissedCoaches(matchingEvent.missedCoaches || [])
                setCoaches(matchingEvent.coaches || [])
                const matchCenter = educationCentersList.find(r => r.id === matchingEvent.educationCenter)
                setEducationCenter({ label: matchCenter.name, value: matchingEvent.educationCenter })
                setDescription(matchingEvent.description || '')
                setRepeats(updateDropdownValue(matchingEvent.repeats))
                setType(updateDropdownValue(matchingEvent.type))
                setActivity(updateDropdownValue(matchingEvent.activity))
                setFastTrackType(updateDropdownValue(matchingEvent.fastTrackType))
                setOriginalFastTrackType(matchingEvent.fastTrackType)
                setOriginalWeekActivity(matchingEvent.weekActivity)
                setOriginalActivity(matchingEvent.activity)
                if (matchingEvent.sessionStatus && matchingEvent.sessionStatus.value) {
                    // Whole obj inserted
                    setSessionStatus(matchingEvent.sessionStatus)
                    setSessionStatusOriginal(matchingEvent.sessionStatus)
                } else {
                    setSessionStatus(updateDropdownValue(matchingEvent.sessionStatus))
                    setSessionStatusOriginal(updateDropdownValue(matchingEvent.sessionStatus))
                }
                // setFeedback(matchingEvent.feedback || '')
                setRepeatUntilDate(matchingEvent.repeatUntilDate ? new Date(matchingEvent.repeatUntilDate) : new Date())
                setGroupId(matchingEvent.groupId)
            } else {
                setCoaches([])
                setMissedCoaches([])
                setEducationCenter('')
                setType('')
                setOriginalWeekActivity('')
                setOriginalActivity('')
                setActivity('')
                setFastTrackType('')
                setOriginalFastTrackType('')
                setSessionStatus('')
                setSessionStatusOriginal('')
                setDescription('')
                setRepeats({ label: 'Off', value: 'Off' })
                setRepeatUntilDate(addDays(new Date(), 14))
                setGroupId('')
            }
        }, [])


        const handleSave = async () => {

            const startDateMelbourne = fromZonedTime(startDate, 'Australia/Melbourne')
            const endDateMelbourne = fromZonedTime(endDate, 'Australia/Melbourne')
            let currentOccurrenceIndex = 0

            if (eventId && groupId) {
                const groupedDocs = await getFirebaseDocs(await getDocs(query(collection(db, `events`), where('groupId', '==', groupId))))
                const sortedGroupedDocs = groupedDocs.sort((a, b) => isAfter(new Date(a.start), new Date(b.start)) ? 1 : -1)
                const foundIndex = sortedGroupedDocs.findIndex(row => row.id === eventId)
                currentOccurrenceIndex = foundIndex >= 0 ? foundIndex : 0
            }

            setLoading(true)
            // Compute activity week from activity
            let resolvedWeekActivity =
                ['Trial Music',
                    'Trial Yoga',
                    'Trial Gymnastics',
                    'Trial Sports Pack 1',
                    'Trial Sports Pack 2'].includes(activity.value) ? activity.value :
                    resolveWeekActivity(startDateMelbourne.toISOString(), activity.value, currentOccurrenceIndex, fastTrackType)
            let weekActivity = typeof resolvedWeekActivity === 'string' ? resolvedWeekActivity : resolvedWeekActivity.weekActivity

            if (!weekActivity) {
                weekActivity = ''
            }

            if (eventId && groupId !== eventId) {
                weekActivity = originalWeekActivity
            }

            let fastTrackTypePayload = typeof resolvedWeekActivity === 'string' ? (fastTrackType ? fastTrackType.value : '') : resolvedWeekActivity.fastTrackType
            if (fastTrackTypePayload) {
                // Check if fast track type belongs to activity. Might not belong if activity has been changed after choosing fast track.
                const activityVal = activity.value

                if (activityVal === 'Music' && gymFTOptions.includes(fastTrackTypePayload)) {
                    fastTrackTypePayload = ''
                } else if (activityVal === 'Gymnastics' && musicFTOptions.includes(fastTrackTypePayload)) {
                    fastTrackTypePayload = ''
                }

            }

            const payload = {
                start: startDateMelbourne.toISOString(),
                end: endDateMelbourne.toISOString(),
                title: `${type.value === 'Ongoing' ? '' : `${type.value} `}${educationCentersList.find(r => r.id === educationCenter.value).name}`,
                type: type.value,
                weekActivity,
                activity: activity.value || '',
                fastTrackType: fastTrackTypePayload,
                educationCenter: educationCenter.value,
                description,
                coaches,
                sessionStatus: sessionStatus ? sessionStatus.value : '',
                repeats: repeats.value,
                color: getColorUser(coaches[0].value),
                // feedback,
                repeatUntilDate: repeats.value !== 'Off' && repeatUntilDate.toISOString()
            }


            if (sendMessageToCoach) {

                const coachesInfo = returnedUsers.filter(r => coaches.map(x => x.value).includes(r.id)).map(({ firstName, lastName, phone }) => ({ firstName, lastName, phone })).filter(r => r.phone)

                if (coachesInfo.length !== coaches.length) {
                    toast.error('One or more coaches dont have a phone number. Sending to others (if any).')
                } else {
                    toast.success('Messages will be sent to coaches.')
                }

                await setDoc(doc(db, 'notify-coach', eventId), { ...payload, additionalMessage, startString: format(startDateMelbourne, 'dd/MMM/yyyy HH:mm a'), endString: format(endDateMelbourne, 'dd/MMM/yyyy HH:mm a'), centerName: educationCentersList.find(r => r.id === educationCenter.value).name, coachesInfo })
                setSendMessageToCoach(false)
                setAdditionalMessage('')
            }

            let newEventId = eventId
            // Missed coaches only added to first event.

            if (eventId) {
                let individuallyEditedObj = {}, activityPayload = {}
                if (event.state.start.value !== startDateMelbourne.toISOString()) {
                    individuallyEditedObj = { individuallyEdited: true }
                }

                // if (updateFutureEvents && (activity.value !== originalActivity || (fastTrackType && fastTrackType.value && fastTrackType.value !== originalFastTrackType))) {
                if (updateFutureEvents) {
                    // Updated activity, so update week activity, activity for current event.

                    resolvedWeekActivity =
                        ['Trial Music',
                            'Trial Yoga',
                            'Trial Gymnastics',
                            'Trial Sports Pack 1',
                            'Trial Sports Pack 2'].includes(activity.value) ? activity.value :
                            resolveWeekActivity(startDateMelbourne.toISOString(), activity.value, currentOccurrenceIndex, fastTrackType)
                    weekActivity = typeof resolvedWeekActivity === 'string' ? resolvedWeekActivity : resolvedWeekActivity.weekActivity

                    activityPayload = {
                        weekActivity,
                        activity: activity.value || '',
                        fastTrackType: typeof resolvedWeekActivity === 'string' ? '' : resolvedWeekActivity.fastTrackType,
                    }
                }
                await setDoc(doc(db, 'events', eventId), { ...payload, ...individuallyEditedObj, ...activityPayload, groupId: groupId || '', missedCoaches })
            } else {
                newEventId = await addDoc(collection(db, 'events'), { ...payload, missedCoaches })
                // console.log('newEventId', newEventId.id)
                newEventId = newEventId.id
            }

            if (groupId && repeats.value === 'Off') {
                // Situation where original had repeats, now updating to remove repeats.


                // Clear old repeats...
                const docs = await getFirebaseDocs(await getDocs(query(collection(db, `events`), where('groupId', '==', groupId))))

                for (let row of docs) {
                    if (row.id !== groupId) {
                        // if not the first/original record delete it , as original record already updated.
                        await deleteDoc(doc(db, 'events', row.id))
                    } else {
                        await updateDoc(doc(db, 'events', row.id), { groupId: '' })
                    }
                }

            }

            if (eventId && ((!sessionStatusOriginal && sessionStatus) || (sessionStatusOriginal && sessionStatusOriginal.value !== sessionStatus.value))) {
                // Updating session status, so skip duplicating children and other checks and abort.
                toast.success('Calendar event updated.')


                setTimeout(() => {
                    fetchEvents()
                }, 1000)
                setLoading(false)
                event.close()

                return
            }

            if (groupId && groupId !== eventId && updateFutureEvents) {
                // Update coaches and timeslots , description for upcoming classes from here.

                const docsDb = await getFirebaseDocs(await getDocs(query(collection(db, `events`), where('groupId', '==', groupId))))

                const docs = docsDb.sort((a, b) => isAfter(new Date(a.start), new Date(b.start)) ? 1 : -1)

                // const proceed = window.prompt(`Going to update ${docs.filter(row => isAfter(new Date(row.start), startDateMelbourne)).length}. Proceed?`, 'Yes')
                // if (proceed !== 'Yes') {
                //     toast.error('Update cancelled')
                //     setLoading(false)
                //     event.close()
                //     return
                // }

                // Get difference in hours to updated start, end time and apply difference to all upcoming ones.
                const originalStartDate = new Date(event.state.start.value)
                const originalEndDate = new Date(event.state.end.value)

                // const startDifference = differenceInMinutes(startDate, originalStartDate)
                // const endDifference = differenceInMinutes(endDate, originalEndDate)

                for (let [rowIndex, row] of docs.entries()) {

                    let activityPayload = {

                    }


                    if (row.id !== eventId && isAfter(new Date(row.start), startDateMelbourne)) {
                        // Not updating current event (as already updated) and only future events.


                        const payloadUpdateDates = {
                            start: updateHoursAndMinutesAndDay(new Date(row.start), startDateMelbourne, differenceInDays(startDateMelbourne, originalStartDate)).toISOString(),
                            end: updateHoursAndMinutesAndDay(new Date(row.end), endDateMelbourne, differenceInDays(endDateMelbourne, originalEndDate)).toISOString(),
                        }

                        // if (activity.value !== originalActivity || (fastTrackType && fastTrackType.value && fastTrackType.value !== originalFastTrackType)) {
                        if (true) {
                            const resolvedWeekActivityForEach = ['Trial Music',
                                'Trial Yoga',
                                'Trial Gymnastics',
                                'Trial Sports Pack 1',
                                'Trial Sports Pack 2'].includes(activity.value) ? activity.value : resolveWeekActivity(payloadUpdateDates.start, activity.value, rowIndex, fastTrackType)
                            const weekActivityForEach = typeof resolvedWeekActivityForEach === 'string' ? resolvedWeekActivityForEach : resolvedWeekActivityForEach.weekActivity
                            activityPayload = {
                                activity: activity.value,
                                weekActivity: weekActivityForEach || '',
                                fastTrackType: typeof resolvedWeekActivityForEach === 'string' ? '' : resolvedWeekActivityForEach.fastTrackType,
                            }
                        }

                        await updateDoc(doc(db, 'events', row.id), { coaches, color: getColorUser(coaches[0].value), description, ...payloadUpdateDates, ...activityPayload })
                    }

                }
            }

            if (repeats.value !== 'Off' && !(groupId && groupId !== eventId)) {

                let startDates = [], endDates = []
                // update old creations / delete them?
                if (repeats.value === 'Weekly') {


                    console.log('start dates', startDates)
                    console.log('end dates', endDates)

                    startDates = new RRule({
                        interval: 1,
                        freq: RRule.WEEKLY,
                        dtstart: startDateMelbourne,
                        until: repeatUntilDate
                    }).all()
                    endDates = new RRule({
                        interval: 1,
                        freq: RRule.WEEKLY,
                        dtstart: endDateMelbourne,
                        until: repeatUntilDate
                    }).all()
                } else if (repeats.value === 'Bi-Weekly') {
                    startDates = new RRule({
                        interval: 2,
                        freq: RRule.WEEKLY,
                        dtstart: startDateMelbourne,
                        until: repeatUntilDate
                    }).all()
                    endDates = new RRule({
                        interval: 2,
                        freq: RRule.WEEKLY,
                        dtstart: endDateMelbourne,
                        until: repeatUntilDate
                    }).all()
                } else if (repeats.value === 'Tri-Weekly') {
                    startDates = new RRule({
                        interval: 3,
                        freq: RRule.WEEKLY,
                        dtstart: startDateMelbourne,
                        until: repeatUntilDate
                    }).all()
                    endDates = new RRule({
                        interval: 3,
                        freq: RRule.WEEKLY,
                        dtstart: endDateMelbourne,
                        until: repeatUntilDate
                    }).all()
                } else if (repeats.value === 'Quad-Weekly') {
                    startDates = new RRule({
                        interval: 4,
                        freq: RRule.WEEKLY,
                        dtstart: startDateMelbourne,
                        until: repeatUntilDate
                    }).all()
                    endDates = new RRule({
                        interval: 4,
                        freq: RRule.WEEKLY,
                        dtstart: endDateMelbourne,
                        until: repeatUntilDate
                    }).all()
                } else if (repeats.value === 'Monthly') {

                    const weekDay = format(subDays(startDateMelbourne, 1), 'EEEEEE').toUpperCase()
                    console.log('weekDay', weekDay)

                    startDates = new RRule({
                        interval: 1,
                        freq: RRule.MONTHLY,
                        byweekday: RRule[[weekDay]].nth(getWeekOfMonth(startDateMelbourne) - 1),
                        dtstart: startDateMelbourne,
                        until: repeatUntilDate
                    }).all()

                    endDates = new RRule({
                        interval: 1,
                        freq: RRule.MONTHLY,
                        byweekday: RRule[[weekDay]].nth(getWeekOfMonth(startDateMelbourne) - 1),
                        dtstart: endDateMelbourne,
                        until: repeatUntilDate
                    }).all()
                }

                console.log('start dates', startDates)
                console.log('end dates', endDates)

                let existingSessionsCount = 0
                if (eventId) {
                    // Update or original record with repeats, so proceed to delete old repeats

                    // Clear old repeats
                    const docs = await getFirebaseDocs(await getDocs(query(collection(db, `events`), where('groupId', '==', eventId))))

                    existingSessionsCount = docs.length

                    if (!extendSessionDates) {
                        for (let row of docs) {
                            if (row.id !== eventId) {
                                // if not the first/original record delete it , as original record already updated.
                                await deleteDoc(doc(db, 'events', row.id))
                            }
                        }
                    } else {
                        // Update to the new repeat until date as extending sessions.
                        for (let row of docs) {
                            if (row.id !== eventId) {
                                // if not the first/original record delete it , as original record already updated.
                                await updateDoc(doc(db, 'events', row.id), {
                                    repeatUntilDate: repeatUntilDate.toISOString()
                                })
                            }
                        }
                    }
                }

                // create copies as old copies deleted OR is fresh creation.
                for (let index = 1; index < startDates.length; index++) {
                    // Skipping first index as thats already created
                    // For type "New Center" repeats, toggling child types to "Ongoing".

                    const resolvedWeekActivityForRepeat = ['Trial Music',
                        'Trial Yoga',
                        'Trial Gymnastics',
                        'Trial Sports Pack 1',
                        'Trial Sports Pack 2'].includes(activity.value) ? activity.value : resolveWeekActivity(startDates[index].toISOString(), activity.value, index, fastTrackType)
                    let weekActivity = typeof resolvedWeekActivityForRepeat === 'string' ? resolvedWeekActivityForRepeat : resolvedWeekActivityForRepeat.weekActivity
                    if (!weekActivity) {
                        weekActivity = ''
                    }
                    if (!extendSessionDates || (extendSessionDates && index >= existingSessionsCount)) {
                        await addDoc(collection(db, 'events'), {
                            ...payload,
                            sessionStatus: '',
                            weekActivity,
                            fastTrackType: typeof resolvedWeekActivityForRepeat === 'string' ? '' : resolvedWeekActivityForRepeat.fastTrackType,
                            start: startDates[index].toISOString(),
                            end: endDates[index].toISOString(),
                            groupId: newEventId,
                            type: payload.type === 'New Center' ? 'Ongoing' : payload.type
                        })
                    }
                }


                // Update original to have same groupId as others.
                await updateDoc(doc(db, 'events', newEventId), { groupId: newEventId })
            }

            if (eventId) {
                toast.success('Calendar event updated.')
            } else {
                toast.success('Calendar event created.')
            }

            setTimeout(() => {
                fetchEvents()
            }, 1000)
            setLoading(false)
            event.close()
        }



        const renderActivityDropdown = () => <div style={{ width: '200px' }}>
            <Dropdown label={'Activity'} options={[
                'Sports One', 'Sports Two', 'Music', 'Gymnastics', 'Yoga', 'Sensory Fusion',
                'Offer Sports 1', 'Offer Sports 2', 'Offer Music', 'Offer Gymnastics', 'Offer Yoga', 'Offer Sensory',
                'Trial Music',
                'Trial Yoga',
                'Trial Gymnastics',
                'Trial Sports Pack 1',
                'Trial Sports Pack 2'

            ].map(r => ({ label: r, value: r }))} errorFields={[]} value={activity} setValue={setActivity} />
            {activity && (['Music'].includes(activity.value)) && <>
                <Dropdown label={'Fast Track Music'} options={musicFTOptions.map(r => ({ label: r, value: r }))} errorFields={[]} value={fastTrackType} setValue={setFastTrackType} />
            </>}

            {activity && (['Gymnastics'].includes(activity.value)) && <>
                <Dropdown label={'Fast Track Gym'} options={gymFTOptions.map(r => ({ label: r, value: r }))} errorFields={[]} value={fastTrackType} setValue={setFastTrackType} />
            </>}
        </div>

        return <div style={{ padding: '40px', height: '500px', overflowY: 'auto' }}>
            <div style={{ display: 'flex', gap: '10px' }}>
                {/* <Input bold label={'Title'} errors={[]} value={title} setValue={setTitle} /> */}
                <div style={{ width: '230px', marginTop: '10px' }}>
                    <Dropdown label={'Education Center'} options={educationCentersList.map(r => ({ label: r.name, value: r.id }))} errorFields={[]} value={educationCenter} setValue={setEducationCenter} />
                </div>
                <div style={{ width: '230px', marginTop: '10px' }}>
                    <MyCalendar label={'Start Date'} startDate={startDate} setStartDate={setStartDate} />
                </div>
                <div style={{ width: '230px', marginTop: '10px' }}>
                    <MyCalendar label={'End Date'} startDate={endDate} setStartDate={setEndDate} />
                </div>
            </div>



            {!(groupId && groupId !== eventId) && <div style={{ display: 'flex', gap: '10px' }}>
                <div style={{ width: '200px' }}>
                    <Dropdown label={'Repeats'} options={['Off', 'Weekly', 'Bi-Weekly', 'Tri-Weekly', 'Quad-Weekly', 'Monthly'].map(r => ({ label: r, value: r }))} errorFields={[]} value={repeats} setValue={setRepeats} />
                </div>
                {(repeats.value && repeats.value !== 'Off') && <MyCalendar label={'Repeat Until'} startDate={repeatUntilDate} setStartDate={setRepeatUntilDate} />}
                <div style={{ width: '200px' }}>
                    <Dropdown label={'Type'} options={['Trial', 'New Center', 'Offer', 'One Off', 'Ongoing', 'Short Bookings'].map(r => ({ label: r, value: r }))} errorFields={[]} value={type} setValue={setType} />
                </div>
                {renderActivityDropdown()}

            </div>}

            <div style={{ display: 'flex' }}>
                <div style={{ width: '300px', marginRight: '20px' }}>
                    <Dropdown isMulti label={'Coaches'} options={returnedUsers.map(r => ({ label: r.firstName + ' ' + r.lastName, value: r.id }))} errorFields={[]} value={coaches} setValue={setCoaches} />
                </div>


                <div style={{ width: '230px' }}>
                    <Dropdown label={'Session Status'} options={['Attended', 'Rescheduled', 'Missed'].map(r => ({ label: r, value: r }))} errorFields={[]} value={sessionStatus} setValue={setSessionStatus} />
                </div>
            </div>
            {
                sessionStatus && sessionStatus.value === 'Rescheduled' && <div style={{ width: '300px', marginRight: '20px' }}>
                    <Dropdown isMulti label={'Missed By'} options={returnedUsers.map(r => ({ label: r.firstName + ' ' + r.lastName, value: r.id }))} errorFields={[]} value={missedCoaches} setValue={setMissedCoaches} />
                </div>}


            {eventId && <div style={{ marginTop: '10px', marginLeft: '-10px' }}>
                <Checkbox errors={[]} label={'Send Message to Coach'} value={sendMessageToCoach} setValue={() => { setSendMessageToCoach(!sendMessageToCoach) }} />
                {sendMessageToCoach && <>
                    <label style={{ display: 'flex', marginTop: '15px', fontSize: '15px', color: '#000', fontWeight: '700' }}>Additional Message?</label>
                    <textarea value={additionalMessage} style={{ height: '100px' }} onChange={(e) => setAdditionalMessage(e.target.value)}></textarea>
                </>}
            </div>}

            {eventId && eventId !== groupId && <div style={{ marginTop: '10px', marginLeft: '-10px' }}>
                <Checkbox errors={[]} label={'Update all future events?'} value={updateFutureEvents} setValue={() => { setUpdateFutureEvents(!updateFutureEvents) }} />
            </div>}

            {eventId && eventId === groupId && <div style={{ marginTop: '10px', marginLeft: '-10px' }}>
                <Checkbox errors={[]} label={'Extend Session Dates'} value={extendSessionDates} setValue={() => { setExtendSessionDates(!extendSessionDates) }} />
            </div>}


            {updateFutureEvents && renderActivityDropdown()}


            <label style={{ display: 'flex', marginTop: '15px', fontSize: '15px', color: '#000', fontWeight: '700' }}>Description</label>
            <textarea value={description} style={{ height: '100px' }} onChange={e => setDescription(e.target.value)}></textarea>

            {/* <label style={{ display: 'flex', marginTop: '15px', fontSize: '15px', color: '#000', fontWeight: '700' }}>Feedback</label>
            <textarea value={feedback} style={{ height: '100px' }} onChange={e => setFeedback(e.target.value)}></textarea> */}

            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                <button disabled={loading || !repeats || !type || !educationCenter || coaches.length === 0 || isAfter(startDate, endDate)} onClick={handleSave}>{event.state.event_id.value ? 'Update' : 'Save'}</button>
                <button className="textButton" style={{ marginTop: '25px' }} onClick={() => event.close()}>Cancel</button>
            </div>
        </div>

    }


    const ViewerComponent = ({ event }) => {

        const [parentStartDate, setParentStartDate] = useState()

        useEffect(() => {
            getParentDate()
        }, [event])

        const getParentDate = async () => {
            if (event.groupId && event.repeats !== 'Off') {
                const docData = (await getDoc(doc(db, `events`, event.groupId))).data()
                if (docData && docData.start) {
                    setParentStartDate(format(new Date(docData.start), 'dd MMM yyyy hh:mm a'))
                    return
                }
            }
            setParentStartDate('')
        }

        return <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
            <label style={{ fontSize: '14px', color: 'grey' }}>{format(event.start, 'hh:mm a')}-{format(event.end, 'hh:mm a')}</label>
            <label style={{ fontSize: '14px', color: 'grey' }}>Coaches: {event.coaches.map(r => r.label).join(', ')}</label>
            <label style={{ fontSize: '14px', color: 'grey' }}>Repeats: {event.repeats}</label>
            {event.repeats !== 'Off' && <label style={{ fontSize: '14px', color: 'grey' }}>Is Parent of Repeats: {event.groupId === event.id ? 'Yes' : 'No'}</label>}
            {event.repeats !== 'Off' && <label style={{ fontSize: '14px', color: 'grey' }}>Parent Start Date: {parentStartDate}</label>}
            {event.repeats !== 'Off' && <label style={{ fontSize: '14px', color: 'grey' }}>Week Index: {getWeekOfMonth(parentStartDate)}</label>}
            {event.repeats !== 'Off' && <label style={{ fontSize: '14px', color: 'grey' }}>Week Activity:{event.weekActivity}</label>}
            {event.id && <label style={{ fontSize: '14px', color: 'grey' }}>Id (internal): {event.id}</label>}
        </div>
    }


    const handleDeleteEducationCenter = async () => {
        if (!confirmDeleteEducationCenter) {
            setConfirmDeleteEducationCenter(true)
        } else {
            await deleteDoc(doc(db, 'education-centers', addEducationCenterId))
            toast.success('Education center deleted')
            setConfirmDeleteEducationCenter(false)
            fetchEducationCenters()
            setShowAddEducationCenter(false)
        }
    }
    const handleAddEducationCenter = async () => {
        // updateDoc(doc(db, 'settings', 'education-centers'), {
        //     centers: [...educationCentersList, addEducationCenterText]
        // })

        const nowIso = new Date().toISOString()
        const nextCenterStatus = addEducationCenterStatus ? addEducationCenterStatus.value : ''
        const previousCenterStatus = addEducationCenterStatusPrevious ? addEducationCenterStatusPrevious.value : ''
        const trimmedClosedReason = (addEducationCenterClosedDesc || '').trim()
        const existingCenter = addEducationCenterId ? educationCentersList.find(row => row.id === addEducationCenterId) : null

        if (nextCenterStatus === 'Offer Closed' && !trimmedClosedReason) {
            toast.error('Offer closed reason is required.')
            return
        }

        let programCodePayload = normalizeCenterProgramCode(addEducationCenterProgramCode)
        if (!isValidCenterProgramCode(programCodePayload)) {
            const existingCodes = new Set(educationCentersList.filter(row => row.id !== addEducationCenterId).map(row => normalizeCenterProgramCode(row.programCode)).filter(isValidCenterProgramCode))
            programCodePayload = await getUniqueCenterProgramCode(existingCodes)
        }

        let statusHistoryPayload = Array.isArray(existingCenter?.statusHistory) ? [...existingCenter.statusHistory] : []
        if (!addEducationCenterId && nextCenterStatus) {
            statusHistoryPayload = [{ fromStatus: '', toStatus: nextCenterStatus, changedAt: nowIso }]
        } else if (addEducationCenterId && nextCenterStatus && previousCenterStatus !== nextCenterStatus) {
            statusHistoryPayload = [...statusHistoryPayload, { fromStatus: previousCenterStatus || '', toStatus: nextCenterStatus, changedAt: nowIso }]
        }

        const payload = {
            name: addEducationCenterText,
            invoiceName: addEducationCenterInvoiceName,
            studentCount: addEducationCenterStudentCount,
            programCode: programCodePayload,
            address: addEducationCenterAddress,
            addressGeo: addEducationCenterCoords,
            city: addEducationCenterCity,
            town: addEducationCenterTown,
            phone: addEducationCenterPhone,
            email: addEducationCenterEmail,
            pointsType: addEducationCenterPointsType ? addEducationCenterPointsType.value : '',
            points: addEducationCenterPoints,
            directorName: addEducationCenterDirectorName,
            managedBy: addEducationCenterManagedBy ? addEducationCenterManagedBy.value : '',
            staffDeliverSessions: addEducationCenterStaffDeliverSessions,
            soldBy: addEducationCenterSoldBy ? addEducationCenterSoldBy.value : '',
            mikeyAppPoster: addEducationCenterMikeyAppPoster ? addEducationCenterMikeyAppPoster.value : 'No',
            startDate: addEducationCenterStartDate ? addEducationCenterStartDate.toISOString() : '',
            closedDate: addEducationCenterClosedDate ? addEducationCenterClosedDate.toISOString() : '',
            closedDesc: trimmedClosedReason,
            closedType: addEducationCenterClosedType ? addEducationCenterClosedType.value : '',
            notes: addEducationCenterNotes,
            status: nextCenterStatus,
            fourSessionNotice: addEducationCenterFourSessionNotice ? addEducationCenterFourSessionNotice.value : 'No',
            fourSessionNoticeReason: addEducationCenterFourSessionNotice && addEducationCenterFourSessionNotice.value === 'Yes' ? addEducationCenterFourSessionNoticeReason : '',
            categories: addEducationCenterCategories.map(r => r.value),
            coaches: addEducationCenterCoaches,
            statusHistory: statusHistoryPayload,
            created: existingCenter?.created || nowIso,
        }

        if (addEducationCenterId) {

            // Check if trial being moved somewhere else.
            if ((addEducationCenterStatusPrevious && addEducationCenterStatusPrevious.value === 'Trial') && (addEducationCenterStatus && addEducationCenterStatus.value !== 'Trial')) {
                await addDoc(collection(db, 'education-trials'), { ...payload, trialMoveDate: new Date().toISOString(), trialReason: addEducationCenterTrialReason })
            }

            await updateDoc(doc(db, 'education-centers', addEducationCenterId), payload)
            await syncParentProgramAccessForCenter({ centerId: addEducationCenterId, centerName: payload.name, centerStatus: payload.status, centerProgramCode: payload.programCode })
            toast.success('Education center updated.')
        } else {
            await addDoc(collection(db, 'education-centers'), payload)
            toast.success('Education center created.')
        }

        fetchEducationCenters()
        setShowAddEducationCenter(false)

        setConfirmDeleteEducationCenter(false)
    }


    const handleUpdateUserInfo = async () => {

        console.log('addUserStatus', addUserStatus.value)
        const nextStatus = addUserStatus.value
        const trimmedInactiveReason = addUserInactiveReason.trim()
        const isMovingToInactive = addUserStatusPrevious !== 'Inactive' && nextStatus === 'Inactive'

        if (nextStatus === 'Inactive' && (!addUserInactiveDate || !trimmedInactiveReason)) {
            toast.error('Inactive date and reason are required.')
            return
        }

        const payload = {
            address: addUserAddress,
            receivedUniform: addUserReceivedUniform ? addUserReceivedUniform.value : '',
            addressGeo: addUserCoords,
            city: addUserCity,
            town: addUserTown,
            phone: normalizeAustralianPhone(addUserPhone),
            dateOfBirth: addUserDateOfBirth ? addUserDateOfBirth.toISOString() : '',
            topSize: addUserTopSize,
            bankName: addUserBankName,
            bsb: addUserBsb,
            accountNumber: addUserAccountNumber,
            bankAccount: '',
            tfn: addUserTfn,
            superNumberAndProvider: addUserSuperNumberAndProvider,
            claimTaxFreeThreshold: addUserClaimTaxFreeThreshold ? addUserClaimTaxFreeThreshold.value : '',
            color: addUserColor,
            email: addUserEmail,
            startDate: addUserStartDate ? addUserStartDate.toISOString() : '',
            endDate: addUserEndDate ? addUserEndDate.toISOString() : '',
            aboutMe: addUserAboutMe || '',
            profilePic: addUserProfilePic || '',
            notes: addUserNotes,
            categories: addUserCategories.map(r => r.value),
            speciality: addUserSpeciality ? addUserSpeciality.value : '',
            status: nextStatus,
            inactiveDate: nextStatus === 'Inactive' && addUserInactiveDate ? addUserInactiveDate.toISOString() : '',
            inactiveReason: nextStatus === 'Inactive' ? trimmedInactiveReason : '',
            availability: addUserAvailabilities
        }

        if (isMovingToInactive) {
            payload.inactiveHistory = [
                ...(addUserInactiveHistory || []),
                {
                    date: addUserInactiveDate.toISOString(),
                    reason: trimmedInactiveReason,
                    recordedAt: new Date().toISOString(),
                }
            ]
        }
        // console.log('addUserAvailabilities update', addUserAvailabilities)
        await updateDoc(doc(db, 'users', addUserId), payload)
        if (viewUser && viewUser.id === addUserId) {
            setViewUser({ ...viewUser, ...payload })
        }

        toast.success('User information updated.')
        fetchUsers()
        setShowUpdateUserInfo(false)
    }

    const deleteThisEvent = async () => {

        await deleteDoc(doc(db, 'events', showDeletePopup))
        setShowDeletePopup(false)
        fetchEvents()
        toast.success('Event deleted.')

    }


    const deleteEventFromNow = async () => {
        const data = await (await getDoc(doc(db, 'events', showDeletePopup))).data()

        const docs = await getFirebaseDocs(await getDocs(query(collection(db, `events`), where('groupId', '==', data.groupId))))
        const docsAfter = docs.filter(r => isAfter(new Date(r.start), new Date(data.start)))

        await deleteDoc(doc(db, 'events', showDeletePopup))
        for (let row of docsAfter) {
            await deleteDoc(doc(db, 'events', row.id))
        }
        setShowDeletePopup(false)
        fetchEvents()
        toast.success('Events deleted.')
    }


    const returnCentersForUser = (userId) => {
        const matchingCenters = educationCentersList.filter(r => r.coaches.map(c => c.value).includes(userId))
        return matchingCenters.map(r => r.name).join(', ')
    }

    const calculateAvgRatingOfFeedback = () => {
        const ratingWithValues = [punctualityRating, attendanceRating, interactionRating, qualityCoachRating, qualityProgramRating].filter(r => r && r.value).map(r => r.value)

        const sum = ratingWithValues.reduce((partialSum, a) => partialSum + a, 0);

        if (ratingWithValues.length > 0) {

            return (sum / ratingWithValues.length)
        } else {
            return 0
        }
    }


    const deleteFeedback = async () => {

        await deleteDoc(doc(db, 'feedbacks', showDeleteFeedbackPopup))
        setShowDeleteFeedbackPopup(false)
        toast.success('Feedback deleted.')
        fetchFeedbacks()

    }

    const deleteGeneralFeedback = async () => {

        await deleteDoc(doc(db, 'feedbacks-general', showDeleteGeneralFeedbackPopup))
        setShowDeleteGeneralFeedbackPopup(false)
        toast.success('Feedback deleted.')
        fetchGeneralFeedbacksOfCoach()

    }

    const deleteFiveStarFeedback = async () => {

        await deleteDoc(doc(db, 'five-star-feedbacks', showDeleteFiveStarFeedbackPopup))
        setShowDeleteFiveStarFeedbackPopup(false)
        toast.success('5 Star Feedback deleted.')
        fetchFiveStarFeedbacksOfCoach()

    }

    const handleAddFeedback = async () => {

        const payload = {
            title: feedbackTitle,
            name: feedbackSubmittedBy?.label || feedbackName || '',
            submittedBy: feedbackSubmittedBy?.value || '',
            desc: feedbackDesc || '',
            coach: feedbackCoach,
            center: viewCenter.id,
            punctuality: punctualityRating ? punctualityRating.value : 0,
            attendance: attendanceRating ? attendanceRating.value : 0,
            interaction: interactionRating ? interactionRating.value : 0,
            coachQuality: qualityCoachRating ? qualityCoachRating.value : 0,
            programQuality: qualityProgramRating ? qualityProgramRating.value : 0,
            avgRating: calculateAvgRatingOfFeedback(),
            created: feedbackDate.toISOString(),
        }

        if (feedbackId) {
            // const { created, ...remaining } = payload
            await updateDoc(doc(db, 'feedbacks', feedbackId), payload)
            toast.success('Feedback updated.')

        } else {
            await addDoc(collection(db, 'feedbacks'), payload)
            toast.success('Feedback created.')
        }
        setShowAddFeedbackModal(false)

        fetchFeedbacks()
    }

    const handleAddCoachGeneralFeedback = async () => {

        const payload = {
            message: feedbackDesc,
            attachmentUrl: feedbackAttachment || '',
            coach: viewUser.id,
            created: feedbackDate.toISOString(),
        }

        if (feedbackId) {
            // const { created, ...remaining } = payload
            await updateDoc(doc(db, 'feedbacks-general', feedbackId), payload)
            toast.success('Feedback updated.')

        } else {
            await addDoc(collection(db, 'feedbacks-general'), payload)
            toast.success('Feedback created.')
        }
        setShowAddGeneralFeedbackModal(false)
        setFeedbackAttachment('')

        fetchGeneralFeedbacksOfCoach()
    }

    const handleAddFiveStarFeedback = async () => {

        const payload = {
            coachId: viewUser.id,
            rating: Number(fiveStarFeedbackRating?.value || fiveStarFeedbackRating || 0),
            comment: fiveStarFeedbackComment || '',
            created: fiveStarFeedbackDate.toISOString(),
            createdBy: userInfo.id,
            createdByName: `${userInfo.firstName || ''} ${userInfo.lastName || ''}`.trim() || userInfo.email || ''
        }

        if (fiveStarFeedbackId) {
            await updateDoc(doc(db, 'five-star-feedbacks', fiveStarFeedbackId), payload)
            toast.success('5 Star Feedback updated.')
        } else {
            await addDoc(collection(db, 'five-star-feedbacks'), payload)
            toast.success('5 Star Feedback created.')
        }

        setShowAddFiveStarFeedbackModal(false)
        fetchFiveStarFeedbacksOfCoach()
    }


    const fetchGlobalFeedbacks = async () => {
        if (isStaffUser && !userInfo?.id) {
            return
        }

        // Getting 4 weeks prior to show red /pending feedbacks
        const feedbackQuery = isStaffUser
            ? query(
                collection(db, `feedbacks`),
                and(
                    where('submittedBy', '==', userInfo.id),
                    where('created', '>=', startOfDay(subWeeks(feedbackViewDate, 4)).toISOString()),
                    where('created', '<=', endOfDay(addDays(feedbackViewDate, 6)).toISOString())
                ),
                orderBy('created', 'asc')
            )
            : query(
                collection(db, `feedbacks`),
                and(
                    // or(
                    //     where('desc', '==', ''),
                    //     where('desc', '==', null),
                    // ),
                    where('created', '>=', startOfDay(subWeeks(feedbackViewDate, 4)).toISOString()),
                    where('created', '<=', endOfDay(addDays(feedbackViewDate, 6)).toISOString())
                ),
                orderBy('created', 'asc')
            )
        const docs = await getFirebaseDocs(await getDocs(feedbackQuery));
        // Pulling all docs as some are not showing as desc is not ''.
        setGlobalFeedbacks(docs.filter(r => !r.desc))
    }

    const fetchEquipments = async () => {
        const docs = await getFirebaseDocs(await getDocs(query(collection(db, `equipments`))))
        setEquipments(docs)
    }

    const fetchHolidays = async () => {
        const docs = await getFirebaseDocs(await getDocs(query(collection(db, `holidays`))))
        setHolidays(docs)
    }


    const deleteHoliday = async (id) => {
        await deleteDoc(doc(db, 'holidays', id))
        fetchHolidays()
    }

    const handleSaveHoliday = async () => {
        if (editHoliday) {
            await updateDoc(doc(db, 'holidays', editHoliday), {
                startDay: startDay.toISOString(),
                endDay: endDay.toISOString(),
            })
            setEditHoliday('')
        }
        fetchHolidays()
    }

    const computeChurn = (startDateMonth, endDateMonth) => {

        // const centersOngoingTillPrevMonth = educationCentersList.filter(r => (r.status === 'Ongoing' && r.startDate && isAfter(startDateMonth, new Date(r.startDate))) || (r.status === 'Closed' && r.startDate && isAfter(startDateMonth, new Date(r.startDate)) && r.closedDate && isAfter(new Date(r.closedDate), endDateMonth)))
        const centersOngoingTillPrevMonth = [...educationCentersList.filter(r => activeStatsCenterStatuses.includes(r.status) && r.startDate && isAfter(endOfMonth(startDateMonth), new Date(r.startDate))), ...educationCentersList.filter(r => (r.status === 'Closed') && r.closedDate && r.startDate && isAfter(endOfMonth(startDateMonth), new Date(r.startDate)) && isAfter(new Date(r.closedDate), startOfMonth(startDateMonth)))].filter(matchesLocationFilters)
        const centersLostThatMonth = educationCentersList.filter(r => r.status === 'Closed' && r.closedDate && isAfter(endDateMonth, new Date(r.closedDate)) && isBefore(startDateMonth, new Date(r.closedDate))).filter(matchesLocationFilters)
        // console.log('centersLostThatMonth', centersLostThatMonth)
        // const pointsLost = centersLostThatMonth.map(r => parseInt(r.points || '0')).reduce((partialSum, a) => partialSum + a, 0);
        return { centersOngoingTillPrevMonth, centersLostThatMonth }
    }
    const average = array => array.reduce((a, b) => a + b) / array.length;

    const getCenterStatusHistory = (center) => {
        const history = Array.isArray(center?.statusHistory) ? [...center.statusHistory] : []

        if (history.length > 0) {
            return history.sort((a, b) => new Date(a.changedAt).getTime() - new Date(b.changedAt).getTime())
        }

        if (center?.status && (center?.created || center?.startDate || center?.closedDate)) {
            return [{
                fromStatus: '',
                toStatus: center.status,
                changedAt: center.created || center.startDate || center.closedDate,
            }]
        }

        return []
    }

    const doesRangeOverlap = (rangeStart, rangeEnd, intervalStart, intervalEnd) => {
        const startTime = new Date(rangeStart).getTime()
        const endTime = new Date(rangeEnd).getTime()
        const intervalStartTime = new Date(intervalStart).getTime()
        const intervalEndTime = intervalEnd ? new Date(intervalEnd).getTime() : Number.POSITIVE_INFINITY

        return intervalStartTime <= endTime && intervalEndTime >= startTime
    }

    const getOfferStatsForMonth = (monthStart) => {
        const monthEnd = endOfMonth(monthStart)
        const positiveOfferStatuses = ['New Center', 'Ongoing']

        const offerCenterIds = new Set()
        let newOffers = 0
        let movedToOfferClosed = 0
        let movedFromOfferPositive = 0

        educationCentersList.filter(matchesLocationFilters).forEach(center => {
            const history = getCenterStatusHistory(center)

            history.forEach((entry, index) => {
                const nextEntry = history[index + 1]

                if (entry.toStatus === 'Offer' && doesRangeOverlap(monthStart, monthEnd, entry.changedAt, nextEntry?.changedAt || '')) {
                    offerCenterIds.add(center.id)
                }

                if (entry.toStatus === 'Offer' && !isBefore(new Date(entry.changedAt), startOfMonth(monthStart)) && !isAfter(new Date(entry.changedAt), monthEnd)) {
                    newOffers += 1
                }

                if (entry.fromStatus === 'Offer' && entry.toStatus === 'Offer Closed' && !isBefore(new Date(entry.changedAt), startOfMonth(monthStart)) && !isAfter(new Date(entry.changedAt), monthEnd)) {
                    movedToOfferClosed += 1
                }

                if (entry.fromStatus === 'Offer' && positiveOfferStatuses.includes(entry.toStatus) && !isBefore(new Date(entry.changedAt), startOfMonth(monthStart)) && !isAfter(new Date(entry.changedAt), monthEnd)) {
                    movedFromOfferPositive += 1
                }
            })
        })

        return {
            id: format(monthStart, 'yyyy-MM'),
            monthLabel: format(monthStart, 'MMM yyyy'),
            offerCenters: offerCenterIds.size,
            newOffers,
            movedToOfferClosed,
            movedFromOfferPositive,
        }
    }

    const fetchChurn = () => {


        let churnRatesLocal = {}, overallPercentages = {
            total: 0,
            ourFault: 0,
            notOurFault: 0,
        }

        const yearsToSubtract = new Date().getFullYear() - parseInt(statsYear)
        const startDateMonth = statsType === 'YTD' ? startOfYear(subYears(new Date(), yearsToSubtract)) : startOfMonth(statsDate)
        const endDateMonth = statsType === 'YTD' ? yearsToSubtract === 0 ? endOfMonth(new Date()) : endOfYear(subYears(new Date(), yearsToSubtract)) : endOfMonth(statsDate)

        const { centersOngoingTillPrevMonth, centersLostThatMonth } = computeChurn(startDateMonth, endDateMonth)
        churnRatesLocal = { centersOngoingTillPrevMonth, centersLostThatMonth }
        if (statsType === 'YTD') {


            const monthsTillNow = eachMonthOfInterval({
                start: subYears(startOfYear(new Date()), yearsToSubtract),
                end: subYears(endOfYear(new Date()), yearsToSubtract),
            }).filter(r => isBefore(r, new Date()))

            let percent = [], percentFault = [], percentNotFault = []
            for (let monthVal of monthsTillNow) {
                const startDateMonth = startOfMonth(monthVal)
                const endDateMonth = endOfMonth(monthVal)
                const { centersOngoingTillPrevMonth, centersLostThatMonth } = computeChurn(startDateMonth, endDateMonth)
                const percentLoc = (centersLostThatMonth.length / (centersOngoingTillPrevMonth.length || 1)) * 100
                const percentFaultLoc = (centersLostThatMonth.filter(r => r.closedType === 'Our Fault').length / (centersOngoingTillPrevMonth.length || 1)) * 100
                const percentNotFaultLoc = (centersLostThatMonth.filter(r => r.closedType === 'Not Our Fault').length / (centersOngoingTillPrevMonth.length || 1)) * 100
                percent.push(percentLoc)
                percentFault.push(percentFaultLoc)
                percentNotFault.push(percentNotFaultLoc)
            }
            overallPercentages = { percent: average(percent).toFixed(1), percentFault: average(percentFault).toFixed(1), percentNotFault: average(percentNotFault).toFixed(1) }
        }

        setChurnRates({ ...churnRatesLocal, ...overallPercentages })
    }

    const fetchFeedbacks = async () => {
        const feedbackQuery = isStaffUser
            ? query(collection(db, `feedbacks`), where('center', '==', viewCenter.id), where('submittedBy', '==', userInfo.id), orderBy('created', 'desc'))
            : query(collection(db, `feedbacks`), where('center', '==', viewCenter.id), orderBy('created', 'desc'))
        const docs = await getFirebaseDocs(await getDocs(feedbackQuery))
        setCenterFeedbacks(docs)
    }

    const fetchCenterStaffFeedbacks = async () => {
        const docs = await getFirebaseDocs(await getDocs(query(collection(db, `center-feedbacks`), where('center', '==', viewCenter.id), orderBy('created', 'desc'))))
        setCenterStaffFeedbacks(docs)
    }

    const fetchCenterStaffFeedbacksCoach = async () => {
        const docs = await getFirebaseDocs(await getDocs(query(collection(db, `center-feedbacks`), where('coachId', '==', viewUser.id), orderBy('created', 'desc'))))
        setCenterStaffFeedbacksCoach(docs)
    }

    const fetchAttendedSessionsForCenter = async () => {
        const docs = await getFirebaseDocs(await getDocs(query(collection(db, `events`), where('educationCenter', '==', viewCenter.id), where('sessionStatus', '==', 'Attended'))))
        setAttendedSessionsOfCenter(docs.sort((a, b) => isAfter(new Date(a.start), new Date(b.start)) ? 1 : -1))

    }
    const fetchMissedSessionsForCenter = async () => {
        const docs = await getFirebaseDocs(await getDocs(query(collection(db, `events`), where('educationCenter', '==', viewCenter.id), where('sessionStatus', '==', 'Missed'))))
        setMissedSessionsOfCenter(docs.filter(r => !r.missedCoaches || r.missedCoaches.length === 0).sort((a, b) => isAfter(new Date(a.start), new Date(b.start)) ? 1 : -1))
        setCoveredSessionsOfCenter(docs.filter(r => r.missedCoaches && r.missedCoaches.length > 0).sort((a, b) => isAfter(new Date(a.start), new Date(b.start)) ? 1 : -1))
    }
    const fetchRescheduledSessionsForCenter = async () => {
        const docs = await getFirebaseDocs(await getDocs(query(collection(db, `events`), where('educationCenter', '==', viewCenter.id), where('sessionStatus', '==', 'Rescheduled'))))
        setRescheduledSessionsOfCenter(docs.sort((a, b) => isAfter(new Date(a.start), new Date(b.start)) ? 1 : -1))
    }

    const fetchFeedbacksOfCoach = async () => {
        const docs = await getFirebaseDocs(await getDocs(query(collection(db, `feedbacks`), where('coach.value', '==', viewUser.id), orderBy('created', 'desc'))))
        setCoachFeedbacks(docs)
    }

    const fetchCoachDocumentsOfCoach = async () => {
        const docs = await getFirebaseDocs(await getDocs(query(collection(db, `children-checks`), where('coachId', '==', viewUser.id), orderBy('created', 'desc'))))
        const sortedDocs = docs.sort((a, b) => isAfter(new Date(a.expiry), new Date(b.expiry)) ? -1 : 1)

        setChildrenChecks(sortedDocs.filter(row => !row.documentType || row.documentType === 'children-check'))
        setResumeReferenceChecks(sortedDocs.filter(row => row.documentType === 'resume-reference-check'))
        setNationalSafetyTrainings(sortedDocs.filter(row => row.documentType === 'national-safety-training'))
        setWorkRightsDocuments(sortedDocs.filter(row => row.documentType === 'work-rights'))
        setContracts(sortedDocs.filter(row => row.documentType === 'contract'))
    }

    const fetchGeneralFeedbacksOfCoach = async () => {
        const docs = await getFirebaseDocs(await getDocs(query(collection(db, `feedbacks-general`), where('coach', '==', viewUser.id), orderBy('created', 'desc'))))
        setCoachGeneralFeedbacks(docs)
    }

    const fetchHeadFeedbacksOfCoach = async () => {
        const docs = await getFirebaseDocs(await getDocs(query(collection(db, `head-coach-feedbacks`), where('toCoach', '==', viewUser.id), orderBy('created', 'desc'))))
        setCoachHeadFeedbacks(docs)
    }

    const fetchFiveStarFeedbacksOfCoach = async () => {
        const docs = await getFirebaseDocs(await getDocs(query(collection(db, `five-star-feedbacks`), where('coachId', '==', viewUser.id), orderBy('created', 'desc'))))
        setCoachFiveStarFeedbacks(docs)
    }

    const fetchAttendedMissedCoveredCounts = async () => {
        // const docs = await getFirebaseDocs(await getDocs(query(collection(db, `feedbacks-general`), where('coach', '==', viewUser.id), orderBy('created', 'desc'))))
        const attendedDocs = await getFirebaseDocs(await getDocs(query(collection(db, `events`), where('coaches', 'array-contains', { label: `${viewUser.firstName} ${viewUser.lastName}`, value: viewUser.id }), where('sessionStatus', '==', 'Attended'),)))
        const missedDocs = await getFirebaseDocs(await getDocs(query(collection(db, `events`), where('coaches', 'array-contains', { label: `${viewUser.firstName} ${viewUser.lastName}`, value: viewUser.id }), where('sessionStatus', '==', 'Missed'),)))
        let coveredDocs = await getFirebaseDocs(await getDocs(query(collection(db, `events`), where('coaches', 'array-contains', { label: `${viewUser.firstName} ${viewUser.lastName}`, value: viewUser.id }), where('sessionStatus', '==', 'Rescheduled'),)))
        coveredDocs = coveredDocs.filter(r => r.missedCoaches && r.missedCoaches.length > 0 && !r.missedCoaches.map(r => r.value).find(r => r === viewUser.id))

        // Rescheduled sessions but held by same coach are added to attended status.
        let attendedRescheduledDocs = await getFirebaseDocs(await getDocs(query(collection(db, `events`), where('coaches', 'array-contains', { label: `${viewUser.firstName} ${viewUser.lastName}`, value: viewUser.id }), where('sessionStatus', '==', 'Rescheduled'),)))
        attendedRescheduledDocs = attendedRescheduledDocs.filter(r => ((r.missedCoaches && r.missedCoaches.length > 0 && r.missedCoaches.map(r => r.value).find(r => r === viewUser.id)) || (!r.missedCoaches || r.missedCoaches.length === 0)))

        setCoachAttendedStats({
            Attended: attendedDocs.length + attendedRescheduledDocs.length,
            Missed: missedDocs.length,
            Covered: coveredDocs.length
        })
    }

    const getAvailabilityColor = availability => {
        if (availability === 'Available') {
            return 'green'
        } else if (availability === 'Fortnightly') {
            return 'yellow'
        } else if (availability === 'Filled') {
            return 'orange'
        } else if (availability === 'Unavailable') {
            return 'red'
        }

        return 'transparent'
    }

    const handleSortCenter = (property) => {
        const nextDirection = centerSortConfig.property === property && centerSortConfig.direction === 'desc' ? 'asc' : 'desc'
        const directionMultiplier = nextDirection === 'desc' ? -1 : 1
        const compareText = (valueA = '', valueB = '') => String(valueA || '').trim().toLowerCase().localeCompare(String(valueB || '').trim().toLowerCase())
        const compareNumber = (valueA = 0, valueB = 0) => (valueA - valueB)
        const compareDate = (valueA, valueB) => {
            const timeA = valueA ? new Date(valueA).getTime() : Number.NEGATIVE_INFINITY
            const timeB = valueB ? new Date(valueB).getTime() : Number.NEGATIVE_INFINITY
            return timeA - timeB
        }

        const sortedCenters = [...educationCentersList].sort((a, b) => {
            if (property === 'startDate') {
                return compareDate(a.startDate, b.startDate) * directionMultiplier
            }
            if (property === 'closedDate') {
                return compareDate(a.closedDate, b.closedDate) * directionMultiplier
            }
            if (property === 'avgRating') {
                return compareNumber(a.avgRating || 0, b.avgRating || 0) * directionMultiplier
            }
            if (property === 'name') {
                return compareText(a.name, b.name) * directionMultiplier
            }
            if (property === 'status') {
                if (statusFilter === 'New Center') {
                    const onboardingStepsA = a.onboardingStepsCompleted || []
                    const onboardingStepsB = b.onboardingStepsCompleted || []
                    const mostRecentStepA = onboardingStepsA.length > 0 ? Math.max(...onboardingStepsA) : -1
                    const mostRecentStepB = onboardingStepsB.length > 0 ? Math.max(...onboardingStepsB) : -1
                    return compareNumber(mostRecentStepA, mostRecentStepB) * directionMultiplier
                }
                if (statusFilter === 'Trial') {
                    const onboardingStepsA = a.trialStepsCompleted || []
                    const onboardingStepsB = b.trialStepsCompleted || []
                    const mostRecentStepA = onboardingStepsA.length > 0 ? Math.max(...onboardingStepsA) : -1
                    const mostRecentStepB = onboardingStepsB.length > 0 ? Math.max(...onboardingStepsB) : -1
                    return compareNumber(mostRecentStepA, mostRecentStepB) * directionMultiplier
                }
                return compareText(a.status, b.status) * directionMultiplier
            }
            return 0
        })

        setCenterSortConfig({ property, direction: nextDirection })
        setEducationCentersList(sortedCenters)
    }


    const handleSortCoaches = (property) => {
        if (property === 'startDate' || property === 'inactiveDate') {
            const getDateTimestamp = (value) => {
                if (!value) {
                    return null
                }

                const timestamp = new Date(value).getTime()
                return Number.isNaN(timestamp) ? null : timestamp
            }

            setReturnedUsers([...returnedUsers].sort((a, b) => {
                const startDateA = getDateTimestamp(a[property])
                const startDateB = getDateTimestamp(b[property])

                if (startDateA === null && startDateB === null) {
                    return 0
                }

                if (startDateA === null) {
                    return 1
                }

                if (startDateB === null) {
                    return -1
                }

                return startDateB - startDateA
            }))

        } else if (property === 'avgRating') {
            setReturnedUsers([...returnedUsers.sort((a, b) => (a.avgRating || 0) > (b.avgRating || 0) ? -1 : 1)])
        } else if (property === 'name') {
            setReturnedUsers([...returnedUsers.sort((a, b) => (a.firstName) > (b.firstName) ? 1 : -1)])

        } else if (property === 'codeOfConduct') {
            setReturnedUsers([...returnedUsers.sort((a, b) => !!a.codeOfConductUrl === !!b.codeOfConductUrl ? 0 : !!a.codeOfConductUrl ? -1 : 1)])
        }
    }

    const toggleCoachFilter = id => {
        if (coachFilter.includes(id)) {
            setCoachFilter(coachFilter.filter(r => r !== id))
        } else {
            setCoachFilter([...coachFilter, id])
        }
    }


    const getColorFromAvgRating = (avgRating) => {
        if (avgRating >= 8) {
            return 'green'
        } else if (avgRating >= 6) {
            return 'orange'
        } else {
            return 'red'
        }
    }

    const updateOnboardingSteps = async () => {
        let payload = { onboardingStepsCompleted: addEducationCenterCompletedOnboardingSteps }
        if (addEducationCenterCompletedOnboardingSteps.includes(12)) {
            payload = { ...payload, status: 'Ongoing' }
        }
        await updateDoc(doc(db, 'education-centers', viewCenter.id), payload)
        toast.success('Onboarding steps updated.')
        fetchEducationCenters()
    }

    const updateOnboardingStepsCoach = async () => {
        let payload = {
            onboardingStepsCompleted: addCoachCompletedOnboardingSteps,
            onboardingStepsType: addCoachOnboardingStepsType ? addCoachOnboardingStepsType.value : '',
            onboardingStepsCompletedA: addCoachCompletedOnboardingStepsA,
            onboardingStepsCompletedB: addCoachCompletedOnboardingStepsB
        }

        if (addCoachCompletedOnboardingStepsA.includes(5) || addCoachCompletedOnboardingStepsB.includes(6)) {
            // user has completed onboarding
            payload.onboardingStatus = "Onboarded"
        }

        await updateDoc(doc(db, 'users', viewUser.id), payload)
        toast.success('Onboarding steps updated for coach.')
        fetchUsers()
    }

    const updateTrialSteps = async () => {
        const payload = { trialStepsCompleted: addEducationCenterCompletedTrialSteps }
        await updateDoc(doc(db, 'education-centers', viewCenter.id), payload)
        toast.success('Trial steps updated.')
        fetchEducationCenters()
    }

    const getStatusColor = (statusVal, onboardingStepsCompleted, trialStepsCompleted) => {
        if (statusVal === 'New Center') {

            if (onboardingStepsCompleted.length > 0) {
                const mostRecentStep = Math.max(...onboardingStepsCompleted)
                if (mostRecentStep >= 0) {
                    return onboardingStepsOptions.find((r, idx) => idx === mostRecentStep).color
                }
            }
        } else if (statusVal === 'Trial') {
            if (trialStepsCompleted.length > 0) {
                const mostRecentStep = Math.max(...trialStepsCompleted)
                if (mostRecentStep >= 0) {
                    return trialStepsOptions.find((r, idx) => idx === mostRecentStep).color
                }
            }
        }
        return 'transparent'
    }

    const getStatusNumber = (statusVal, onboardingStepsCompleted, trialStepsCompleted) => {
        if (statusVal === 'New Center') {

            if (onboardingStepsCompleted.length > 0) {
                const mostRecentStep = Math.max(...onboardingStepsCompleted)
                if (mostRecentStep >= 0) {
                    return onboardingStepsOptions.find((r, idx) => idx === mostRecentStep).label
                }
            }
        } else if (statusVal === 'Trial') {
            if (trialStepsCompleted.length > 0) {
                const mostRecentStep = Math.max(...trialStepsCompleted)
                // console.log('mostRecentStep', mostRecentStep)
                if (mostRecentStep >= 0) {
                    return trialStepsOptions.find((r, idx) => idx === mostRecentStep).label
                }
            }
        }
        return ''
    }


    const getSessionValue = r => {
        let sessionVal = ''
        if (r.sessionStatus && r.sessionStatus.value) {
            sessionVal = r.sessionStatus.value
        } else {
            sessionVal = r.sessionStatus
        }

        if (sessionFilter === 'None') {
            return !sessionVal
        }

        // if (sessionFilter === 'Missed') {
        //     return sessionVal === 'Missed' && (!r.missedCoaches || r.missedCoaches.length === 0)
        // } else
        if (sessionFilter === 'Covered') {
            return sessionVal === 'Rescheduled' && r.missedCoaches && r.missedCoaches.length !== 0
        }

        return sessionVal === sessionFilter
    }


    const updateUsersEquipments = async (value, row, arrayEquipments = usersEquipments, setArrayEquipment = setUsersEquipments) => {
        if (value && value !== '0') {
            const matchingEquipment = arrayEquipments.find(r => r.id === row.id)
            if (matchingEquipment) {
                setArrayEquipment([...arrayEquipments.map(r => r.id === row.id ? { ...r, qty: value } : r)])
            } else {
                setArrayEquipment([...arrayEquipments, { ...row, qty: value }])
            }

        } else {
            // Remove
            setArrayEquipment([...arrayEquipments.filter(r => r.id !== row.id)])
        }
    }


    const fetchUsersQty = (row, arrayEquipments = usersEquipments) => {
        const matchingEquipment = arrayEquipments.find(r => r.id === row.id)

        if (matchingEquipment) {
            return matchingEquipment.qty || ''
        }
        return ''
    }



    const chooseTransferEquipment = async (id, value) => {
        if (value) {
            setReceiverEquipments([...receiverEquipments, usersEquipments.find(r => r.id === id)])
        } else {
            setReceiverEquipments([...receiverEquipments.filter(r => r.id !== id)])

        }
    }


    const fetchQtyForEquipmentId = (id) => {

        let qty = 0
        for (let eachUser of [centerEquipments, ...returnedUsers].filter(r => stockRoomFilter === 'All' ? true : stockRoomFilter === 'Stock Room' ? r.id === 'center' : r.id !== 'center')) {
            if (matchesLocationFilters(eachUser)) {


                const matchingEquip = eachUser.equipments && eachUser.equipments.find(r => r.id === id)
                if (matchingEquip) {
                    qty += parseInt(matchingEquip.qty) || 0
                }

            }
        }
        return qty
    }


    // Sums up stock room quantities for duplicated names across categories.
    const fetchQtyClubbedForStockRoom = () => {
        let equipmentsCounted = []

        const centerEquipmentsArray = centerEquipments.equipments || []
        for (let equip of centerEquipmentsArray) {
            if (equipmentsCounted.find(r => r.name === equip.name)) {
                equipmentsCounted = equipmentsCounted.map(r => r.name === equip.name ? { ...r, qty: r.qty + parseInt(equip.qty) } : r)
            } else {
                equipmentsCounted.push({ name: equip.name, qty: parseInt(equip.qty) || 0 })
            }
        }

        return equipmentsCounted

    }

    const handleSaveUsersEquipment = async () => {
        setLoading(true)
        if (showAssignEquipment.id === 'center') {
            await updateDoc(doc(db, 'equipments-in-center', showAssignEquipment.id), { equipments: usersEquipments })
        } else {
            await updateDoc(doc(db, 'users', showAssignEquipment.id), { equipments: usersEquipments })
        }
        setLoading(false)
        toast.success('Equipment updated')
        setShowAssignEquipment(false)
        fetchUsers()
    }

    const calculateEquipmentSent = (usersEquipments, receiverEquipments) => {
        let usersEquipmentsLoc = [...usersEquipments]

        for (let equipment of receiverEquipments) {
            const matchingOriginal = usersEquipmentsLoc.find(r => r.id === equipment.id)
            const newQty = parseInt(matchingOriginal.qty || 0) - parseInt(equipment.qty || 0)
            usersEquipmentsLoc = usersEquipmentsLoc.map(r => r.id === equipment.id ? { ...r, qty: String(newQty) } : r)
        }
        return usersEquipmentsLoc.filter(r => parseInt(r.qty) !== 0)
    }

    const calculateEquipmentReceived = (usersEquipments = [], receiverEquipments = []) => {
        let usersEquipmentsLoc = [...usersEquipments]
        for (let equipment of receiverEquipments) {
            const matchingOriginal = usersEquipmentsLoc.find(r => r.id === equipment.id)
            if (matchingOriginal) {
                const newQty = parseInt(matchingOriginal.qty) + parseInt(equipment.qty)
                usersEquipmentsLoc = usersEquipmentsLoc.map(r => r.id === equipment.id ? { ...r, qty: String(newQty) } : r)
            } else {
                usersEquipmentsLoc.push(equipment)
            }
        }
        return usersEquipmentsLoc
    }

    const handleTransferUsersEquipment = async () => {
        setLoading(true)

        const updatedSenderEquipments = calculateEquipmentSent(usersEquipments, receiverEquipments)

        const originalEquipmentOfReceiver = receiverUser.value === 'center' ? centerEquipments.equipments : returnedUsers.find(r => r.id === receiverUser.value).equipments

        const updatedReceiverEquipments = calculateEquipmentReceived(originalEquipmentOfReceiver, receiverEquipments)
        if (showTransferEquipment.id === 'center') {
            await updateDoc(doc(db, 'equipments-in-center', showTransferEquipment.id), { equipments: updatedSenderEquipments })
        } else {
            await updateDoc(doc(db, 'users', showTransferEquipment.id), { equipments: updatedSenderEquipments })
        }

        if (receiverUser.value === 'center') {
            await updateDoc(doc(db, 'equipments-in-center', receiverUser.value), { equipments: updatedReceiverEquipments })
        } else {
            await updateDoc(doc(db, 'users', receiverUser.value), { equipments: updatedReceiverEquipments })
        }

        setLoading(false)
        toast.success('Equipment transferred')
        setShowTransferEquipment(false)
        fetchUsers()
    }

    const handleAddChildrenChecks = async () => {
        const activeDocumentSection = getCoachDocumentSection(childrenCheckType)

        const payload = {
            coachId: viewUser.id,
            img: childrenCheckImage,
            created: new Date().toISOString(),
            expiry: childrenCheckPopupExpiryDate.toISOString(),
            documentType: activeDocumentSection.key,
        }

        if (childrenCheckId) {
            // const { created, ...remaining } = payload
            await updateDoc(doc(db, 'children-checks', childrenCheckId), payload)
            toast.success('Checks updated.')

        } else {
            await addDoc(collection(db, 'children-checks'), payload)
            toast.success('Checks created.')
        }


        setShowCoachChildrenChecksPopup(false)
        fetchCoachDocumentsOfCoach()
        setChildrenCheckId('')
        setChildrenCheckImage('')
        setChildrenCheckPopupExpiryDate('')
        setChildrenCheckType('children-check')
    }

    const deleteCoachDocument = async () => {
        await deleteDoc(doc(db, 'children-checks', deleteCoachDocumentId))
        setDeleteCoachDocumentId('')
        fetchCoachDocumentsOfCoach()
        toast.success('Document deleted.')
    }

    const updateEmergencyContact = async () => {
        const combinedEmergencyName = [emergencyContactFirstName.trim(), emergencyContactSurname.trim()].filter(Boolean).join(' ').trim()
        const payload = {
            emergencyContactName: combinedEmergencyName,
            emergencyContactPhoneNumber: emergencyContactMobileNumber.trim(),
            emergencyContactFirstName: emergencyContactFirstName.trim(),
            emergencyContactSurname: emergencyContactSurname.trim(),
            emergencyContactMobileNumber: emergencyContactMobileNumber.trim(),
            emergencyContactRelationship: emergencyContactRelationship.trim()
        }

        await updateDoc(doc(db, 'users', viewUser.id), payload)
        toast.success('Emergency contact updated.')
        fetchUsers()
        setViewUser({ ...viewUser, ...payload })
    }

    const sortHolidays = () => {
        if (viewHolidayType === 'Upcoming') {
            return [...holidays].filter(a => isAfter(new Date(a.endDay), new Date())).sort((a, b) => isAfter(new Date(a.endDay), new Date(b.endDay)) ? 1 : -1)
        } else {
            return [...holidays].filter(a => isAfter(new Date(), new Date(a.endDay))).sort((a, b) => isAfter(new Date(a.endDay), new Date(b.endDay)) ? -1 : 1)

        }
    }

    const getHolidayUser = (userId) => returnedUsers.find(user => user.id === userId)

    const filteredHolidays = sortHolidays().filter((holiday) => {
        const matchingUser = getHolidayUser(holiday.userId)
        const userName = getUserName(holiday.userId)
        const email = matchingUser?.email || ''
        const state = matchingUser?.city || ''
        const searchValue = search.trim().toLowerCase()

        if (holidayStateFilter !== 'All' && state !== holidayStateFilter) {
            return false
        }

        if (!searchValue) {
            return true
        }

        return userName.toLowerCase().includes(searchValue) || email.toLowerCase().includes(searchValue)
    })

    const findMatchingEquipmentsAndSort = (a, b) => {
        const matchingEqA = equipments.find(r => r.id === a.id)
        const matchingEqB = equipments.find(r => r.id === b.id)
        if (matchingEqA && matchingEqB) {
            return matchingEqA.priority >= matchingEqB.priority ? 1 : -1
        }
    }

    const findMatchingEquipmentsAndSortByName = (a, b) => {
        const matchingEqA = equipments.find(r => r.id === a.id)
        const matchingEqB = equipments.find(r => r.id === b.id)
        if (matchingEqA && matchingEqB) {
            return matchingEqA.name.toLowerCase() >= matchingEqB.name.toLowerCase() ? 1 : -1
        }
    }


    const getEquipmentQtyColor = (id, qty) => {
        const matchingEq = equipments.find(r => r.id === id)
        if (matchingEq) {
            return matchingEq.quantity > qty ? 'red' : 'green'
        }
    }

    const equipmentGroupedByName = (array) => {
        if (categoryFilter === 'All') {
            const grouped = {};


            array.forEach(item => {
                if (grouped[item.name]) {
                    grouped[item.name] += (item.qty === '.0' ? 0 : parseInt(item.qty)) || 0;
                } else {
                    grouped[item.name] = (item.qty === '.0' ? 0 : parseInt(item.qty)) || 0;
                }
            });

            const result = Object.keys(grouped).map(name => ({
                name,
                qty: grouped[name]
            }));

            console.log(result)
            return result
        }
        return array
    }


    const getEventsAfterStatsFiltering = (events, statsType, statsDate) => events
        .filter(r => {
            const center = getCenterById(r.educationCenter)
            return center ? matchesLocationFilters(center) : cityFilter === 'All'
        })
        .filter(r => {
            if (statsType === 'YTD') return true
            const eventStartDate = new Date(r.start)
            return !isBefore(eventStartDate, startOfMonth(statsDate)) && !isAfter(eventStartDate, endOfMonth(statsDate))
        })

    const getAttendanceAfterFiltering = (events, statsType, statsDate) => getEventsAfterStatsFiltering(events, statsType, statsDate).length

    const getProgramsCount = (events, statsType, statsDate) => {
        const eventsFiltered = getEventsAfterStatsFiltering(events, statsType, statsDate)

        let message = { Sports: 0, Music: 0, Yoga: 0, Gymnastics: 0, SensoryFusion: 0 }, processedIds = []
        for (let event of eventsFiltered) {
            if (!processedIds.includes(event.educationCenter)) {
                const classType = getClassType(event.activity, event.weekActivity)
                if (classType === 'Sports') {
                    message.Sports += 1
                } else if (classType === 'Music') {
                    message.Music += 1
                } else if (classType === 'Gymnastics') {
                    message.Gymnastics += 1
                } else if (classType === 'Yoga') {
                    message.Yoga += 1
                } else if (classType === 'Sensory Fusion') {
                    message.SensoryFusion += 1
                }
                processedIds.push(event.educationCenter)
            }
        }
        return <h3>Sports: {message.Sports}<br /> Music: {message.Music} <br /> Yoga: {message.Yoga} <br /> Gymnastics: {message.Gymnastics} <br /> Sensory Fusion: {message.SensoryFusion}</h3>
    }

    const computePercentageAttendance = (eventsCount, type) => {

        if (statsType === 'YTD') {

            const monthsTillNow = eachMonthOfInterval({
                start: startOfYear(statsDate),
                end: isSameYear(new Date(), statsDate) ? new Date() : endOfYear(statsDate)
            })

            let percentAttended = [], percentMissed = [], percentRescheduled = []

            for (let monthVal of monthsTillNow) {
                const total = getAttendanceAfterFiltering(eventsAttendance.Total, 'Month', monthVal)
                const attended = getAttendanceAfterFiltering(eventsAttendance.Attended, 'Month', monthVal)
                const missed = getAttendanceAfterFiltering(eventsAttendance.Missed, 'Month', monthVal)
                const rescheduled = getAttendanceAfterFiltering(eventsAttendance.Rescheduled, 'Month', monthVal)

                percentAttended.push((attended / (total || 1)) * 100)
                percentMissed.push((missed / (total || 1)) * 100)
                percentRescheduled.push((rescheduled / (total || 1)) * 100)
            }

            if (type === 'Attended') {
                return average(percentAttended).toFixed(1)
            } else if (type === 'Missed') {
                return average(percentMissed).toFixed(1)
            } else if (type === 'Rescheduled') {
                return average(percentRescheduled).toFixed(1)
            }

        } else {
            const total = getAttendanceAfterFiltering(eventsAttendance.Total, statsType, statsDate)
            return ((eventsCount / (total || 1)) * 100).toFixed(1)
        }
    }

    const handleAddAdmin = async () => {

        const emailForAdmin = adminEmail.trim().toLowerCase()

        // Check if admin already exists for this center
        const existingUsers = await getFirebaseDocs(await getDocs(query(collection(db, 'users'), where('email', '==', emailForAdmin))))

        if (existingUsers.length > 0) {
            toast.error('A user with this email already exists, cant create admin.')
            return
        }

        await addDoc(collection(db, 'education-centers-admins'), {
            firstName: adminFirstName,
            lastName: adminLastName,
            email: emailForAdmin,
            centerId: viewCenter.id,
            centerName: viewCenter.name,
            programCode: viewCenter.programCode,
            created: new Date().toISOString(),
        })

        const centerId = viewCenter.id

        await updateDoc(doc(db, 'education-centers', centerId), {
            admin: {
                firstName: adminFirstName,
                lastName: adminLastName,
                email: emailForAdmin,
                created: new Date().toISOString(),
            }
        })

        setViewCenter({
            ...viewCenter,
            admin: {
                firstName: adminFirstName,
                lastName: adminLastName,
                email: emailForAdmin,
            }
        })

        setAddingAdmin(false)
    }


    const handleConfirmAdminOnboardingAgain = async () => {
        const matchingDocs = await getFirebaseDocs(await getDocs(query(collection(db, `users`), where('email', '==', viewCenter.admin.email))))
        if (matchingDocs.length > 0) {
            await updateDoc(doc(db, 'users', matchingDocs[0].id), {
                completedStaffOnboarding: false
            })
            toast.success('Toggled them to trigger onboarding again')
        }
        setShowConfirmAdminOnboardingPopup(false)
    }

    const handleResendAdminInvite = async () => {
        if (!viewCenter || !viewCenter.id || !viewCenter.admin || !viewCenter.admin.email || !auth.currentUser) {
            toast.error('Missing center admin details.')
            return
        }

        try {
            setResendingAdminInvite(true)
            const token = await auth.currentUser.getIdToken()

            const response = await fetch(getFunctionUrl('resendCenterAdminInvite'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    token,
                    centerId: viewCenter.id,
                    email: viewCenter.admin.email,
                })
            })

            const payload = await response.json()

            if (!response.ok || payload.err) {
                throw new Error(payload.err || 'Unable to resend invite.')
            }

            toast.success('Center admin invite resent with a new password.')
            setShowConfirmResendAdminInvitePopup(false)
        } catch (error) {
            console.error(error)
            toast.error(error.message || 'Unable to resend invite.')
        } finally {
            setResendingAdminInvite(false)
        }
    }

    const resetStaffProfileForm = () => {
        setAddingStaffProfile(false)
        setEditingStaffProfileId('')
        setStaffProfileName('')
        setStaffProfileRoomName('')
        setStaffProfileRoomType('')
        setStaffProfileType('manual')
        setStaffProfileIsActive(true)
    }

    const handleStartAddStaffProfile = () => {
        resetStaffProfileForm()
        setAddingStaffProfile(true)
    }

    const handleStartEditStaffProfile = (profile) => {
        setAddingStaffProfile(true)
        setEditingStaffProfileId(profile.id)
        setStaffProfileName(profile.name || '')
        setStaffProfileRoomName(profile.roomName || '')
        setStaffProfileRoomType(profile.roomType || '')
        setStaffProfileType(profile.profileType || 'manual')
        setStaffProfileIsActive(profile.isActive !== false)
    }

    const handleSaveStaffProfile = async () => {
        if (!viewCenter || !viewCenter.id || !staffProfileName.trim()) {
            toast.error('Profile name is required.')
            return
        }

        if (!userInfo?.id) {
            toast.error('You must be signed in to save staff profiles.')
            return
        }

        try {
            const existingProfiles = Array.isArray(viewCenter.staffProfiles) ? viewCenter.staffProfiles : []
            const now = new Date().toISOString()
            const nextProfiles = addingStaffProfile && editingStaffProfileId
                ? existingProfiles.map(profile => profile.id === editingStaffProfileId ? {
                    ...profile,
                    name: staffProfileName.trim(),
                    roomName: staffProfileRoomName.trim(),
                    roomType: staffProfileRoomType.trim(),
                    profileType: profile.profileType || 'manual',
                    isActive: staffProfileIsActive,
                    updatedAt: now,
                } : profile)
                : [...existingProfiles, {
                    id: randomString(18),
                    name: staffProfileName.trim(),
                    roomName: staffProfileRoomName.trim(),
                    roomType: staffProfileRoomType.trim(),
                    profileType: 'manual',
                    isActive: staffProfileIsActive,
                    sortOrder: Math.max(0, ...existingProfiles.map(profile => profile.sortOrder || 0)) + 1,
                    createdAt: now,
                    updatedAt: now,
                    createdByUserId: userInfo.id,
                    lastSelectedAt: null,
                    lastFeedbackAt: null,
                }]

            await updateDoc(doc(db, 'education-centers', viewCenter.id), {
                staffProfiles: nextProfiles,
            })

            setViewCenter({
                ...viewCenter,
                staffProfiles: nextProfiles,
            })
            setEducationCentersList(prev => prev.map(center => center.id === viewCenter.id ? {
                ...center,
                staffProfiles: nextProfiles,
            } : center))
            resetStaffProfileForm()
        } catch (error) {
            console.error(error)
            toast.error('Unable to save staff profile.')
        }
    }

    const calculatePointsSumCenter = centers => centers.map(r => parseInt(r.points) || 0).reduce((accumulator, currentValue) => accumulator + currentValue, 0)

    const renderTownFilter = () => cityFilter !== 'All' && <div style={{ display: 'flex', alignItems: 'center' }}>
        <h4 style={{ marginTop: '12px', marginBottom: '-10px', marginRight: '5px' }}>Town Filter:</h4>
        <Tabs tabs={['All', ...getTownOptionsForState(cityFilter)]} currentTab={townFilter} setCurrentTab={setTownFilter} />
    </div>

    const returnSessionFilters = (isMap, isStats) => <>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <h4 style={{ marginTop: '12px', marginBottom: '-10px', marginRight: '5px' }}>State Filter:</h4>
                <Tabs tabs={['All', ...cityFilterOptions]} currentTab={cityFilter} setCurrentTab={setCityFilter} />
            </div>
            {
                isMap && !isStats && <div style={{ display: 'flex', alignItems: 'center' }}>
                    <h4 style={{ marginTop: '12px', marginBottom: '-10px', marginRight: '5px' }}>View Type:</h4>
                    <Tabs tabs={['All', 'Coaches', 'Centers']} currentTab={mapViewType} setCurrentTab={setMapViewType} />
                </div>
            }
            {!isMap && <>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <h4 style={{ marginTop: '12px', marginBottom: '-10px', marginRight: '5px' }}>Type Filter:</h4>
                    <Tabs tabs={['All', 'New Center', 'Offer', 'Ongoing', 'Short Bookings', 'Trial']} currentTab={sessionTypeFilter} setCurrentTab={setSessionTypeFilter} />
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <h4 style={{ marginTop: '12px', marginBottom: '-10px', marginRight: '5px' }}>Session Filter:</h4>
                    <Tabs tabs={['All', 'None', 'Attended', 'Missed', 'Covered', 'Rescheduled']} currentTab={sessionFilter} setCurrentTab={setSessionFilter} />
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <h4 style={{ marginTop: '12px', marginBottom: '-10px', marginRight: '5px' }}>Category Filter:</h4>
                    <Tabs tabs={[
                        'All', 'Sports One', 'Sports Two', 'Music', 'Gymnastics', 'Yoga', 'Sensory Fusion',
                        'Offer Sports 1', 'Offer Sports 2', 'Offer Music', 'Offer Gymnastics', 'Offer Yoga', 'Offer Sensory',
                    ]} currentTab={categoryFilter} setCurrentTab={setCategoryFilter} />
                </div>
            </>}

            {isMap && !isStats && <div style={{ display: 'flex', alignItems: 'center' }}>
                <h4 style={{ marginTop: '12px', marginBottom: '-10px', marginRight: '5px' }}>Category Filter:</h4>
                <Tabs tabs={['All', 'Sports', 'Music', 'Yoga', 'Gymnastics', 'Sensory Fusion']} currentTab={categoryFilter} setCurrentTab={setCategoryFilter} />
            </div>}
        </div>
        {renderTownFilter()}
    </>


    const filteredEvents = events
        .filter(r => (sessionTypeFilter && sessionTypeFilter !== 'All') ? r.type === sessionTypeFilter : true)
        .filter(r => (categoryFilter && categoryFilter !== 'All') ? r.activity === categoryFilter : true)
        .filter(r => coachFilter.length === 0 ? true : (coachFilter.includes(r.coaches[0].value) || (r.coaches[1] && coachFilter.includes(r.coaches[1].value)) || (r.coaches[2] && coachFilter.includes(r.coaches[2].value))))
        .filter(r => {
            const center = getCenterById(r.educationCenter)
            return center ? matchesLocationFilters(center) : cityFilter === 'All'
        })
        .filter(r => {
            const center = getCenterById(r.educationCenter)
            return (center && search) ? center.name.toLowerCase().includes(search.toLowerCase()) : true
        })
        .filter(r => sessionFilter !== 'All' ? getSessionValue(r) : true)
    const filteredEducationCenters = educationCentersList
        .filter(r => (statusFilter && statusFilter !== 'All') ? r.status === statusFilter : (r.status !== 'Closed' && r.status !== 'Offer Closed' && r.status !== 'Short Bookings Closed' && r.status !== 'Trial' && r.status !== 'Trial Closed'))
        .filter(matchesLocationFilters)
        .filter(r => (categoryFilter && categoryFilter !== 'All') ? r.categories.includes(categoryFilter) : true)
        .filter(r => search ? r.name.toLowerCase().includes(search.toLowerCase()) : true)
    const mapEducationCenters = filteredEducationCenters.filter(r => r.status !== 'One Off')
    const filteredUsers = returnedUsers
        .filter(matchesLocationFilters)
        .filter(r => (categoryFilter && categoryFilter !== 'All' && r.categories) ? r.categories.includes(categoryFilter) : true)
        .filter(r => search ? (r.firstName.toLowerCase().includes(search.toLowerCase()) || (r.lastName.toLowerCase().includes(search.toLowerCase()))) : true)
        .filter(r => (stateFilter && stateFilter !== 'All' ? r.status === stateFilter : true))
        .filter(r => onboardingStatusFilter !== 'All' ? (onboardingStatusFilter === 'Onboarded' ? r.onboardingStatus === 'Onboarded' : !r.onboardingStatus || r.onboardingStatus === 'Onboarding') : true)
    const allEducationCenters = [...filteredEducationCenters, ...educationCentersTrialsList].filter(row => ['Trial', 'Trial Closed', 'Offer Closed', 'Short Bookings Closed', 'Closed'].includes(statusFilter) ? format(new Date(row.closedDate || row.created), 'yyyy') === `${yearFilter}` : true).filter(row => statusFilter !== 'Trial' ? !row.isOld : true).filter(r => (['Closed', 'Offer Closed', 'Short Bookings Closed'].includes(statusFilter) ? (closedReasonFilter === 'All' ? true : closedReasonFilter === r.closedType) : true)).filter(r => statusFilter === 'Trial' ? (trialFilter === 'All' ? true : (trialFilter === 'Signed Up' ? r.status === 'New Center' : r.status === 'Trial Closed')) : true)
    const displayedEducationCenters = allEducationCenters
        .filter(r => inHouseFilter === 'All' || (r.staffDeliverSessions === true ? 'Yes' : 'No') === inHouseFilter)
        .filter(r => statusFilter !== 'One Off' ? r.status !== 'One Off' : true)
        .filter(r => fourSessionNoticeFilter === 'All' ? true : (r.fourSessionNotice || 'No') === fourSessionNoticeFilter)

    const usersWithEquipments = [centerEquipments, ...returnedUsers.filter(matchesLocationFilters).filter(r => r.equipments && r.equipments.length > 0).filter(r => categoryFilter && categoryFilter !== 'All' ? r.equipments.find(x => x.type === categoryFilter) : true)]
    const totalStatsCenters = [...educationCentersList.filter(r => activeStatsCenterStatuses.includes(r.status) && r.startDate && isAfter(endOfMonth(statsDate), new Date(r.startDate))), ...educationCentersList.filter(r => (r.status === 'Closed') && r.closedDate && r.startDate && isAfter(endOfMonth(statsDate), new Date(r.startDate)) && isAfter(new Date(r.closedDate), startOfMonth(statsDate)))].filter(matchesLocationFilters)

    const totalStatsClosed = educationCentersList.filter(r => (r.status === 'Closed') && r.closedDate && isAfter(new Date(r.closedDate), startOfYear(statsDate))).filter(matchesLocationFilters)
    const totalCentersForStats = [...totalStatsCenters, ...(statsType === 'YTD' ? totalStatsClosed : [])].filter((r, idx, arr) => arr.findIndex(x => x.id === r.id) === idx)
    const offerStatsMonths = statsType === 'YTD'
        ? eachMonthOfInterval({
            start: startOfYear(new Date(statsYear, 0, 1)),
            end: statsYear === new Date().getFullYear() ? endOfMonth(new Date()) : endOfYear(new Date(statsYear, 0, 1)),
        })
        : [startOfMonth(statsDate)]
    const offerStatsRows = offerStatsMonths.map(monthStart => getOfferStatsForMonth(monthStart))
    const offerStatsTotals = offerStatsRows.reduce((acc, row) => ({
        offerCenters: acc.offerCenters + row.offerCenters,
        newOffers: acc.newOffers + row.newOffers,
        movedToOfferClosed: acc.movedToOfferClosed + row.movedToOfferClosed,
        movedFromOfferPositive: acc.movedFromOfferPositive + row.movedFromOfferPositive,
    }), {
        offerCenters: 0,
        newOffers: 0,
        movedToOfferClosed: 0,
        movedFromOfferPositive: 0,
    })
    const averageOfferCenters = offerStatsRows.length > 0 ? (offerStatsTotals.offerCenters / offerStatsRows.length).toFixed(1) : '0.0'
    const attendedEventsForStats = getEventsAfterStatsFiltering(eventsAttendance.Attended, statsType, statsDate)
    const missedEventsForStats = getEventsAfterStatsFiltering(eventsAttendance.Missed, statsType, statsDate)
    const rescheduledEventsForStats = getEventsAfterStatsFiltering(eventsAttendance.Rescheduled, statsType, statsDate)
    const totalEventsForStats = getEventsAfterStatsFiltering(eventsAttendance.Total, statsType, statsDate)
    const centersForAttendanceTable = [...educationCentersList, ...educationCentersTrialsList]
        .filter(matchesLocationFilters)
        .filter((r, idx, arr) => arr.findIndex(x => x.id === r.id) === idx)
    const attendedEventsByCenter = attendedEventsForStats.reduce((acc, event) => {
        if (event.educationCenter) {
            acc[event.educationCenter] = (acc[event.educationCenter] || 0) + 1
        }
        return acc
    }, {})
    const missedEventsByCenter = missedEventsForStats.reduce((acc, event) => {
        if (event.educationCenter) {
            acc[event.educationCenter] = (acc[event.educationCenter] || 0) + 1
        }
        return acc
    }, {})
    const rescheduledEventsByCenter = rescheduledEventsForStats.reduce((acc, event) => {
        if (event.educationCenter) {
            acc[event.educationCenter] = (acc[event.educationCenter] || 0) + 1
        }
        return acc
    }, {})
    const classesScheduledByCenter = totalEventsForStats.reduce((acc, event) => {
        if (event.educationCenter) {
            acc[event.educationCenter] = (acc[event.educationCenter] || 0) + 1
        }
        return acc
    }, {})
    const unmatchedAttendanceCenterIds = [...new Set([
        ...Object.keys(attendedEventsByCenter),
        ...Object.keys(missedEventsByCenter),
        ...Object.keys(rescheduledEventsByCenter),
        ...Object.keys(classesScheduledByCenter)
    ])].filter(centerId => !centersForAttendanceTable.find(center => center.id === centerId))
    const centerAttendanceStatsRows = [
        ...centersForAttendanceTable.map(center => ({
            id: center.id,
            centerName: center.name,
            sessionsAttended: attendedEventsByCenter[center.id] || 0,
            sessionsMissed: missedEventsByCenter[center.id] || 0,
            sessionsRescheduled: rescheduledEventsByCenter[center.id] || 0,
            classesScheduled: classesScheduledByCenter[center.id] || 0
        })),
        ...unmatchedAttendanceCenterIds.map(centerId => ({
            id: centerId,
            centerName: `Unknown Center (${centerId})`,
            sessionsAttended: attendedEventsByCenter[centerId] || 0,
            sessionsMissed: missedEventsByCenter[centerId] || 0,
            sessionsRescheduled: rescheduledEventsByCenter[centerId] || 0,
            classesScheduled: classesScheduledByCenter[centerId] || 0
        }))
    ]
        .filter(row => row.sessionsAttended > 0 || row.sessionsMissed > 0 || row.sessionsRescheduled > 0 || row.classesScheduled > 0)
        .sort((a, b) => (b[centerAttendanceSortBy] - a[centerAttendanceSortBy]) || b.sessionsAttended - a.sessionsAttended || a.centerName.localeCompare(b.centerName))
    const centersLostThatMonth = churnRates.centersLostThatMonth.filter(matchesLocationFilters)
    const centersOngoingTillPrevMonth = churnRates.centersOngoingTillPrevMonth.filter(matchesLocationFilters)

    return <div className="container">
        <Header />

        <div style={{ display: 'flex', alignItems: 'center' }}>
            <Tabs tabs={availableTabs} currentTab={page} setCurrentTab={setPage} />

            <div style={{ marginLeft: 'auto', marginRight: '20px' }}>
                <Input type={'text'} value={search} placeholder={page === 'Holidays' ? 'Search coach' : 'Search'} setValue={setSearch} errors={[]} />
            </div>

        </div>

        {
            page === 'Invoices Upload' ? <>
                <h3>Old Stats</h3>

                <InvoicesByState dues={invoicesPending} centers={[...educationCentersList, ...educationCentersTrialsList]} />

                <CsvUploader allEducationCenters={[...educationCentersList, ...educationCentersTrialsList]} fetchInvoicesPending={fetchInvoicesPending} />
            </>
                :
                page === 'Calendar' ? <>

                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <h3 style={{ marginTop: '12px', marginBottom: '-10px' }}>Sessions ({filteredEvents.length}) </h3>
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '12px', marginRight: '20px' }}>
                            <button style={{ padding: 4, marginTop: 0 }} onClick={() => { setHeight(height - 200) }}>-</button>
                            <p style={{ margin: '0 4px' }}>Cell Height</p>
                            <button style={{ padding: 4, marginTop: 0 }} onClick={() => { setHeight(height + 200) }}>+</button>
                        </div>
                    </div>

                    {returnSessionFilters()}
                    <ModalComp showModal={!!showDeletePopup} setShowModal={setShowDeletePopup}>
                        <h2>Delete Options</h2>
                        <button onClick={deleteThisEvent}> Delete This Event Alone</button>
                        <button onClick={deleteEventFromNow}> Delete Events From Now</button>
                        <button className="textButton" style={{ marginTop: '20px' }} onClick={() => setShowDeletePopup(false)}> Cancel</button>
                    </ModalComp>
                    <ModalComp showModal={showConfirmAdminOnboardingPopup} setShowModal={setShowConfirmAdminOnboardingPopup}>
                        <h2>Trigger Onboarding Again?</h2>
                        <p>This will require the center admin to complete onboarding again.</p>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <button onClick={handleConfirmAdminOnboardingAgain}>Confirm</button>
                            <button className="secondary" onClick={() => setShowConfirmAdminOnboardingPopup(false)}>Cancel</button>
                        </div>
                    </ModalComp>

                    <div style={{ display: 'flex', width: '100%' }}>
                        <div style={{ width: '200px', display: 'flex', flexDirection: 'column' }}>
                            {returnedUsers.sort((a, b) => a.firstName.toLowerCase() > b.firstName.toLowerCase() ? 1 : -1).filter(r => filteredEvents.find(event => (r.id === event.coaches[0].value) || (event.coaches[1] && r.id === event.coaches[1].value) ? true : false)).map(r => <div onClick={() => toggleCoachFilter(r.id)} style={{ marginTop: '4px', fontSize: '14px', fontWeight: coachFilter.includes(r.id) ? 'bold' : 'normal', backgroundColor: r.color || 'black', color: 'white', borderRadius: '12px', padding: '2px 4px', marginBottom: '2px' }}>{r.firstName + ' ' + r.lastName}</div>)}
                        </div>
                        <div style={{ display: 'flex', width: 'calc(100% - 220px)' }} className="calendar-container">
                            <Scheduler
                                ref={calendarRef}
                                key={height}
                                view={viewMode}
                                height={height}
                                onViewChange={setViewMode}
                                month={
                                    {
                                        startHour: 9,
                                        endHour: 17,
                                        weekStartOn: 0
                                    }
                                }

                                week={{
                                    startHour: 8,
                                    endHour: 17,
                                }}
                                draggable={false}
                                onSelectedDateChange={setCalendarDate}
                                onEventClick={(event) => {

                                }}
                                customEditor={event => isStaffUser ? <></> : <CustomEditor event={event} />}
                                viewerExtraComponent={(fields, event) => isStaffUser ? <></> : <ViewerComponent event={event} />}
                                agenda={false}
                                onDelete={(v) => !isStaffUser && handleDelete(v)}
                                events={filteredEvents}
                            />
                        </div>
                    </div>

                </> : page === 'Centers' ? <>

                    {viewCenter ? <>
                        <button className="textButton" onClick={() => setViewCenter('')}> {"<-Back"}</button>

                        <h2>{viewCenter.name}</h2>

                        {!isStaffUser && <div>
                            <h3 className="text-lg font-bold mt-4" style={{ color: 'red' }}>Invoices Pending</h3>
                            <ul>
                                {invoicesPending.find(r => r.center === ((viewCenter.invoiceName && viewCenter.invoiceName.trim()) || viewCenter.name.trim())) && [invoicesPending.find(r => r.center === ((viewCenter.invoiceName && viewCenter.invoiceName.trim()) || (viewCenter.name && viewCenter.name.trim())))].filter(r => r).map((item, idx) => <li key={idx} className="mb-3">
                                    <p>
                                        <strong>{item.center}</strong> — Total Pending:{" "}
                                        {item.total.toFixed(2)}
                                    </p>
                                    <ul className="ml-4 list-disc">
                                        {item.dues.map((d, i) => (
                                            <li key={i}>
                                                Amount: {d.amount}, Due: {d.dueDate}, InvoiceNumber: {d.InvoiceNumber}
                                            </li>
                                        ))}
                                    </ul>
                                </li>)}
                            </ul>
                        </div>}

                        <table>
                            <thead>
                                <tr>
                                    {['Address', 'Phone', 'Email', 'Program Code', 'Start Date', 'End Date', 'Director Name', 'Notes', 'Categories', 'Coaches', 'Status', 'Closed Reason Type', 'Closed Reason'].map(r => <th key={r}>
                                        {r}
                                    </th>)}
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    {[viewCenter.address, viewCenter.phone, viewCenter.email, viewCenter.programCode || '-', viewCenter.startDate ? format(new Date(viewCenter.startDate), 'dd MMM yyyy') : '', viewCenter.closedDate ? format(new Date(viewCenter.closedDate), 'dd MMM yyyy') : '',
                                    viewCenter.directorName, viewCenter.notes, `${viewCenter.categories.join(', ')}`,
                                    `${viewCenter.coaches.map(r => r.label).join(', ')}`, viewCenter.status, viewCenter.closedType || '-', viewCenter.closedDesc || '-'].map(r => <td key={r}>{r}</td>)}
                                </tr>
                            </tbody>
                        </table>


                        <ModalComp showModal={!!showDeleteFeedbackPopup} setShowModal={setShowDeleteFeedbackPopup}>
                            <h2>Delete Feedback</h2>
                            <div style={{ display: 'flex', gap: '40px' }}>
                                <button onClick={deleteFeedback}> Delete</button>
                                <button style={{ marginTop: '20px' }} onClick={() => setShowDeleteFeedbackPopup(false)}> Cancel</button>
                            </div>
                        </ModalComp>

                        <ModalComp showModal={!!showConfirmResendAdminInvitePopup} setShowModal={setShowConfirmResendAdminInvitePopup}>
                            <h2>Resend Center Admin Invite</h2>
                            <p>This will generate a new password and email fresh login details to this center admin. Their old password will stop working.</p>
                            <div style={{ display: 'flex', gap: '40px' }}>
                                <button disabled={resendingAdminInvite} onClick={handleResendAdminInvite}>{resendingAdminInvite ? 'Sending...' : 'Resend Invite'}</button>
                                <button style={{ marginTop: '20px' }} disabled={resendingAdminInvite} onClick={() => setShowConfirmResendAdminInvitePopup(false)}>Cancel</button>
                            </div>
                        </ModalComp>


                        <h2 style={{ textDecorationLine: visibleCenterSection === 'Onboarding/Trial Steps/ Invoices' ? 'underline' : '' }} onClick={() => setVisibleCenterSection('Onboarding/Trial Steps/ Invoices')}>Onboarding/Trial Steps/ Invoices</h2>
                        {visibleCenterSection === 'Onboarding/Trial Steps/ Invoices' && <>
                            <div style={{ display: 'flex', gap: '100px' }}>
                                {viewCenter.status === 'New Center' && <div>
                                    <h3>Onboarding Steps</h3>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                        {onboardingStepsOptions.map((row, index) => <Checkbox errors={[]} style={row.hidden ? { display: 'none' } : {}} label={row.label} value={addEducationCenterCompletedOnboardingSteps.includes(index)} setValue={() => { setAddEducationCenterCompletedOnboardingSteps(addEducationCenterCompletedOnboardingSteps.includes(index) ? addEducationCenterCompletedOnboardingSteps.filter(r => r !== index) : [...addEducationCenterCompletedOnboardingSteps, index]) }} />)}
                                    </div>
                                    {!isStaffUser && <button style={{ width: '300px' }} onClick={updateOnboardingSteps}> Update Onboarding Steps </button>}
                                </div>}

                                {viewCenter.status === 'Trial' && <div>
                                    <h3>Trial Steps</h3>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                        {trialStepsOptions.map((row, index) => <Checkbox errors={[]} label={row.label} value={addEducationCenterCompletedTrialSteps.includes(index)} setValue={() => { setAddEducationCenterCompletedTrialSteps(addEducationCenterCompletedTrialSteps.includes(index) ? addEducationCenterCompletedTrialSteps.filter(r => r !== index) : [...addEducationCenterCompletedTrialSteps, index]) }} />)}
                                    </div>
                                    {!isStaffUser && <button style={{ width: '300px' }} onClick={updateTrialSteps}> Update Trial Steps </button>}
                                </div>}
                            </div>
                        </>}


                        <h2 style={{ textDecorationLine: visibleCenterSection === 'Center Admin/Owner' ? 'underline' : '' }} onClick={() => setVisibleCenterSection('Center Admin/Owner')}>Center Admin/Owner</h2>
                        {visibleCenterSection === 'Center Admin/Owner' && <>

                            {!addingAdmin ? <>
                                <button style={{ width: '200px', marginLeft: 'auto', marginBottom: '10px' }} onClick={() => setAddingAdmin(true)}>Add Admin</button>
                                {viewCenter.admin ? <table>
                                    <thead>
                                        <tr>
                                            <th>
                                                Name
                                            </th>
                                            <th>Email</th>
                                            {!isStaffUser && <th>Action</th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{viewCenter.admin.firstName} {viewCenter.admin.lastName}</td>
                                            <td>{viewCenter.admin.email}</td>
                                            {!isStaffUser && <td><button className="textButton" onClick={() => setShowConfirmResendAdminInvitePopup(true)}>Resend Invite</button></td>}
                                        </tr>
                                    </tbody>
                                </table> : <p>No admin assigned yet.</p>}

                                {
                                    viewCenter.admin && viewCenter.onboardingCompleted && viewCenter.onboardingDetails && <>
                                        <table style={{ marginTop: '10px' }}>
                                            <tbody>
                                                <tr>
                                                    <th>Feedback Name</th>
                                                    <td>{viewCenter.onboardingDetails.feedbackName}</td>
                                                </tr>
                                                <tr>
                                                    <th>Feedback Email</th>
                                                    <td>{viewCenter.onboardingDetails.feedbackEmail}</td>
                                                </tr>
                                                <tr>
                                                    <th>Break for Holidays</th>
                                                    <td>{viewCenter.onboardingDetails.breakForHolidays}</td>
                                                </tr>
                                                <tr>
                                                    <th>Invoice Name</th>
                                                    <td>{viewCenter.onboardingDetails.invoiceName}</td>
                                                </tr>
                                                <tr>
                                                    <th>Invoice Email</th>
                                                    <td>{viewCenter.onboardingDetails.invoiceEmail}</td>
                                                </tr>
                                                <tr>
                                                    <th>Aware Of</th>
                                                    <td>{viewCenter.onboardingDetails.awareOf}</td>
                                                </tr>
                                                <tr>
                                                    <th>Aware Of Details</th>
                                                    <td>{viewCenter.onboardingDetails.awareOfDetails}</td>
                                                </tr>
                                                <tr>
                                                    <th>Reschedule Preference</th>
                                                    <td>{viewCenter.onboardingDetails.reschedulePreference}</td>
                                                </tr>
                                                <tr>
                                                    <th>Reschedule Preference Day</th>
                                                    <td>{viewCenter.onboardingDetails.reschedulePreferenceDay}</td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <h3 style={{ marginBottom: '0px' }}>Rooms</h3>
                                        {viewCenter.rooms?.map((room, i) => (
                                            <table key={i} style={{ marginTop: '20px' }}>
                                                <thead>
                                                    <th colSpan={2}>Room {i + 1}</th>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <th>Room Name</th>
                                                        <td>{room.roomName}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Kids in Room</th>
                                                        <td>{room.kidsInRoom}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Room Type</th>
                                                        <td>{room.roomType}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Staff Profile First Name</th>
                                                        <td>{room.roomLeader?.firstName}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Staff Profile Last Name</th>
                                                        <td>{room.roomLeader?.lastName}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        ))}
                                        <h3 style={{ marginTop: '30px', marginBottom: '10px' }}>Staff Profiles</h3>
                                        {!addingStaffProfile && <button style={{ width: '220px', marginBottom: '12px' }} onClick={handleStartAddStaffProfile}>Add Staff Profile</button>}
                                        {addingStaffProfile && <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', maxWidth: '420px', marginBottom: '20px' }}>
                                            <Input bold label={'Profile Name'} type={'text'} value={staffProfileName} setValue={setStaffProfileName} errors={[]} />
                                            <Input bold label={'Room Name'} type={'text'} value={staffProfileRoomName} setValue={setStaffProfileRoomName} errors={[]} />
                                            <Input bold label={'Room Type'} type={'text'} value={staffProfileRoomType} setValue={setStaffProfileRoomType} errors={[]} />
                                            <Input bold label={'Profile Type'} type={'text'} value={staffProfileType || 'manual'} setValue={() => { }} errors={[]} disabled />
                                            <Checkbox label={'Active'} value={staffProfileIsActive} setValue={() => setStaffProfileIsActive(!staffProfileIsActive)} errors={[]} />
                                            <div style={{ display: 'flex' }}>
                                                <button className="secondary" onClick={resetStaffProfileForm}>Cancel</button>
                                                <button onClick={handleSaveStaffProfile}>{editingStaffProfileId ? 'Update Profile' : 'Save Profile'}</button>
                                            </div>
                                        </div>}
                                        <div style={{ overflowX: 'auto', maxWidth: '100%' }}>
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th>Name</th>
                                                        <th>Profile Type</th>
                                                        <th>Room Name</th>
                                                        <th>Room Type</th>
                                                        <th>Active</th>
                                                        <th>Last Selected</th>
                                                        <th>Last Feedback</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {(viewCenter.staffProfiles || []).sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0)).map((profile) => <tr key={profile.id}>
                                                        <td>{profile.name}</td>
                                                        <td>{profile.profileType || 'manual'}</td>
                                                        <td>{profile.roomName || '-'}</td>
                                                        <td>{profile.roomType || '-'}</td>
                                                        <td>{profile.isActive === false ? 'No' : 'Yes'}</td>
                                                        <td>{profile.lastSelectedAt ? format(new Date(profile.lastSelectedAt), 'dd MMM yyyy HH:mm') : '-'}</td>
                                                        <td>{profile.lastFeedbackAt ? format(new Date(profile.lastFeedbackAt), 'dd MMM yyyy HH:mm') : '-'}</td>
                                                        <td><button className="textButton" onClick={() => handleStartEditStaffProfile(profile)}>Edit</button></td>
                                                    </tr>)}
                                                </tbody>
                                            </table>
                                        </div>
                                        <button style={{ width: '300px' }} onClick={() => setShowConfirmAdminOnboardingPopup(true)}>Trigger Onboarding for Admin Again</button>
                                    </>
                                }
                            </> :

                                <>
                                    <div style={{ display: 'flex', gap: '20px' }}>
                                        <div style={{ width: '300px' }}>
                                            <Input bold label={'Admin First Name'} type={'text'} value={adminFirstName} setValue={setAdminFirstName} errors={[]} />
                                        </div>
                                        <div style={{ width: '300px' }}>
                                            <Input bold label={'Admin Last Name'} type={'text'} value={adminLastName} setValue={setAdminLastName} errors={[]} />
                                        </div>
                                        <div style={{ width: '300px' }}>
                                            <Input bold label={'Admin Email'} type={'text'} value={adminEmail} setValue={setAdminEmail} errors={[]} />
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex' }}>
                                        <button className="secondary" onClick={() => setAddingAdmin(false)}>Cancel</button>
                                        <button disabled={!adminFirstName || !adminLastName || !adminEmail || checkEmailInValid(adminEmail)} onClick={handleAddAdmin}>Save</button>
                                    </div>
                                </>}

                        </>}
                        {!isStaffUser && <h2 style={{ textDecorationLine: visibleCenterSection === 'Center Staff Feedbacks' ? 'underline' : '' }} onClick={() => setVisibleCenterSection('Center Staff Feedbacks')}>Center Staff Feedbacks</h2>}
                        {visibleCenterSection === 'Center Staff Feedbacks' && <>
                            <div style={{ overflowX: 'auto', maxWidth: '100%' }}>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>
                                                Date
                                            </th>
                                            <th>
                                                Coach Name
                                            </th>
                                            <th>
                                                Week Activity
                                            </th>
                                            <th>
                                                Activity
                                            </th>
                                            <th>
                                                Engagement of Children
                                            </th>
                                            <th>
                                                Structure/Quality of Session
                                            </th>
                                            <th>
                                                Feedback
                                            </th>
                                            <th>
                                                Staff Name
                                            </th>
                                            <th>
                                                Staff Profile
                                            </th>
                                            <th>
                                                Room Type
                                            </th>
                                            <th>
                                                Room Name
                                            </th>

                                        </tr>
                                    </thead>
                                    <tbody>

                                        {centerStaffFeedbacks.map(row => <tr key={row.id}>

                                            <td>{format(new Date(row.created), 'dd MMM yyyy')}</td>
                                            <td>{row.coachName}</td>
                                            <td>{row.weekActivity}</td>
                                            <td>{row.activity}</td>
                                            <td>{row.engagement}</td>
                                            <td>{row.lesson}</td>
                                            <td>{row.feedback}</td>
                                            <td>{row.userName}</td>
                                            <td>{row.staffProfileName || '-'}</td>
                                            <td>{row.roomType}</td>
                                            <td>{row.roomName}</td>

                                        </tr>)}
                                    </tbody>
                                </table>
                            </div>
                        </>}


                        <h2 style={{ textDecorationLine: visibleCenterSection === 'Feedbacks' ? 'underline' : '' }} onClick={() => setVisibleCenterSection('Feedbacks')}>Feedbacks</h2>
                        {visibleCenterSection === 'Feedbacks' && <>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <h4 style={{ marginTop: '12px', marginBottom: '-10px', marginRight: '5px' }}>Name Filter:</h4>
                                <Tabs tabs={['All', ...nameFilterOptionsFeedback]} currentTab={nameFilter} setCurrentTab={setNameFilter} />
                            </div>

                            <div style={{ overflowX: 'auto', maxWidth: '100%' }}>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>
                                                Date
                                            </th>
                                            <th>
                                                Title
                                            </th>
                                            <th>
                                                Name
                                            </th>
                                            <th>
                                                Center
                                            </th>
                                            <th>
                                                Coach
                                            </th>
                                            <th>
                                                Description
                                            </th>
                                            <th>
                                                Avg Rating
                                            </th>
                                            <th>
                                                Punctuality
                                            </th>
                                            <th>
                                                Attendance
                                            </th>
                                            <th>
                                                Interaction
                                            </th>
                                            <th>
                                                Coach Quality
                                            </th>
                                            <th>
                                                Program Quality
                                            </th>
                                            <th>
                                                Actions
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {centerFeedbacks.filter(r => nameFilter !== 'All' ? r.name === nameFilter : true).map(row => <tr key={row.id}>

                                            <td>{format(new Date(row.created), 'dd MMM yyyy')}</td>
                                            <td>{row.title}</td>
                                            <td>{row.name}</td>
                                            <td>{viewCenter.name}</td>
                                            <td>{row.coach.label}</td>
                                            <td>{row.desc}</td>
                                            <td>{row.avgRating}</td>
                                            <td>{row.punctuality}</td>
                                            <td>{row.attendance}</td>
                                            <td>{row.interaction}</td>
                                            <td>{row.coachQuality}</td>
                                            <td>{row.programQuality}</td>
                                            <td>
                                                <button className="textButton" onClick={() => { setFeedbackDate(new Date(row.created)); setFeedbackId(row.id); setFeedbackTitle(row.title); setFeedbackName(row.name); setFeedbackSubmittedBy(row.submittedBy ? (feedbackSubmitters.find(option => option.value === row.submittedBy) || { label: row.name, value: row.submittedBy }) : ''); setFeedbackDesc(row.desc); setFeedbackCoach(row.coach); setPunctualityRating(updateDropdownValue(row.punctuality)); setAttendanceRating(updateDropdownValue(row.attendance)); setInteractionRating(updateDropdownValue(row.interaction)); setQualityCoachRating(updateDropdownValue(row.coachQuality)); setQualityProgramRating(updateDropdownValue(row.programQuality)); setShowAddFeedbackModal(true) }}>Edit</button>
                                                <button className="textButton" onClick={() => { setShowDeleteFeedbackPopup(row.id) }}>Delete</button>
                                            </td>
                                        </tr>)}
                                    </tbody>
                                </table>
                            </div>
                            <button style={{ width: '200px', padding: '10px', marginLeft: 'auto' }} onClick={() => { setFeedbackDate(new Date()); setShowAddFeedbackModal(true); setFeedbackTitle(''); setFeedbackName(''); setFeedbackSubmittedBy(isStaffUser ? { label: userInfo.firstName || userInfo.email, value: userInfo.id } : ''); setFeedbackId(''); setFeedbackCoach(''); setFeedbackDesc(''); setPunctualityRating(''); setAttendanceRating(''); setInteractionRating(''); setQualityCoachRating(''); setQualityProgramRating(''); }}>Add Feedback</button>
                        </>}

                        {!isStaffUser && <h2 style={{ textDecorationLine: visibleCenterSection === 'Attendance' ? 'underline' : '' }} onClick={() => setVisibleCenterSection('Attendance')}>Attendance</h2>}
                        {visibleCenterSection === 'Attendance' && <>
                            <h3>Attended ({attendedSessionsOfCenter.length})</h3>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                {attendedSessionsOfCenter.map(r => <p style={{ margin: 0 }}>{format(new Date(r.start), 'dd MMM yyyy hh:mm a')}</p>)}
                            </div>

                            <h3>Missed ({missedSessionsOfCenter.length})</h3>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                {missedSessionsOfCenter.map(r => <p style={{ margin: 0 }}>{format(new Date(r.start), 'dd MMM yyyy hh:mm a')}</p>)}
                            </div>

                            <h3>Covered ({coveredSessionsOfCenter.length})</h3>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                {coveredSessionsOfCenter.map(r => <p style={{ margin: 0 }}>{format(new Date(r.start), 'dd MMM yyyy hh:mm a')}</p>)}
                            </div>

                            <h3>Rescheduled ({rescheduledSessionsOfCenter.length})</h3>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                {rescheduledSessionsOfCenter.map(r => <p style={{ margin: 0 }}>{format(new Date(r.start), 'dd MMM yyyy hh:mm a')}</p>)}
                            </div>
                        </>}

                        <ModalComp showModal={showAddFeedbackModal} setShowModal={setShowAddFeedbackModal}>
                            <h2> {feedbackId ? 'Edit' : 'Add'} Feedback</h2>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                <div style={{ width: '450px', marginTop: '-15px' }}>
                                    <Input bold label={'Title'} type={'text'} value={feedbackTitle} setValue={setFeedbackTitle} errors={[]} />
                                </div>
                                <MyCalendar label={'Date'} startDate={feedbackDate} setStartDate={setFeedbackDate} />
                                <div style={{ width: '200px' }}>
                                    <Dropdown label={'Submitted By'} options={feedbackSubmitters} errorFields={[]} value={feedbackSubmittedBy} setValue={setFeedbackSubmittedBy} />
                                </div>
                            </div>
                            <Input bold disabled label={'Center'} type={'text'} value={viewCenter.name} setValue={() => { }} errors={[]} />

                            <Dropdown label={'Coach'} options={returnedUsers.map(r => ({ label: r.firstName + ' ' + r.lastName, value: r.id }))} errorFields={[]} value={feedbackCoach} setValue={setFeedbackCoach} />

                            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                <Dropdown label={'Punctuality'} options={[10, 9, 8, 7, 6, 5, 4, 3, 2, 1].map(r => ({ label: r, value: r }))} errorFields={[]} value={punctualityRating} setValue={setPunctualityRating} />
                                <Dropdown label={'Attendance'} options={[10, 9, 8, 7, 6, 5, 4, 3, 2, 1].map(r => ({ label: r, value: r }))} errorFields={[]} value={attendanceRating} setValue={setAttendanceRating} />
                                <Dropdown label={'Interaction'} options={[10, 9, 8, 7, 6, 5, 4, 3, 2, 1].map(r => ({ label: r, value: r }))} errorFields={[]} value={interactionRating} setValue={setInteractionRating} />
                                <Dropdown label={'Quality Coach'} options={[10, 9, 8, 7, 6, 5, 4, 3, 2, 1].map(r => ({ label: r, value: r }))} errorFields={[]} value={qualityCoachRating} setValue={setQualityCoachRating} />
                                <Dropdown label={'Quality Program'} options={[10, 9, 8, 7, 6, 5, 4, 3, 2, 1].map(r => ({ label: r, value: r }))} errorFields={[]} value={qualityProgramRating} setValue={setQualityProgramRating} />
                            </div>

                            <label style={{ display: 'flex', marginTop: '15px', fontSize: '15px', color: '#000', fontWeight: '700' }}>Feedback</label>
                            <textarea value={feedbackDesc} onChange={e => setFeedbackDesc(e.target.value)}></textarea>

                            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                <button disabled={!feedbackTitle || !feedbackCoach || !feedbackDate || !feedbackSubmittedBy} onClick={handleAddFeedback}>Save</button>
                                <button className="textButton" style={{ marginTop: '25px' }} onClick={() => setShowAddFeedbackModal(false)}>Cancel</button>
                            </div>
                        </ModalComp>

                    </> : <>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', alignItems: 'center', justifyContent: 'space-evenly' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <h4 style={{ marginTop: '12px', marginBottom: '-10px', marginRight: '5px' }}>Status:</h4>
                                <Tabs tabs={['All', ...educationCenterStatuses]} currentTab={statusFilter} setCurrentTab={setStatusFilter} />
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center' }} title="Click the selected option again to show all centres">
                                <h4 style={{ marginTop: '12px', marginBottom: '-10px', marginRight: '5px', whiteSpace: 'nowrap' }}>In-House:</h4>
                                <Tabs tabs={['Yes', 'No']} currentTab={inHouseFilter} setCurrentTab={value => setInHouseFilter(current => current === value ? 'All' : value)} />
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <h4 style={{ marginTop: '12px', marginBottom: '-10px', marginRight: '5px' }}>4 Session Notice:</h4>
                                <Tabs tabs={['All', 'Yes', 'No']} currentTab={fourSessionNoticeFilter} setCurrentTab={setFourSessionNoticeFilter} />
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <h4 style={{ marginTop: '12px', marginBottom: '-10px', marginRight: '5px' }}>State Filter:</h4>
                                <Tabs tabs={['All', ...cityFilterOptions]} currentTab={cityFilter} setCurrentTab={setCityFilter} />
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <h4 style={{ marginTop: '12px', marginBottom: '-10px', marginRight: '5px' }}>Category Filter:</h4>
                                <Tabs tabs={['All', 'Sports', 'Music', 'Yoga', 'Gymnastics', 'Sensory Fusion']} currentTab={categoryFilter} setCurrentTab={setCategoryFilter} />
                            </div>
                        </div>
                        {renderTownFilter()}

                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <h3 style={{ marginTop: '12px', }}>Centers ({displayedEducationCenters.length})  Avg: {displayedEducationCenters.filter(r => r.avgRating && r.avgRating > 0).reduce((avg, value, _, { length }) => avg + value.avgRating / length, 0).toFixed(1)}</h3>
                            <button style={{ width: '120px', padding: '10px', marginLeft: 'auto', marginBottom: '20px', marginTop: 0 }} onClick={() => { setShowAddEducationCenter(true); setAddEducationCenterId(''); setAddEducationCenterAddress(''); setAddEducationCenterCoords(''); setAddEducationCenterText(''); setAddEducationCenterInvoiceName(''); setAddEducationCenterStudentCount('0'); setAddEducationCenterProgramCode(''); setAddEducationCenterCity(''); setAddEducationCenterTown(''); setAddEducationCenterPhone(''); setAddEducationCenterDirectorName(''); setAddEducationCenterManagedBy(''); setAddEducationCenterStaffDeliverSessions(false); setAddEducationCenterSoldBy(''); setAddEducationCenterMikeyAppPoster({ label: 'No', value: 'No' }); setAddEducationCenterCategories([]); setAddEducationCenterNotes(''); setAddEducationCenterCoaches([]); setAddEducationCenterStatus(''); setAddEducationCenterStatusPrevious(''); setAddEducationCenterTrialReason(''); setAddEducationCenterEmail(''); setAddEducationCenterPointsType(''); setAddEducationCenterPoints(''); setAddEducationCenterStartDate(new Date()); setAddEducationCenterClosedDate(''); setAddEducationCenterClosedDesc(''); setAddEducationCenterClosedType(''); setAddEducationCenterFourSessionNotice({ label: 'No', value: 'No' }); setAddEducationCenterFourSessionNoticeReason('') }}>+ Add Center</button>
                        </div>

                        {['Trial', 'Trial Closed', 'Offer Closed', 'Short Bookings Closed', 'Closed'].includes(statusFilter) && <div style={{ marginTop: '-20px' }}>
                            <Tabs tabs={Array.from({ length: new Date().getFullYear() - 2024 + 1 }, (_, idx) => `${2024 + idx}`)} currentTab={yearFilter} setCurrentTab={setYearFilter} />
                            {['Closed', 'Offer Closed', 'Short Bookings Closed'].includes(statusFilter) && <Tabs tabs={['All', 'Our Fault', 'Not Our Fault']} currentTab={closedReasonFilter} setCurrentTab={setClosedReasonFilter} />}
                            {statusFilter === 'Trial' && <Tabs tabs={['All', 'Signed Up', 'Didn\'t Sign Up']} currentTab={trialFilter} setCurrentTab={setTrialFilter} />}
                        </div>}

                        <ModalComp showModal={showAddEducationCenter} setShowModal={setShowAddEducationCenter}>
                            <h2>{addEducationCenterId ? 'Edit' : 'Add New'}  Education Center</h2>
                            <div style={{ display: 'flex', gap: '20px' }}>
                                <Input bold style={{ width: '300px' }} label={'Name'} type={'text'} value={addEducationCenterText} setValue={setAddEducationCenterText} errors={[]} />
                                {/* <Input bold style={{ width: '400px' }} label={'Address'} refProp={ref} type={'text'} value={addEducationCenterAddress} setValue={setAddEducationCenterAddress} errors={[]} /> */}
                                <div style={{ marginTop: 'auto' }}>
                                    <label style={{ display: 'flex', marginTop: '25px', fontWeight: '800', fontSize: '14px', color: '#000' }}>Address</label>

                                    <AutoComplete
                                        apiKey={'AIzaSyAG_p8MmFkQM50X8iGEbavuVVu4fnMed1I'}

                                        options={{
                                            types: ["address"],
                                            componentRestrictions: { country: "au" },
                                        }}
                                        defaultValue={addEducationCenterAddress}
                                        onPlaceSelected={(place) => { setAddEducationCenterCoords({ lat: place.geometry.location.lat(), lng: place.geometry.location.lng() }); setAddEducationCenterAddress(place.formatted_address); }}
                                        style={{ width: '400px' }}
                                    />
                                </div>
                                <Input bold label={'Director Name'} type={'text'} value={addEducationCenterDirectorName} setValue={setAddEducationCenterDirectorName} errors={[]} />

                            </div>
                            <div style={{ display: 'flex', gap: '20px' }}>
                                <div style={{ width: '180px', marginTop: '10px' }}>
                                    <Dropdown label={'State'} options={stateOptions.map(r => ({ label: r, value: r }))} errorFields={[]} value={updateDropdownValue(addEducationCenterCity)} setValue={v => setAddEducationCenterCity(v ? v.value : '')} />
                                </div>
                                <div style={{ width: '220px', marginTop: '10px' }}>
                                    <Dropdown label={'Town'} options={getTownOptionsForState(addEducationCenterCity).map(r => ({ label: r, value: r }))} errorFields={[]} value={updateTownDropdownValue(addEducationCenterTown)} setValue={v => setAddEducationCenterTown(v ? v.value : '')} />
                                </div>
                                <Input bold label={'Phone Number'} type={'text'} value={addEducationCenterPhone} setValue={setAddEducationCenterPhone} errors={[]} />
                                <Input bold label={'Email'} type={'text'} value={addEducationCenterEmail} setValue={setAddEducationCenterEmail} errors={[]} />
                                <Input bold disabled label={'Program Code'} type={'text'} value={addEducationCenterProgramCode || 'Auto-generated on save'} setValue={() => { }} errors={[]} />
                                <div style={{ width: '200px', marginTop: '10px' }}>
                                    <Dropdown label={'Points Type'} options={["Weekly", "Fortnightly", "Monthly", "Other"].map(r => ({ label: r, value: r }))} errorFields={[]} value={addEducationCenterPointsType} setValue={setAddEducationCenterPointsType} />
                                </div>
                                <Input bold label={'Points'} type={'text'} value={addEducationCenterPoints} setValue={setAddEducationCenterPoints} errors={[]} />

                            </div>
                            <div style={{ display: 'flex', gap: '20px' }}>
                                <div style={{ marginTop: '12px', marginLeft: "40px" }}>
                                    <MyCalendar label={'Start Date'} startDate={addEducationCenterStartDate} setStartDate={setAddEducationCenterStartDate} />
                                </div>
                                <div style={{ width: '300px', marginTop: '10px' }}>
                                    <Dropdown label={'Status'} options={educationCenterStatuses.map(r => ({ label: r, value: r }))} errorFields={[]} value={addEducationCenterStatus} setValue={setAddEducationCenterStatus} />
                                </div>
                                <div style={{ width: '200px', marginTop: '10px' }}>
                                    <Dropdown label={'4 Session Notice'} options={['Yes', 'No'].map(r => ({ label: r, value: r }))} errorFields={[]} value={addEducationCenterFourSessionNotice} setValue={setAddEducationCenterFourSessionNotice} />
                                </div>

                                <Input bold style={{ width: '300px' }} label={'Invoice Name'} type={'text'} value={addEducationCenterInvoiceName} setValue={setAddEducationCenterInvoiceName} errors={[]} />
                                <Input bold style={{ width: '120px' }} label={'Students Count'} type={'text'} value={addEducationCenterStudentCount} setValue={setAddEducationCenterStudentCount} errors={[]} />

                                {addEducationCenterId && addEducationCenterStatus && /*['Trial Closed', 'Closed'].includes(addEducationCenterStatus.value) && */ <div style={{ marginTop: '10px', }}>
                                    <MyCalendar label={'Closed Date'} startDate={addEducationCenterClosedDate} setStartDate={setAddEducationCenterClosedDate} />
                                </div>}

                                {addEducationCenterId && addEducationCenterStatus && closedEducationCenterStatuses.includes(addEducationCenterStatus.value) && <div style={{ width: '300px', marginTop: '10px' }}>
                                    <Dropdown label={'Closed Reason Type'} options={['Our Fault', 'Not Our Fault'].map(r => ({ label: r, value: r }))} errorFields={[]} value={addEducationCenterClosedType} setValue={setAddEducationCenterClosedType} />
                                </div>}


                                {(addEducationCenterStatus && addEducationCenterStatus.value !== 'Trial') && (addEducationCenterStatusPrevious && addEducationCenterStatusPrevious.value === 'Trial') && <Input bold style={{ width: '300px' }} label={'Reason'} type={'text'} value={addEducationCenterTrialReason} setValue={setAddEducationCenterTrialReason} errors={[]} />}
                            </div>

                            {addEducationCenterFourSessionNotice && addEducationCenterFourSessionNotice.value === 'Yes' && <>
                                <label style={{ display: 'flex', marginTop: '15px', fontSize: '15px', color: '#000', fontWeight: '700' }}>4 Session Notice Reason</label>
                                <textarea value={addEducationCenterFourSessionNoticeReason} style={{ height: '100px' }} onChange={e => setAddEducationCenterFourSessionNoticeReason(e.target.value)}></textarea>
                            </>}



                            {addEducationCenterId && addEducationCenterStatus && closedEducationCenterStatuses.includes(addEducationCenterStatus.value) && <>
                                <label style={{ display: 'flex', marginTop: '15px', fontSize: '15px', color: '#000', fontWeight: '700' }}>{addEducationCenterStatus.value === 'Offer Closed' ? 'Offer Closed Reason' : 'Closed Reason Notes'}</label>
                                <textarea value={addEducationCenterClosedDesc} style={{ height: '100px' }} onChange={e => setAddEducationCenterClosedDesc(e.target.value)}></textarea>
                            </>}


                            <label style={{ display: 'flex', marginTop: '15px', fontSize: '15px', color: '#000', fontWeight: '700' }}>Notes</label>
                            <textarea value={addEducationCenterNotes} style={{ height: '100px' }} onChange={e => setAddEducationCenterNotes(e.target.value)}></textarea>


                            <div style={{ display: 'flex', gap: '20px' }}>
                                <div style={{ width: '250px' }}>
                                    <Dropdown isMulti label={'Categories'} options={['Sports', 'Music', 'Yoga', 'Gymnastics', 'Sensory Fusion'].map(r => ({ label: r, value: r }))} errorFields={[]} value={addEducationCenterCategories} setValue={setAddEducationCenterCategories} />
                                </div>
                                <div style={{ width: '250px' }}>
                                    <Dropdown label={'Sold By'} options={feedbackSubmitters.map(option => ({ label: option.label, value: option.label }))} errorFields={[]} value={addEducationCenterSoldBy} setValue={setAddEducationCenterSoldBy} />
                                </div>
                                <div style={{ width: '250px' }}>
                                    <label style={{ display: 'block', margin: '16px 0' }}>
                                        <input type="checkbox" checked={addEducationCenterStaffDeliverSessions} onChange={e => setAddEducationCenterStaffDeliverSessions(e.target.checked)} /> Centre staff deliver sessions
                                        <small style={{ display: 'block' }}>Enable coach videos and PDFs for this centre’s selected programs, unlocked week by week in the mobile app.</small>
                                    </label>
                                    <Dropdown label={'Managed By'} options={["Nug", "Rhi", "Katie", "Troy", "Viki", "Ashlee"].map(r => ({ label: r, value: r }))} errorFields={[]} value={addEducationCenterManagedBy} setValue={setAddEducationCenterManagedBy} />
                                </div>
                                <div style={{ width: '250px' }}>
                                    <Dropdown label={'Does This Centre Have A Mikey App Poster'} options={['Yes', 'No'].map(r => ({ label: r, value: r }))} errorFields={[]} value={addEducationCenterMikeyAppPoster} setValue={setAddEducationCenterMikeyAppPoster} />
                                </div>
                            </div>

                            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                <button disabled={!addEducationCenterText} onClick={handleAddEducationCenter}>Save</button>
                                <button className="textButton" style={{ marginTop: '25px' }} onClick={() => { setShowAddEducationCenter(false); setConfirmDeleteEducationCenter(false) }}>Cancel</button>
                                <button disabled={!addEducationCenterId} style={{ background: 'red', marginLeft: '50px' }} onClick={handleDeleteEducationCenter}>{confirmDeleteEducationCenter ? 'Confirm Delete?' : 'Delete'}</button>
                            </div>

                        </ModalComp>

                        <table>
                            <thead>
                                <tr>
                                    <th style={{ cursor: 'pointer', textDecorationLine: centerSortConfig.property === 'name' ? 'underline' : 'none' }} onClick={() => { handleSortCenter('name') }}>
                                        Name
                                    </th>
                                    <th>
                                        Address
                                    </th>
                                    <th>Phone</th>
                                    <th>Email</th>
                                    <th>
                                        State
                                    </th>
                                    <th>
                                        Town
                                    </th>
                                    <th>
                                        Program Code
                                    </th>
                                    <th style={{ cursor: 'pointer', textDecorationLine: centerSortConfig.property === 'startDate' ? 'underline' : 'none' }} onClick={() => handleSortCenter('startDate')}>
                                        Start Date
                                    </th>
                                    <th style={{ cursor: 'pointer', textDecorationLine: centerSortConfig.property === 'closedDate' ? 'underline' : 'none' }} onClick={() => handleSortCenter('closedDate')}>
                                        End Date
                                    </th>
                                    {fourSessionNoticeFilter === 'Yes' && <th>
                                        4 Session Reason
                                    </th>}
                                    <th style={{ cursor: 'pointer', textDecorationLine: centerSortConfig.property === 'avgRating' ? 'underline' : 'none' }} onClick={() => handleSortCenter('avgRating')}>
                                        Avg Rating
                                    </th>
                                    <th>
                                        Categories
                                    </th>
                                    <th>
                                        Points Type
                                    </th>
                                    <th>
                                        Points
                                    </th>

                                    <th>
                                        Managed By
                                    </th>
                                    {statusFilter === 'Trial' && <th>
                                        Reason
                                    </th>}

                                    <th style={{ cursor: (statusFilter === 'New Center' || statusFilter === 'Trial') ? 'pointer' : 'default', textDecorationLine: centerSortConfig.property === 'status' ? 'underline' : 'none' }} onClick={() => { (statusFilter === 'New Center' || statusFilter === 'Trial') && handleSortCenter('status') }}>
                                        Status
                                    </th>
                                    {!isStaffUser && <th>
                                        Actions
                                    </th>}
                                </tr>
                            </thead>
                            <tbody>
                                {displayedEducationCenters.map(row => <tr key={row.id}>
                                    {/* <td style={row.isOld ? { textDecoration: 'line-through', textDecorationColor: row.status === 'Trial Closed' ? 'red' : 'green' } : {}} onClick={() => { if (!row.isOld) { setViewCenter(row); setAddEducationCenterCompletedOnboardingSteps(row.onboardingStepsCompleted || []); setAddEducationCenterCompletedTrialSteps(row.trialStepsCompleted || []) } }} className="hover">{row.name} </td> */}
                                    <td onClick={() => { if (!row.isOld) { setViewCenter(row); setAddEducationCenterCompletedOnboardingSteps(row.onboardingStepsCompleted || []); setAddEducationCenterCompletedTrialSteps(row.trialStepsCompleted || []) } }} className="hover">{row.name} </td>
                                    <td style={{ marginLeft: 20 }}>{row.address}</td>
                                    <td style={{ marginLeft: 20 }}>{row.phone}</td>
                                    <td style={{ marginLeft: 20 }}>{row.email}</td>
                                    <td style={{ marginLeft: 20 }}>{row.city}</td>
                                    <td style={{ marginLeft: 20 }}>{row.town}</td>
                                    <td style={{ marginLeft: 20 }}>{row.programCode || '-'}</td>
                                    <td style={{ marginLeft: 20 }}>{row.startDate ? format(new Date(row.startDate), 'dd/MMM/yyyy') : ''}</td>
                                    <td style={{ marginLeft: 20 }}>{row.closedDate ? format(new Date(row.closedDate), 'dd/MMM/yyyy') : ''}</td>
                                    {fourSessionNoticeFilter === 'Yes' && <td style={{ marginLeft: 20 }}>{row.fourSessionNoticeReason || ''}</td>}
                                    <td style={{ marginLeft: 20, backgroundColor: getColorFromAvgRating(row.avgRating || 0) }}>{row.avgRating || 0}</td>
                                    <td style={{ marginLeft: 20 }}>{row.categories.join(', ')}</td>
                                    <td style={{ marginLeft: 20 }}>{row.pointsType}</td>
                                    <td style={{ marginLeft: 20 }}>{row.points}</td>
                                    <td style={{ marginLeft: 20 }}>{row.managedBy}</td>
                                    {statusFilter === 'Trial' && <td style={{ marginLeft: 20 }}>{row.isOld ? ` ${row.trialReason} - Date:${format(new Date(row.trialMoveDate), 'dd/MM/yyyy')}` : 'NA'}</td>}
                                    <td style={{ marginLeft: 20, backgroundColor: getStatusColor(row.status, row.onboardingStepsCompleted || [], row.trialStepsCompleted || []) }}>{row.status} <br />{getStatusNumber(row.status, row.onboardingStepsCompleted || [], row.trialStepsCompleted || [])}</td>
                                    {!isStaffUser && <td style={{ marginLeft: 20 }}>
                                        {!row.isOld && <button className="textButton" onClick={() => {
                                            setAddEducationCenterId(row.id);
                                            setAddEducationCenterAddress(row.address);
                                            setAddEducationCenterCoords(row.addressGeo)
                                            setAddEducationCenterCity(row.city);
                                            setAddEducationCenterTown(row.town || '');
                                            setAddEducationCenterProgramCode(normalizeCenterProgramCode(row.programCode));

                                            setAddEducationCenterPhone(row.phone || '');
                                            setAddEducationCenterEmail(row.email || '');
                                            setAddEducationCenterPointsType(updateDropdownValue(row.pointsType));
                                            setAddEducationCenterManagedBy(updateDropdownValue(row.managedBy));
                                            setAddEducationCenterStaffDeliverSessions(row.staffDeliverSessions === true);
                                            setAddEducationCenterSoldBy(updateDropdownValue(row.soldBy));
                                            setAddEducationCenterMikeyAppPoster(updateDropdownValue(row.mikeyAppPoster || 'No'));
                                            setAddEducationCenterPoints(row.points || '');
                                            setAddEducationCenterDirectorName(row.directorName || '');
                                            setAddEducationCenterStartDate(row.startDate ? new Date(row.startDate) : '');
                                            setAddEducationCenterClosedDate(row.closedDate ? new Date(row.closedDate) : '');
                                            setAddEducationCenterNotes(row.notes || '');
                                            setAddEducationCenterStatus(updateDropdownValue(row.status));
                                            setAddEducationCenterClosedDesc(row.closedDesc || '');
                                            setAddEducationCenterClosedType(updateDropdownValue(row.closedType));
                                            setAddEducationCenterStatusPrevious(updateDropdownValue(row.status));
                                            setAddEducationCenterFourSessionNotice(updateDropdownValue(row.fourSessionNotice || 'No'));
                                            setAddEducationCenterFourSessionNoticeReason(row.fourSessionNoticeReason || '');
                                            setAddEducationCenterTrialReason('');
                                            setAddEducationCenterCategories(row.categories ? row.categories.map(updateDropdownValue) : []); setShowAddEducationCenter(true); setAddEducationCenterText(row.name); setAddEducationCenterCoaches(row.coaches);
                                            setAddEducationCenterInvoiceName(row.invoiceName)
                                            setAddEducationCenterStudentCount(row.studentCount || '0')
                                        }}>Edit</button>}
                                    </td>}

                                </tr>)}
                            </tbody>
                        </table>
                    </>}
                </> : page === 'Coaches' ? <>

                    {viewUser ? <>

                        <ModalComp showModal={!!showDeleteGeneralFeedbackPopup} setShowModal={setShowDeleteGeneralFeedbackPopup}>
                            <h2>Delete Feedback</h2>
                            <div style={{ display: 'flex', gap: '40px' }}>
                                <button onClick={deleteGeneralFeedback}> Delete</button>
                                <button style={{ marginTop: '20px' }} onClick={() => setShowDeleteGeneralFeedbackPopup(false)}> Cancel</button>
                            </div>
                        </ModalComp>

                        <ModalComp showModal={!!showDeleteFiveStarFeedbackPopup} setShowModal={setShowDeleteFiveStarFeedbackPopup}>
                            <h2>Delete 5 Star Feedback</h2>
                            <div style={{ display: 'flex', gap: '40px' }}>
                                <button onClick={deleteFiveStarFeedback}> Delete</button>
                                <button style={{ marginTop: '20px' }} onClick={() => setShowDeleteFiveStarFeedbackPopup(false)}> Cancel</button>
                            </div>
                        </ModalComp>


                        <ModalComp showModal={showAddGeneralFeedbackModal} setShowModal={setShowAddGeneralFeedbackModal}>
                            <h2> {feedbackId ? 'Edit' : 'Add'} General Feedback</h2>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                <MyCalendar label={'Date'} startDate={feedbackDate} setStartDate={setFeedbackDate} />
                            </div>

                            <label style={{ display: 'flex', marginTop: '15px', fontSize: '15px', color: '#000', fontWeight: '700' }}>Feedback</label>
                            <textarea value={feedbackDesc} onChange={e => setFeedbackDesc(e.target.value)}></textarea>

                            <label style={{ display: 'flex', marginTop: '15px', fontSize: '15px', color: '#000', fontWeight: '700' }}>Document (Medical certificate etc)</label>
                            <MyDropzone allowImageAndPdf storageLocation={`CoachGeneralFeedback/${randomString()}`} customMessage={'Drop file here to upload'} editing={true} errors={[]} name={'feedbackAttachment'} image={feedbackAttachment} updateImage={(doc) => setFeedbackAttachment(doc)} />

                            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                <button disabled={!feedbackDesc || !feedbackDate} onClick={handleAddCoachGeneralFeedback}>Save</button>
                                <button className="textButton" style={{ marginTop: '25px' }} onClick={() => setShowAddGeneralFeedbackModal(false)}>Cancel</button>
                            </div>
                        </ModalComp>

                        <ModalComp showModal={showAddFiveStarFeedbackModal} setShowModal={setShowAddFiveStarFeedbackModal}>
                            <h2>{fiveStarFeedbackId ? 'Edit' : 'Add'} 5 Star Feedback</h2>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                <MyCalendar label={'Date'} startDate={fiveStarFeedbackDate} setStartDate={setFiveStarFeedbackDate} />
                                <Dropdown label={'Rating'} options={[5, 4, 3, 2, 1].map(r => ({ label: r, value: r }))} errorFields={[]} value={fiveStarFeedbackRating} setValue={setFiveStarFeedbackRating} />
                            </div>

                            <label style={{ display: 'flex', marginTop: '15px', fontSize: '15px', color: '#000', fontWeight: '700' }}>Comment</label>
                            <textarea value={fiveStarFeedbackComment} onChange={e => setFiveStarFeedbackComment(e.target.value)}></textarea>

                            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                <button disabled={!fiveStarFeedbackDate || !fiveStarFeedbackRating || !fiveStarFeedbackComment} onClick={handleAddFiveStarFeedback}>Save</button>
                                <button className="textButton" style={{ marginTop: '25px' }} onClick={() => setShowAddFiveStarFeedbackModal(false)}>Cancel</button>
                            </div>
                        </ModalComp>


                        <button className="textButton" onClick={() => setViewUser('')}> {"<-Back"}</button>
                        <h3>{viewUser.firstName} {viewUser.lastName}</h3>
                        <h4 style={{ marginBottom: '10px' }}>Personal Details</h4>
                        <table>
                            <thead>
                                <tr>
                                    <th>Email</th>
                                    <th>Phone</th>
                                    <th>Emergency Contact</th>
                                    <th>Emergency Contact Phone</th>
                                    <th>Emergency Contact Relationship</th>
                                    <th>Date of Birth</th>
                                    <th>Top Size</th>
                                    <th>Address</th>
                                    <th>State</th>
                                    <th>Town</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td> {viewUser.email}</td>
                                    <td> {viewUser.phone}</td>
                                    <td>{viewUser.emergencyContactName || [viewUser.emergencyContactFirstName, viewUser.emergencyContactSurname].filter(Boolean).join(' ').trim() || ''}</td>
                                    <td>{viewUser.emergencyContactPhoneNumber || viewUser.emergencyContactMobileNumber || ''}</td>
                                    <td>{viewUser.emergencyContactRelationship || ''}</td>
                                    <td> {viewUser.dateOfBirth ? format(new Date(viewUser.dateOfBirth), 'dd/MMM/yyyy') : ''}</td>
                                    <td> {viewUser.topSize || ''}</td>
                                    <td> {viewUser.address}</td>
                                    <td> {viewUser.city}</td>
                                    <td> {viewUser.town}</td>
                                </tr>
                            </tbody>
                        </table>

                        <h4 style={{ marginTop: '20px', marginBottom: '10px' }}>Coach Details</h4>
                        <table>
                            <thead>
                                <tr>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th>Color</th>
                                    <th>Categories</th>
                                    <th>Notes</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td> {viewUser.startDate ? format(new Date(viewUser.startDate), 'dd/MMM/yyyy') : ''}</td>
                                    <td> {viewUser.endDate ? format(new Date(viewUser.endDate), 'dd/MMM/yyyy') : ''}</td>
                                    <td> {viewUser.color}</td>
                                    <td>{viewUser.categories && viewUser.categories.join(', ')}</td>
                                    <td> {viewUser.notes}</td>
                                </tr>
                            </tbody>
                        </table>
                        <h2 style={{ textDecorationLine: visibleCoachSection === 'Bank Details' ? 'underline' : '', cursor: 'pointer' }} onClick={() => setVisibleCoachSection(visibleCoachSection === 'Bank Details' ? '' : 'Bank Details')}>Bank Details</h2>
                        {visibleCoachSection === 'Bank Details' && <>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Bank Name</th>
                                        <th>BSB</th>
                                        <th>Account Number</th>
                                        <th>TFN</th>
                                        <th>Super Number and Provider</th>
                                        <th>Claim Tax Free Threshold</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{viewUser.bankName || '-'}</td>
                                        <td>{viewUser.bsb || '-'}</td>
                                        <td>{viewUser.accountNumber || '-'}</td>
                                        <td>{viewUser.tfn || '-'}</td>
                                        <td>{viewUser.superNumberAndProvider || '-'}</td>
                                        <td>{viewUser.claimTaxFreeThreshold || '-'}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </>}
                        <h2 style={{ textDecorationLine: visibleCoachSection === 'Documents' ? 'underline' : '', cursor: 'pointer' }} onClick={() => setVisibleCoachSection(visibleCoachSection === 'Documents' ? '' : 'Documents')}>Documents</h2>
                        {visibleCoachSection === 'Documents' && <>

                            <ModalComp showModal={showCoachChildrenChecksPopup} setShowModal={setShowCoachChildrenChecksPopup}>
                                <h2>{!childrenCheckId ? 'Add' : 'Update'} {getCoachDocumentSection(childrenCheckType).label}</h2>

                                <div style={{ marginTop: '12px' }}>
                                    <MyDropzone
                                        storageLocation={`${getCoachDocumentSection(childrenCheckType).storageLocation}/${randomString()}`}
                                        allowImageAndPdf
                                        customMessage={'Drop file here to upload'}
                                        editing={true}
                                        errors={[]}
                                        name={'childrenCheckImage'}
                                        image={childrenCheckImage}
                                        updateImage={(doc) => setChildrenCheckImage(doc)}
                                    />
                                    <MyCalendar label={'Expiry Date'} startDate={childrenCheckPopupExpiryDate} setStartDate={setChildrenCheckPopupExpiryDate} />
                                </div>


                                <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                    <button disabled={!childrenCheckImage || !childrenCheckPopupExpiryDate} onClick={handleAddChildrenChecks}>Save</button>
                                    <button className="textButton" style={{ marginTop: '25px' }} onClick={() => { setShowCoachChildrenChecksPopup(false); setChildrenCheckId(''); setChildrenCheckImage(''); setChildrenCheckPopupExpiryDate(''); setChildrenCheckType('children-check') }}>Cancel</button>
                                </div>
                            </ModalComp>

                            <ModalComp showModal={!!deleteCoachDocumentId} setShowModal={setDeleteCoachDocumentId}>
                                <h2>Delete Document?</h2>

                                <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                    <button style={{ background: 'red' }} onClick={deleteCoachDocument}>Delete</button>
                                    <button className="textButton" style={{ marginTop: '25px' }} onClick={() => setDeleteCoachDocumentId('')}>Cancel</button>
                                </div>
                            </ModalComp>

                            {coachDocumentSections.map(section => <div key={section.key} style={{ marginBottom: '35px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                                    <h3 style={{ marginBottom: 0 }}>{section.label}</h3>
                                    <button
                                        style={{ width: '220px', marginBottom: 0, marginTop: 0, padding: '10px' }}
                                        onClick={() => {
                                            setShowCoachChildrenChecksPopup(true)
                                            setChildrenCheckId('')
                                            setChildrenCheckImage('')
                                            setChildrenCheckPopupExpiryDate(new Date())
                                            setChildrenCheckType(section.key)
                                        }}
                                    >
                                        Add New Document
                                    </button>
                                </div>

                                <table>
                                    <thead>
                                        <tr>
                                            <th>
                                                Document
                                            </th>
                                            <th>
                                                Expiry
                                            </th>
                                            <th>
                                                Action
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {section.rows.length > 0 ? section.rows.map(row => <tr key={row.id}>
                                            <td>
                                                {isPdfDocument(row.img)
                                                    ? <a href={row.img} target="_blank" rel="noreferrer">Open PDF</a>
                                                    : <>
                                                        <img src={row.img} style={{ width: '200px', height: '200px' }} />
                                                        <a href={row.img} target="_blank" rel="noreferrer">Open</a>
                                                    </>}
                                            </td>
                                            <td>{format(new Date(row.expiry), 'dd/MMM/yyyy')}</td>
                                            <td>
                                                <button className="textButton" onClick={() => { setChildrenCheckId(row.id); setChildrenCheckPopupExpiryDate(new Date(row.expiry)); setChildrenCheckImage(row.img); setChildrenCheckType(row.documentType || 'children-check'); setShowCoachChildrenChecksPopup(true) }}>Edit</button>
                                                <button className="textButton" style={{ color: 'red' }} onClick={() => setDeleteCoachDocumentId(row.id)}>Delete</button>
                                            </td>
                                        </tr>) : <tr>
                                            <td colSpan={3}>No documents uploaded.</td>
                                        </tr>}
                                    </tbody>
                                </table>
                            </div>)}
                        </>}

                        <h2 style={{ textDecorationLine: visibleCoachSection === 'Emergency Contact' ? 'underline' : '', cursor: 'pointer' }} onClick={() => setVisibleCoachSection(visibleCoachSection === 'Emergency Contact' ? '' : 'Emergency Contact')}>Emergency Contact</h2>
                        {visibleCoachSection === 'Emergency Contact' && <>
                            <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                                <Input bold label={'First Name'} type={'text'} value={emergencyContactFirstName} setValue={setEmergencyContactFirstName} errors={[]} />
                                <Input bold label={'Surname'} type={'text'} value={emergencyContactSurname} setValue={setEmergencyContactSurname} errors={[]} />
                                <Input bold label={'Mobile Number'} type={'text'} value={emergencyContactMobileNumber} setValue={setEmergencyContactMobileNumber} errors={[]} />
                                <Input bold label={'Relationship'} type={'text'} value={emergencyContactRelationship} setValue={setEmergencyContactRelationship} errors={[]} />
                            </div>
                            <button
                                style={{ width: '220px' }}
                                disabled={!emergencyContactFirstName || !emergencyContactSurname || !emergencyContactMobileNumber || !emergencyContactRelationship}
                                onClick={updateEmergencyContact}
                            >
                                Save Emergency Contact
                            </button>
                        </>}

                        <h2 style={{ textDecorationLine: visibleCoachSection === 'Onboarding Steps' ? 'underline' : '' }} onClick={() => setVisibleCoachSection('Onboarding Steps')}>Onboarding Steps</h2>
                        {visibleCoachSection === 'Onboarding Steps' && <>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                {onboardingStepsCoach.map((row, index) => <Checkbox errors={[]} label={row} value={addCoachCompletedOnboardingSteps.includes(index)} setValue={() => { setAddCoachCompletedOnboardingSteps(addCoachCompletedOnboardingSteps.includes(index) ? addCoachCompletedOnboardingSteps.filter(r => r !== index) : [...addCoachCompletedOnboardingSteps, index]) }} />)}

                                <Dropdown label={'Coach Type'} options={['Coach A', 'Coach B'].map(r => ({ label: r, value: r }))} errorFields={[]} value={addCoachOnboardingStepsType} setValue={setAddCoachOnboardingStepsType} />

                                {
                                    addCoachOnboardingStepsType && <>
                                        {addCoachOnboardingStepsType.value === 'Coach A' && onboardingStepsCoachA.map((row, index) => <Checkbox errors={[]} label={row} value={addCoachCompletedOnboardingStepsA.includes(index)} setValue={() => { setAddCoachCompletedOnboardingStepsA(addCoachCompletedOnboardingStepsA.includes(index) ? addCoachCompletedOnboardingStepsA.filter(r => r !== index) : [...addCoachCompletedOnboardingStepsA, index]) }} />)}

                                        {addCoachOnboardingStepsType.value === 'Coach B' && onboardingStepsCoachB.map((row, index) => <Checkbox errors={[]} label={row} value={addCoachCompletedOnboardingStepsB.includes(index)} setValue={() => { setAddCoachCompletedOnboardingStepsB(addCoachCompletedOnboardingStepsB.includes(index) ? addCoachCompletedOnboardingStepsB.filter(r => r !== index) : [...addCoachCompletedOnboardingStepsB, index]) }} />)}
                                    </>
                                }

                            </div>
                            <button style={{ width: '300px' }} onClick={updateOnboardingStepsCoach}>Update Onboarding Steps </button>

                        </>}
                        <h2 style={{ textDecorationLine: visibleCoachSection === 'Center Staff Feedbacks' ? 'underline' : '' }} onClick={() => setVisibleCoachSection('Center Staff Feedbacks')}>Center Staff Feedbacks</h2>
                        {visibleCoachSection === 'Center Staff Feedbacks' && <>

                            <table>
                                <thead>
                                    <tr>
                                        <th>
                                            Date
                                        </th>
                                        <th>
                                            Center Name
                                        </th>
                                        <th>
                                            Week Activity
                                        </th>
                                        <th>
                                            Activity
                                        </th>
                                        <th>
                                            Engagement of Children
                                        </th>
                                        <th>
                                            Structure/Quality of Session
                                        </th>
                                        <th>
                                            Feedback
                                        </th>
                                        <th>
                                            Staff Name
                                        </th>
                                        <th>
                                            Staff Profile
                                        </th>
                                        <th>
                                            Room Type
                                        </th>
                                        <th>
                                            Room Name
                                        </th>

                                    </tr>
                                </thead>
                                <tbody>

                                    {centerStaffFeedbacksCoach.map(row => <tr key={row.id}>

                                        <td>{format(new Date(row.created), 'dd MMM yyyy')}</td>
                                        <td>{educationCentersList.find(r => r.id === row.center) ? educationCentersList.find(r => r.id === row.center).name : row.center}</td>
                                        <td>{row.weekActivity}</td>
                                        <td>{row.activity}</td>
                                        <td>{row.engagement}</td>
                                        <td>{row.lesson}</td>
                                        <td>{row.feedback}</td>
                                        <td>{row.userName}</td>
                                        <td>{row.staffProfileName || '-'}</td>
                                        <td>{row.roomType}</td>
                                        <td>{row.roomName}</td>

                                    </tr>)}
                                </tbody>
                            </table>
                        </>}

                        <h2 style={{ textDecorationLine: visibleCoachSection === 'Feedbacks' ? 'underline' : '' }} onClick={() => setVisibleCoachSection('Feedbacks')}>Feedbacks</h2>
                        {visibleCoachSection === 'Feedbacks' && <>

                            <table>
                                <thead>
                                    <tr>
                                        <th>
                                            Date
                                        </th>
                                        <th>
                                            Title
                                        </th>
                                        <th>
                                            Center
                                        </th>
                                        <th>
                                            Description
                                        </th>
                                        <th>
                                            Avg Rating
                                        </th>
                                        <th>
                                            Punctuality
                                        </th>
                                        <th>
                                            Attendance
                                        </th>
                                        <th>
                                            Interaction
                                        </th>
                                        <th>
                                            Quality Coach
                                        </th>
                                        <th>
                                            Quality Program
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {coachFeedbacks.map(row => <tr key={row.id}>
                                        <td>{format(new Date(row.created), 'dd MMM yyyy')}</td>
                                        <td>{row.title}</td>
                                        <td>{educationCentersList.find(r => r.id === row.center) ? educationCentersList.find(r => r.id === row.center).name : row.center}</td>
                                        <td>{row.desc}</td>
                                        <td>{row.avgRating}</td>
                                        <td>{row.punctuality}</td>
                                        <td>{row.attendance}</td>
                                        <td>{row.interaction}</td>
                                        <td>{row.coachQuality}</td>
                                        <td>{row.programQuality}</td>
                                    </tr>)}
                                </tbody>
                            </table>
                        </>}


                        <h2 style={{ textDecorationLine: visibleCoachSection === 'Attendance' ? 'underline' : '', marginBottom: 0 }} onClick={() => setVisibleCoachSection('Attendance')}>Attended/Missed/Covered</h2>
                        {visibleCoachSection === 'Attendance' && <>
                            <table>
                                <thead>
                                    <tr>
                                        <th>
                                            Type
                                        </th>
                                        <th>
                                            Count
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            Attended
                                        </td>
                                        <td>
                                            {/* {coachAttendedStats.Attended} */}
                                            {viewUser.Attended || '0'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Missed
                                        </td>
                                        <td>
                                            {/* {coachAttendedStats.Missed} */}
                                            {viewUser.Missed || '0'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Rescheduled
                                        </td>
                                        <td>
                                            {/* {coachAttendedStats.Covered} */}
                                            {viewUser.Rescheduled || '0'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Covered
                                        </td>
                                        <td>
                                            {/* {coachAttendedStats.Covered} */}
                                            {viewUser.Covered}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </>}
                        <h2 onClick={() => setVisibleCoachSection('General Feedback')} style={{ textDecorationLine: visibleCoachSection === 'General Feedback' ? 'underline' : '' }}>General Feedbacks</h2>

                        {visibleCoachSection === 'General Feedback' && <>
                            <button style={{ width: '200px', marginBottom: '20px', marginTop: 0, padding: '10px', marginLeft: 'auto' }} onClick={() => { setShowAddGeneralFeedbackModal(true); setFeedbackDesc(''); setFeedbackAttachment(''); setFeedbackId(''); setFeedbackDate('') }}>Add General Feedback</button>

                            <div style={{ overflowX: 'auto', maxWidth: '100%' }}>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>
                                                Date
                                            </th>
                                            <th>
                                                Message
                                            </th>
                                            <th>
                                                Document
                                            </th>
                                            <th>
                                                Actions
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {coachGeneralFeedbacks.map(row => <tr key={row.id}>
                                            <td>{format(new Date(row.created), 'dd MMM yyyy')}</td>
                                            <td>{row.message}</td>
                                            <td>{row.attachmentUrl ? <a href={row.attachmentUrl} target="_blank" rel="noreferrer">View</a> : '-'}</td>
                                            <td>
                                                <button className="textButton" onClick={() => { setFeedbackDate(new Date(row.created)); setFeedbackId(row.id); setFeedbackDesc(row.message); setFeedbackAttachment(row.attachmentUrl || ''); setShowAddGeneralFeedbackModal(true) }}>Edit</button>
                                                <button className="textButton" onClick={() => { setShowDeleteGeneralFeedbackPopup(row.id) }}>Delete</button>
                                            </td>
                                        </tr>)}
                                    </tbody>
                                </table>
                            </div>
                        </>
                        }


                        <h2 style={{ textDecorationLine: visibleCoachSection === 'Head Coach Feedbacks' ? 'underline' : '' }} onClick={() => setVisibleCoachSection('Head Coach Feedbacks')} >Head Coach Feedbacks</h2>

                        {visibleCoachSection === 'Head Coach Feedbacks' && <>

                            <button style={{ width: '200px', marginBottom: '20px', marginTop: 0, padding: '10px', marginLeft: 'auto' }} onClick={() => { setShowAddGeneralFeedbackModal(true); setFeedbackDesc(''); setFeedbackId(''); setFeedbackDate('') }}>Add General Feedback</button>

                            <table>
                                <thead>
                                    <tr>
                                        <th>
                                            Date
                                        </th>
                                        <th>
                                            Did they show initiative?
                                        </th>
                                        <th>
                                            Did they engage with kids and educators?
                                        </th>
                                        <th>
                                            Do they show Head Coach potential?
                                        </th>
                                        <th>
                                            Did they brig High energy and a positive attitude?
                                        </th>
                                        <th>
                                            Other Feedback
                                        </th>
                                        <th>
                                            By
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {coachHeadFeedbacks.map(row => <tr key={row.id}>
                                        <td>{format(new Date(row.created), 'dd MMM yyyy')}</td>
                                        {row.feedbacks.map((feedback, index) => <td key={`${row.id}-${index}`}>{feedback}</td>)}
                                        <td>{row.textFeedback}</td>
                                        <td>{getUserName(row.fromCoach)}</td>

                                    </tr>)}
                                </tbody>
                            </table>

                        </>}

                        <h2 style={{ textDecorationLine: visibleCoachSection === '5 Star Feedbacks' ? 'underline' : '' }} onClick={() => setVisibleCoachSection('5 Star Feedbacks')}>5 Star Feedbacks</h2>

                        {visibleCoachSection === '5 Star Feedbacks' && <>

                            <button style={{ width: '200px', marginBottom: '20px', marginTop: 0, padding: '10px', marginLeft: 'auto' }} onClick={() => {
                                setShowAddFiveStarFeedbackModal(true)
                                setFiveStarFeedbackId('')
                                setFiveStarFeedbackDate(new Date())
                                setFiveStarFeedbackRating({ label: 5, value: 5 })
                                setFiveStarFeedbackComment('')
                            }}>Add 5 Star Feedback</button>

                            <table>
                                <thead>
                                    <tr>
                                        <th>
                                            Date
                                        </th>
                                        <th>
                                            Rating
                                        </th>
                                        <th>
                                            Comment
                                        </th>
                                        <th>
                                            Added By
                                        </th>
                                        <th>
                                            Actions
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {coachFiveStarFeedbacks.map(row => <tr key={row.id}>
                                        <td>{format(new Date(row.created), 'dd MMM yyyy')}</td>
                                        <td>{row.rating}/5</td>
                                        <td>{row.comment}</td>
                                        <td>{row.createdByName || getUserName(row.createdBy) || '-'}</td>
                                        <td>
                                            <button className="textButton" onClick={() => {
                                                setFiveStarFeedbackId(row.id)
                                                setFiveStarFeedbackDate(new Date(row.created))
                                                setFiveStarFeedbackRating({ label: row.rating, value: row.rating })
                                                setFiveStarFeedbackComment(row.comment || '')
                                                setShowAddFiveStarFeedbackModal(true)
                                            }}>Edit</button>
                                            <button className="textButton" onClick={() => setShowDeleteFiveStarFeedbackPopup(row.id)}>Delete</button>
                                        </td>
                                    </tr>)}
                                </tbody>
                            </table>
                        </>}


                        <h2 style={{ textDecorationLine: visibleCoachSection === 'Equipments' ? 'underline' : '', marginBottom: '20px' }} onClick={() => setVisibleCoachSection('Equipments')}>Equipments</h2>
                        {visibleCoachSection === 'Equipments' && <>
                            {viewUser.equipments && <table>
                                <tbody>
                                    {viewUser.equipments.map(r => <tr key={r.id}>
                                        <th>{r.name}</th>
                                        <td>{r.qty}</td>
                                    </tr>)}
                                </tbody>
                            </table>}
                        </>}
                    </> : <>

                        <h3 style={{ marginTop: '12px', marginBottom: '-10px' }}>Coaches ({filteredUsers.length}) </h3>


                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-evenly' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <h4 style={{ marginTop: '12px', marginBottom: '-10px', marginRight: '5px' }}>State Filter:</h4>
                                <Tabs tabs={['All', ...cityFilterOptionsCoach]} currentTab={cityFilter} setCurrentTab={setCityFilter} />
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <h4 style={{ marginTop: '12px', marginBottom: '-10px', marginRight: '5px' }}>Category Filter:</h4>
                                <Tabs tabs={['All', 'Sports', 'Music', 'Yoga', 'Gymnastics', 'Sensory Fusion']} currentTab={categoryFilter} setCurrentTab={setCategoryFilter} />
                            </div>

                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <h4 style={{ marginTop: '12px', marginBottom: '-10px', marginRight: '5px' }}>Status Filter:</h4>
                                <Tabs tabs={['All', 'Active', 'Inactive']} currentTab={stateFilter} setCurrentTab={setStateFilter} />
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <h4 style={{ marginTop: '12px', marginBottom: '-10px', marginRight: '5px' }}>Onboarding Status:</h4>
                                <Tabs tabs={['All', 'Onboarding', 'Onboarded']} currentTab={onboardingStatusFilter} setCurrentTab={setOnboardingStatusFilter} />
                            </div>
                        </div>
                        {renderTownFilter()}

                        <ModalComp showModal={showUpdateUserInfo} setShowModal={setShowUpdateUserInfo}>
                            <h2>Update Coach Info</h2>

                            <h3 style={{ marginBottom: '10px' }}>Basic Info</h3>
                            <div style={{ display: 'flex', gap: '20px' }}>
                                <Input bold disabled label={'Name'} type={'text'} value={addUserName} setValue={setAddUserName} errors={[]} />
                                <Input bold disabled label={'Email'} type={'text'} value={addUserEmail} setValue={setAddUserEmail} errors={[]} />
                                <div style={{ marginTop: '12px' }}>
                                    <MyCalendar label={'Start Date'} startDate={addUserStartDate} setStartDate={setAddUserStartDate} />
                                </div>
                                <div style={{ marginTop: '12px' }}>
                                    <MyCalendar label={'End Date'} startDate={addUserEndDate} setStartDate={setAddUserEndDate} />
                                </div>
                                <MyDropzone storageLocation={`Images/Profile/${randomString()}`} customMessage={'Drop file here to upload'} editing={true} errors={[]} name={'childrenCheckImage'} image={addUserProfilePic} updateImage={(doc) => setAddUserProfilePic(doc)} />

                            </div>

                            <h3 style={{ marginTop: '20px', marginBottom: '10px' }}>Personal Details</h3>
                            <div style={{ display: 'flex', gap: '20px' }}>
                                <div style={{ marginTop: 'auto' }}>
                                    <label style={{ display: 'flex', marginTop: '25px', fontWeight: '800', fontSize: '14px', color: '#000' }}>Address</label>

                                    <AutoComplete
                                        apiKey={'AIzaSyAG_p8MmFkQM50X8iGEbavuVVu4fnMed1I'}

                                        options={{
                                            types: ["address"],
                                            componentRestrictions: { country: "au" },
                                        }}
                                        defaultValue={addUserAddress}
                                        onPlaceSelected={(place) => { setAddUserCoords({ lat: place.geometry.location.lat(), lng: place.geometry.location.lng() }); setAddUserAddress(place.formatted_address); }}
                                        style={{ width: '400px' }}
                                    />
                                </div>

                                <div style={{ width: '180px', marginTop: '10px' }}>
                                    <Dropdown label={'State'} options={stateOptions.map(r => ({ label: r, value: r }))} errorFields={[]} value={updateDropdownValue(addUserCity)} setValue={v => setAddUserCity(v ? v.value : '')} />
                                </div>
                                <div style={{ width: '220px', marginTop: '10px' }}>
                                    <Dropdown label={'Town'} options={getTownOptionsForState(addUserCity).map(r => ({ label: r, value: r }))} errorFields={[]} value={updateTownDropdownValue(addUserTown)} setValue={v => setAddUserTown(v ? v.value : '')} />
                                </div>
                            </div>

                            <div style={{ display: 'flex', gap: '20px' }}>
                                <Input bold label={'Phone Number'} type={'text'} value={addUserPhone} setValue={v => setAddUserPhone(normalizeAustralianPhone(v))} errors={[]} />
                                <div style={{ marginTop: '12px' }}>
                                    <MyCalendar label={'Date of Birth'} startDate={addUserDateOfBirth} setStartDate={setAddUserDateOfBirth} />
                                </div>
                                <Input bold label={'Top Size (XS-XL)'} type={'text'} value={addUserTopSize} setValue={setAddUserTopSize} errors={[]} />
                                <Input bold label={'Color'} type={'text'} value={addUserColor} setValue={setAddUserColor} errors={[]} />
                            </div>

                            <h3 style={{ marginTop: '20px', marginBottom: '10px' }}>Bank Details</h3>
                            <div style={{ display: 'flex', gap: '20px' }}>
                                <Input bold label={'Bank Name'} type={'text'} value={addUserBankName} setValue={setAddUserBankName} errors={[]} />
                                <Input bold label={'BSB'} type={'text'} value={addUserBsb} setValue={setAddUserBsb} errors={[]} />
                                <Input bold label={'Account Number'} type={'text'} value={addUserAccountNumber} setValue={setAddUserAccountNumber} errors={[]} />
                                <Input bold label={'TFN'} type={'text'} value={addUserTfn} setValue={setAddUserTfn} errors={[]} />
                                <Input bold style={{ width: '400px' }} label={'Super Number and Provider'} type={'text'} value={addUserSuperNumberAndProvider} setValue={setAddUserSuperNumberAndProvider} errors={[]} />
                                <div style={{ width: '300px' }}>
                                    <Dropdown label={'Claim Tax Free Threshold'} options={['Yes', 'No'].map(r => ({ label: r, value: r }))} errorFields={[]} value={addUserClaimTaxFreeThreshold} setValue={setAddUserClaimTaxFreeThreshold} />
                                </div>
                            </div>

                            <h3 style={{ marginTop: '20px', marginBottom: '10px' }}>Profile</h3>

                            <label style={{ display: 'flex', marginTop: '15px', fontSize: '15px', color: '#000', fontWeight: '700' }}>About Me</label>
                            <textarea value={addUserAboutMe} style={{ height: '100px' }} onChange={e => setAddUserAboutMe(e.target.value)}></textarea>

                            <label style={{ display: 'flex', marginTop: '15px', fontSize: '15px', color: '#000', fontWeight: '700' }}>Notes</label>
                            <textarea value={addUserNotes} style={{ height: '100px' }} onChange={e => setAddUserNotes(e.target.value)}></textarea>

                            <h3 style={{ marginTop: '20px', marginBottom: '10px' }}>Work Settings</h3>
                            <div style={{ display: 'flex', gap: '20px' }}>
                                <div style={{ width: '300px' }}>
                                    <Dropdown isMulti label={'Categories'} options={['Sports', 'Music', 'Yoga', 'Gymnastics', 'Sensory Fusion'].map(r => ({ label: r, value: r }))} errorFields={[]} value={addUserCategories} setValue={setAddUserCategories} />
                                </div>
                                <div style={{ width: '300px' }}>
                                    <Dropdown label={'Speciality'} options={['Sports', 'Music', 'Yoga', 'Gymnastics', 'Sensory Fusion'].map(r => ({ label: r, value: r }))} errorFields={[]} value={addUserSpeciality} setValue={setAddUserSpeciality} />
                                </div>
                                <div style={{ width: '300px' }}>
                                    <Dropdown label={'Status'} options={['Active', 'Inactive'].map(r => ({ label: r, value: r }))} errorFields={[]} value={addUserStatus} setValue={setAddUserStatus} />
                                </div>
                                <div style={{ width: '300px' }}>
                                    <Dropdown label={'Uniform Received'} options={['Yes', 'No'].map(r => ({ label: r, value: r }))} errorFields={[]} value={addUserReceivedUniform} setValue={setAddUserReceivedUniform} />
                                </div>
                            </div>

                            {addUserStatus && addUserStatus.value === 'Inactive' && <>
                                <div style={{ display: 'flex', gap: '20px', alignItems: 'flex-start' }}>
                                    <div style={{ marginTop: '12px' }}>
                                        <MyCalendar label={'Inactive Date'} startDate={addUserInactiveDate} setStartDate={setAddUserInactiveDate} />
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <label style={{ display: 'flex', marginTop: '15px', fontSize: '15px', color: '#000', fontWeight: '700' }}>Inactive Reason</label>
                                        <textarea value={addUserInactiveReason} style={{ height: '100px' }} onChange={e => setAddUserInactiveReason(e.target.value)}></textarea>
                                    </div>
                                </div>
                                {addUserInactiveHistory && addUserInactiveHistory.length > 0 && <div>
                                    <label style={{ display: 'flex', marginTop: '15px', fontSize: '15px', color: '#000', fontWeight: '700' }}>Inactive History</label>
                                    <div style={{ fontSize: '14px' }}>
                                        {addUserInactiveHistory.slice().reverse().map((entry, index) => <div key={`${entry.date || 'inactive'}-${index}`} style={{ marginBottom: '8px' }}>
                                            {entry.date ? format(new Date(entry.date), 'dd/MMM/yyyy') : 'No date'}: {entry.reason || 'No reason recorded'}
                                        </div>)}
                                    </div>
                                </div>}
                            </>}

                            <label style={{ display: 'flex', marginTop: '15px', fontSize: '15px', color: '#000', fontWeight: '700' }}>Availability</label>
                            <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                                {['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'].map((day, index) =>
                                    <div key={day} style={{ width: '160px' }}>
                                        <label style={{ display: 'flex', marginTop: '15px', fontSize: '15px', color: '#000', fontWeight: '700' }}>{day}</label>
                                        {/* <Dropdown errorFields={[]} options={['Available', 'Fortnightly', 'Filled', 'Unavailable'].map(r => ({ label: r, value: r }))} value={addUserAvailabilities[index]} setValue={v => setAddUserAvailabilities([...addUserAvailabilities.map((c, idx) => idx === index ? v : c)])} /> */}
                                        <Input bold label={day} type={'text'} value={addUserAvailabilities[index]} setValue={v => setAddUserAvailabilities([...addUserAvailabilities.map((c, idx) => idx === index ? v : c)])} errors={[]} />
                                    </div>)}
                            </div>

                            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                <button disabled={!addUserAddress || !addUserCoords || !addUserCity || !addUserStatus} onClick={handleUpdateUserInfo}>Save</button>
                                <button className="textButton" style={{ marginTop: '25px' }} onClick={() => setShowUpdateUserInfo(false)}>Cancel</button>
                            </div>
                        </ModalComp>



                        <table>
                            <thead>
                                <tr>
                                    <th onClick={() => handleSortCoaches('name')}>
                                        Name
                                    </th>
                                    <th>
                                        Profile Pic
                                    </th>
                                    <th>
                                        About Me
                                    </th>
                                    <th>
                                        Address
                                    </th>
                                    <th>
                                        State
                                    </th>
                                    <th>
                                        Color
                                    </th>
                                    <th onClick={() => handleSortCoaches('startDate')}>
                                        Start Date
                                    </th>
                                    <th style={{ cursor: 'pointer' }} onClick={() => handleSortCoaches('inactiveDate')} title="Sort inactive dates, latest first">
                                        End Date
                                    </th>
                                    <th>
                                        Status
                                    </th>
                                    <th onClick={() => handleSortCoaches('avgRating')}>
                                        Avg Rating
                                    </th>
                                    <th>
                                        Categories
                                    </th>
                                    <th>
                                        Speciality
                                    </th>
                                    {/* <th>
                                Centers
                            </th> */}
                                    <th>
                                        Uniform Received
                                    </th>
                                    <th onClick={() => handleSortCoaches('codeOfConduct')}>
                                        Code of Conduct
                                    </th>
                                    <th>
                                        Equipments
                                    </th>
                                    <th>
                                        Onboarding Status
                                    </th>
                                    <th>
                                        Actions
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredUsers.map(row => <tr key={row.id}>
                                    <td className="hover" onClick={() => setViewUser(row)}>{row.firstName} {row.lastName}</td>
                                    <td>{row.profilePic ? <img src={row.profilePic} style={{ width: '100px', height: '100px' }} /> : 'No Pic'}</td>
                                    <td style={{ marginLeft: 20 }}>{row.aboutMe}</td>
                                    <td style={{ marginLeft: 20 }}>{row.address}</td>
                                    <td style={{ marginLeft: 20 }}>{row.city}</td>
                                    <td style={{ marginLeft: 20 }}>{row.color}</td>
                                    <td style={{ marginLeft: 20 }}>{row.startDate ? format(new Date(row.startDate), 'dd/MMM/yyyy') : ''}</td>
                                    <td style={{ marginLeft: 20 }}>{row.inactiveDate && !Number.isNaN(new Date(row.inactiveDate).getTime()) ? format(new Date(row.inactiveDate), 'dd/MMM/yyyy') : '—'}</td>
                                    <td style={{ marginLeft: 20 }}>
                                        {row.status || ''}
                                        {row.status === 'Inactive' && row.inactiveDate ? <div>{format(new Date(row.inactiveDate), 'dd/MMM/yyyy')}</div> : null}
                                        {row.status === 'Inactive' && row.inactiveReason ? <div>{row.inactiveReason}</div> : null}
                                    </td>
                                    <td style={{ marginLeft: 20 }}>{row.avgRating ? row.avgRating.toFixed(2) : 0}</td>
                                    <td style={{ marginLeft: 20 }}>{row.categories && row.categories.join(', ')}</td>
                                    <td style={{ marginLeft: 20 }}>{row.speciality}</td>
                                    {/* <td style={{ marginLeft: 20 }}>{returnCentersForUser(row.id)}</td> */}
                                    <td style={{ marginLeft: 20 }}>{row.receivedUniform}</td>
                                    <td style={{ marginLeft: 20 }}>{row.codeOfConductUrl ? <a href={row.codeOfConductUrl} target='_blank'>{row.codeOfConductDate ? format(new Date(row.codeOfConductDate), 'dd/MMM/yyyy') : 'Open'}</a> : ''}</td>
                                    <td style={{ marginLeft: 20 }}>
                                        {row.equipments && [... new Set(row.equipments.map(r => r.type))].join(', ')}
                                        <button className="textButton" onClick={() => { setShowAssignEquipment(row); setUsersEquipments(row.equipments || []) }}>Assign</button>
                                    </td>
                                    <td style={{ marginLeft: 20 }}>
                                        {row.onboardingStatus || "Onboarding"}
                                    </td>
                                    <td style={{ marginLeft: 20 }}>
                                        <button className="textButton" onClick={() => {
                                            setAddUserId(row.id); setAddUserAddress(row.address); setAddUserCity(row.city);
                                            setAddUserTown(row.town || '');
                                            setAddUserCoords(row.addressGeo);
                                            setAddUserPhone(normalizeAustralianPhone(row.phone || ''));
                                            setAddUserDateOfBirth(row.dateOfBirth ? new Date(row.dateOfBirth) : '')
                                            setAddUserTopSize(row.topSize || '')
                                            setAddUserBankName(row.bankName || '')
                                            setAddUserBsb(row.bsb || '')
                                            setAddUserAccountNumber(row.accountNumber || '')
                                            setAddUserTfn(row.tfn || '')
                                            setAddUserSuperNumberAndProvider(row.superNumberAndProvider || '')
                                            setAddUserClaimTaxFreeThreshold(row.claimTaxFreeThreshold ? updateDropdownValue(row.claimTaxFreeThreshold) : '')
                                            setAddUserColor(row.color || '');
                                            setAddUserEmail(row.email);
                                            setAddUserNotes(row.notes || '');
                                            setAddUserStartDate(row.startDate ? new Date(row.startDate) : '')
                                            setAddUserEndDate(row.endDate ? new Date(row.endDate) : '')
                                            setAddUserAboutMe(row.aboutMe || '')
                                            setAddUserProfilePic(row.profilePic || '')
                                            setAddUserStatus(row.status ? updateDropdownValue(row.status) : '')
                                            setAddUserStatusPrevious(row.status || '')
                                            setAddUserInactiveDate(row.inactiveDate ? new Date(row.inactiveDate) : '')
                                            setAddUserInactiveReason(row.inactiveReason || '')
                                            setAddUserInactiveHistory(row.inactiveHistory || [])
                                            setAddUserReceivedUniform(row.receivedUniform ? updateDropdownValue(row.receivedUniform) : '');
                                            setAddUserCategories(row.categories ? row.categories.map(updateDropdownValue) : []);
                                            setAddUserAvailabilities((row.availability || ['Available', 'Available', 'Available', 'Available', 'Available'])); setShowUpdateUserInfo(true); setAddUserName(row.firstName + ' ' + row.lastName)
                                            setAddUserSpeciality(updateDropdownValue(row.speciality));
                                        }}>Edit</button>
                                    </td>
                                </tr>)}
                            </tbody>
                        </table>
                    </>}
                </> : page === 'Availability' ? <>


                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <h4 style={{ marginTop: '12px', marginBottom: '-10px', marginRight: '5px' }}>State Filter:</h4>
                        <Tabs tabs={['All', ...cityFilterOptions]} currentTab={cityFilter} setCurrentTab={setCityFilter} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        {renderTownFilter()}
                    </div>


                    <table>
                        <thead>
                            <tr>
                                <th>
                                    Name
                                </th>
                                <th>
                                    Categories
                                </th>
                                <th>
                                    Monday
                                </th>
                                <th>
                                    Tuesday
                                </th>
                                <th>
                                    Wednesday
                                </th>
                                <th>
                                    Thursday
                                </th>
                                <th>
                                    Friday
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {returnedUsers.filter(matchesLocationFilters).filter(r => (categoryFilter && categoryFilter !== 'All' && r.categories) ? r.categories.includes(categoryFilter) : true).filter(r => search ? (r.firstName.toLowerCase().includes(search.toLowerCase()) || (r.lastName.toLowerCase().includes(search.toLowerCase()))) : true).filter(r => r.status === 'Active').map(row => <tr key={row.id}>
                                <td>{row.firstName} {row.lastName}</td>
                                <td style={{ marginLeft: 20 }}>{row.categories && row.categories.join(', ')}</td>
                                {/* <td style={{ marginLeft: 20 }}>{returnCentersForUser(row.id)}</td> */}
                                <td style={{ marginLeft: 20,/* color: '#D7D7D7', background: getAvailabilityColor(row.availability && row.availability[0])*/ }}>{row.availability && row.availability[0]}</td>
                                <td style={{ marginLeft: 20, /*color: '#D7D7D7', background: getAvailabilityColor(row.availability && row.availability[1])*/ }}>{row.availability && row.availability[1]}</td>
                                <td style={{ marginLeft: 20, /*color: '#D7D7D7', background: getAvailabilityColor(row.availability && row.availability[2])*/ }}>{row.availability && row.availability[2]}</td>
                                <td style={{ marginLeft: 20, /*color: '#D7D7D7', background: getAvailabilityColor(row.availability && row.availability[3])*/ }}>{row.availability && row.availability[3]}</td>
                                <td style={{ marginLeft: 20, /*color: '#D7D7D7', background: getAvailabilityColor(row.availability && row.availability[4])*/ }}>{row.availability && row.availability[4]}</td>
                                <td style={{ marginLeft: 20, /*color: '#D7D7D7', background: getAvailabilityColor(row.availability && row.availability[5])*/ }}>{row.availability && row.availability[5]}</td>
                                <td style={{ marginLeft: 20, /*color: '#D7D7D7', background: getAvailabilityColor(row.availability && row.availability[6])*/ }}>{row.availability && row.availability[6]}</td>
                                <td style={{ marginLeft: 20, /*color: '#D7D7D7', background: getAvailabilityColor(row.availability && row.availability[7])*/ }}>{row.availability && row.availability[7]}</td>
                                <td style={{ marginLeft: 20, /*color: '#D7D7D7', background: getAvailabilityColor(row.availability && row.availability[8])*/ }}>{row.availability && row.availability[8]}</td>
                                <td style={{ marginLeft: 20, /*color: '#D7D7D7', background: getAvailabilityColor(row.availability && row.availability[9])*/ }}>{row.availability && row.availability[9]}</td>
                            </tr>)}
                        </tbody>
                    </table>
                    {/* {returnedUsers.map()} */}

                </> : page === 'Maps' ?
                    <>
                        {returnSessionFilters(true)}
                        <Map centers={mapEducationCenters} mapViewType={mapViewType} coaches={filteredUsers} stateFilter={cityFilter} />
                    </>
                    :
                    page === 'Feedbacks' ? <>
                        <div style={{ display: 'flex', gap: '20px' }}>

                            <button className="textButton" onClick={() => { setFeedbackViewDate(subDays(feedbackViewDate, 7)) }}> {"<-Prev Week"}</button>
                            <h4 style={{ margin: 0, marginTop: '10px' }}>Week {getWeek(feedbackViewDate) - 3} ({format(feedbackViewDate, 'dd MMM yyyy')} - {format(addDays(feedbackViewDate, 7), 'dd MMM yyyy')})</h4>
                            <button className="textButton" onClick={() => { setFeedbackViewDate(addDays(feedbackViewDate, 7)) }}> {"Next Week->"}</button>

                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <h4 style={{ marginTop: '12px', marginBottom: '-10px', marginRight: '5px' }}>Name Filter:</h4>
                                <Tabs tabs={['All', ...nameFilterOptionsFeedback]} currentTab={nameFilter} setCurrentTab={setNameFilter} />
                            </div>

                        </div>

                        <table>
                            <thead>
                                <tr>
                                    <th>
                                        Date
                                    </th>
                                    <th>
                                        Title
                                    </th>
                                    <th>
                                        Name
                                    </th>
                                    <th>
                                        Coach
                                    </th>
                                    <th>
                                        Center
                                    </th>
                                    <th>
                                        Description
                                    </th>
                                    <th>
                                        Avg Rating
                                    </th>

                                    <th>
                                        Punctuality
                                    </th>
                                    <th>
                                        Attendance
                                    </th>
                                    <th>
                                        Interaction
                                    </th>
                                    <th>
                                        Quality Coach
                                    </th>
                                    <th>
                                        Quality Program
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {globalFeedbacks.filter(r => nameFilter !== 'All' ? r.name === nameFilter : true).map(row => <tr key={row.id}>
                                    <td style={{ color: isAfter(new Date(row.created), endOfDay(new Date())) ? 'black' : 'red' }}> {format(new Date(row.created), 'dd MMM yyyy')}</td>
                                    <td> {row.title}</td>
                                    <td> {row.name}</td>
                                    <td>{row.coach.label}</td>
                                    <td className="hover" style={{ color: 'blue' }} onClick={() => { setViewCenter(educationCentersList.find(r => r.id === row.center)); setPage('Centers') }}>{educationCentersList.find(r => r.id === row.center) && educationCentersList.find(r => r.id === row.center).name}</td>
                                    <td>{row.desc}</td>

                                    <td>{row.punctuality}</td>
                                    <td>{row.avgRating}</td>
                                    <td>{row.attendance}</td>
                                    <td>{row.interaction}</td>
                                    <td>{row.coachQuality}</td>
                                    <td>{row.programQuality}</td>
                                </tr>)}
                            </tbody>
                        </table>

                    </>
                        : page === 'Equipment' ? <>

                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <h4 style={{ marginTop: '12px', marginBottom: '-10px', marginRight: '5px' }}>State Filter:</h4>
                                    <Tabs tabs={['All', ...cityFilterOptions]} currentTab={cityFilter} setCurrentTab={setCityFilter} />
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', marginLeft: '20px' }}>
                                    <h4 style={{ marginTop: '12px', marginBottom: '-10px', marginRight: '5px' }}>Category Filter:</h4>
                                    <Tabs tabs={['All', ...equipmentCategoriesWithoutOther]} currentTab={categoryFilter} setCurrentTab={setCategoryFilter} />
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', marginLeft: '20px' }}>
                                    <h4 style={{ marginTop: '12px', marginBottom: '-10px', marginRight: '5px' }}>Type:</h4>
                                    <Tabs tabs={['All', 'Stock Room', 'Coaches']} currentTab={stockRoomFilter} setCurrentTab={setStockRoomFilter} />
                                </div>
                            </div>
                            {renderTownFilter()}


                            <h2>Total ({usersWithEquipments.length})</h2>

                            {['All', ...equipmentCategories].filter(r => (categoryFilter && categoryFilter !== 'All') ? categoryFilter === r : true).map(cityFilter => <div>
                                <h2>{cityFilter}</h2>

                                {
                                    cityFilter === 'All' && stockRoomFilter === 'Stock Room' && <table>
                                        <tr>{fetchQtyClubbedForStockRoom().map(r => <>
                                            <th>{r.name}</th>
                                        </>)}</tr>
                                        <tr>{fetchQtyClubbedForStockRoom().map(r => <>
                                            <td>{r.qty}</td>
                                        </>)}</tr>
                                    </table>
                                }

                                <table>

                                    <tr>
                                        {equipments.sort((a, b) => a.priority >= b.priority ? 1 : -1).filter(r => r.type === cityFilter).map(r => <>

                                            <th>{r.name}</th>
                                        </>)}
                                    </tr>
                                    <tr>
                                        {equipments.sort((a, b) => a.priority >= b.priority ? 1 : -1).filter(r => r.type === cityFilter).map(r => <>

                                            <td>{fetchQtyForEquipmentId(r.id)}</td>
                                        </>)}
                                    </tr>

                                </table>

                            </div>)}

                            <div style={{ display: "flex", flexWrap: 'wrap', gap: '20px' }}>

                                {usersWithEquipments.filter(r => stockRoomFilter === 'All' ? true : stockRoomFilter === 'Stock Room' ? false : r.id !== 'center').map(user => <div key={user.id}>
                                    <h2>{user.firstName} {user.lastName}
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <button className="textButton" onClick={() => { setShowAssignEquipment(user); setUsersEquipments(user.equipments || []) }}>Assign</button>
                                            <button className="textButton" onClick={() => { setShowTransferEquipment(user); setReceiverEquipments([]); setReceiverUser(''); setUsersEquipments(user.equipments || []) }}>Transfer</button>
                                        </div>
                                    </h2>
                                    {
                                        <tbody>
                                            {equipmentGroupedByName(user.equipments.filter(r => categoryFilter !== 'All' ? r.type === categoryFilter : true).sort((a, b) => findMatchingEquipmentsAndSort(a, b))).map(r => <tr key={r.id}>
                                                <th>{r.name}</th>
                                                <td style={{ color: categoryFilter === 'All' ? 'black' : 'white', backgroundColor: getEquipmentQtyColor(r.id, r.qty) }}>{r.qty}</td>
                                            </tr>)}
                                        </tbody>
                                    }

                                </div>)}
                            </div>
                        </> : page === 'Holidays' ? <>
                            <Tabs tabs={['Upcoming', 'Past']} currentTab={viewHolidayType} setCurrentTab={setViewHolidayType} />


                            <ModalComp showModal={editHoliday} setShowModal={setEditHoliday}>
                                <h2>Edit Holiday</h2>
                                <MyCalendar label={'Start Date'} startDate={startDay} setStartDate={setStartDay} />
                                <MyCalendar label={'End Date'} startDate={endDay} setStartDate={setEndDay} />


                                <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                    <button disabled={!startDay || !endDay} onClick={handleSaveHoliday}>Save</button>
                                    <button className="textButton" style={{ marginTop: '25px' }} onClick={() => setEditHoliday(false)}>Cancel</button>
                                </div>
                            </ModalComp>
                            <ModalComp showModal={!!deleteHolidayId} setShowModal={setDeleteHolidayId}>
                                <h2>Delete Holiday?</h2>
                                <p>This action cannot be undone.</p>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <button style={{ background: 'red' }} onClick={() => { deleteHoliday(deleteHolidayId); setDeleteHolidayId('') }}>Delete</button>
                                    <button className="secondary" onClick={() => setDeleteHolidayId('')}>Cancel</button>
                                </div>
                            </ModalComp>

                            <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '20px' }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <h4 style={{ marginTop: '12px', marginBottom: '-10px', marginRight: '5px' }}>State Filter:</h4>
                                    <Tabs tabs={['All', ...cityFilterOptions]} currentTab={holidayStateFilter} setCurrentTab={setHolidayStateFilter} />
                                </div>
                            </div>

                            <table>
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>User</th>
                                        <th>State</th>
                                        <th>Created</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredHolidays.map(holiday => <tr key={holiday.id}>
                                        <td>{format(new Date(holiday.startDay), 'dd MMM yyyy hh:mm a')} - {format(new Date(holiday.endDay), 'dd MMM yyyy hh:mm a')}</td>
                                        <td>{getUserName(holiday.userId)}</td>
                                        <td>{getHolidayUser(holiday.userId)?.city || '-'}</td>
                                        <td>{format(new Date(holiday.created), 'dd MMM yyyy')}</td>
                                        <td>
                                            <button className="textButton" onClick={() => { setEditHoliday(holiday.id); setStartDay(new Date(holiday.startDay)); setEndDay(new Date(holiday.endDay)) }}>Edit</button>
                                            <button className="textButton" onClick={() => setDeleteHolidayId(holiday.id)}>Delete</button>
                                        </td>
                                    </tr>)}
                                </tbody>
                            </table>
                        </> : <>
                            <div style={{ display: 'flex', gap: '100px' }}>
                                {returnSessionFilters(true, true)}

                                <Tabs tabs={['YTD', 'Month']} currentTab={statsType} setCurrentTab={setStatsType} />

                                {statsType === 'YTD' && <div style={{ display: 'flex', gap: '20px', marginTop: '30px' }}>
                                    {[new Date().getFullYear() - 2, new Date().getFullYear() - 1, new Date().getFullYear()].map(yearVal => <button key={yearVal} style={{ textDecorationLine: yearVal === statsYear ? 'underline' : 'none' }} className="textButton" onClick={() => { setStatsYear(yearVal) }}>{yearVal}</button>)}
                                </div>}
                                {statsType === 'Month' && <div style={{ display: 'flex', gap: '20px', marginTop: '30px' }}>
                                    <button className="textButton" onClick={() => { setStatsDate(subMonths(statsDate, 1)) }}>{'< Prev'}</button>
                                    <p style={{ color: "#FF7100", marginTop: '10px' }}>{format(statsDate, 'MMM/yyyy')}</p>
                                    <button className="textButton" onClick={() => { setStatsDate(addMonths(statsDate, 1)) }}>{'Next >'}</button>
                                </div>}

                            </div>

                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div style={{ width: '40%' }}>
                                    <h3 style={{ marginTop: '12px', marginBottom: '-10px' }}>Month Stats</h3>
                                    {/* <p>{r.month}:  {r.rate.toFixed(1)}% ; Points Lost: {r.pointsLost}</p> */}
                                    <h3>Total Centers: {totalCentersForStats.length}</h3>
                                    <h3>Weekly: {totalStatsCenters.filter(r => r.pointsType === 'Weekly').length}</h3>
                                    <h3>Fortnightly: {totalStatsCenters.filter(r => r.pointsType === 'Fortnightly').length}</h3>
                                    <h3>Monthly: {totalStatsCenters.filter(r => r.pointsType === 'Monthly').length}</h3>
                                    <h3>Other: {totalStatsCenters.filter(r => r.pointsType === 'Other').length}</h3>
                                    <h3>Not Categorized: {totalStatsCenters.filter(r => !r.pointsType).length}</h3>
                                    <h3>Total Points: {calculatePointsSumCenter(totalStatsCenters)}</h3>

                                    <h3 style={{ borderTop: '1px solid #DCDCDC' }}>Attendance</h3>
                                    <h3>Total: {getAttendanceAfterFiltering(eventsAttendance.Total, statsType, statsDate)}</h3>
                                    <h3>Attended: {getAttendanceAfterFiltering(eventsAttendance.Attended, statsType, statsDate)}</h3>
                                    <h3>Missed: {getAttendanceAfterFiltering(eventsAttendance.Missed, statsType, statsDate)}</h3>
                                    <h3>Rescheduled: {getAttendanceAfterFiltering(eventsAttendance.Rescheduled, statsType, statsDate)}</h3>

                                    <h3>Percentage Attended: {computePercentageAttendance(getAttendanceAfterFiltering(eventsAttendance.Attended, statsType, statsDate), 'Attended')}%</h3>
                                    <h3>Percentage Missed: {computePercentageAttendance(getAttendanceAfterFiltering(eventsAttendance.Missed, statsType, statsDate), 'Missed')}%</h3>
                                    <h3>Percentage Rescheduled: {computePercentageAttendance(getAttendanceAfterFiltering(eventsAttendance.Rescheduled, statsType, statsDate), 'Rescheduled')}%</h3>

                                    <h3 style={{ borderTop: '1px solid #DCDCDC' }}>Programs</h3>
                                    {getProgramsCount(eventsAttendance.Total, statsType, statsDate)}

                                </div>
                                <div style={{ width: '40%' }}>
                                    <h3 style={{ marginTop: '12px', marginBottom: '-10px' }}>CHURN</h3>
                                    {/* <p>{r.month}:  {r.rate.toFixed(1)}% ; Points Lost: {r.pointsLost}</p> */}
                                    <h3>Total Centers Lost: <span style={{ textDecorationLine: 'underline' }} onClick={() => setShowTotalCentersLost(!showTotalCentresLost)}>{centersLostThatMonth.length}</span></h3>
                                    {
                                        showTotalCentresLost && <p>{centersLostThatMonth.map(r => <div key={r.id} style={{ marginBottom: '5px' }}>{r.name}</div>)}</p>
                                    }
                                    <h3>Weekly: {centersLostThatMonth.filter(r => r.pointsType === 'Weekly').length}</h3>
                                    <h3>Fortnightly: {centersLostThatMonth.filter(r => r.pointsType === 'Fortnightly').length}</h3>
                                    <h3>Monthly: {centersLostThatMonth.filter(r => r.pointsType === 'Monthly').length}</h3>
                                    <h3>Other: {centersLostThatMonth.filter(r => r.pointsType === 'Other').length}</h3>
                                    <h3>Not Categorized: {centersLostThatMonth.filter(r => !r.pointsType).length}</h3>
                                    <br />
                                    <h3>Total Points: {calculatePointsSumCenter(centersLostThatMonth)}</h3>
                                    <h3>Total Percentage: {statsType === 'YTD' ? churnRates.percent : (centersLostThatMonth.length / (totalStatsCenters.length || 1) * 100).toFixed(1)}%</h3>
                                    <br />
                                    <h3>Our Fault Centers: <span style={{ textDecorationLine: 'underline' }} onClick={() => setShowFaultCentersLost(!showFaultCentresLost)}>{centersLostThatMonth.filter(r => r.closedType === 'Our Fault').length}</span></h3>
                                    {
                                        showFaultCentresLost && <table><tbody>{centersLostThatMonth.filter(r => r.closedType === 'Our Fault').map(r => <tr key={r.id} style={{ marginBottom: '5px', }}><td>{r.name} </td><td>{r.closedDesc}</td></tr>)}</tbody></table>
                                    }
                                    <h3>Our Fault Points: {calculatePointsSumCenter(centersLostThatMonth.filter(r => r.closedType === 'Our Fault'))}</h3>
                                    <h3>Our Fault Percentage: {statsType === 'YTD' ? churnRates.percentFault : ((centersLostThatMonth.filter(r => r.closedType === 'Our Fault').length / (totalStatsCenters.length || 1)) * 100).toFixed(1)}%</h3>
                                    <br />
                                    <h3>Not Our Fault Centers: <span style={{ textDecorationLine: 'underline' }} onClick={() => setShowNotFaultCentersLost(!showNotFaultCentresLost)}>{centersLostThatMonth.filter(r => r.closedType === 'Not Our Fault').length}</span></h3>
                                    {
                                        showNotFaultCentresLost && <table><tbody>{centersLostThatMonth.filter(r => r.closedType === 'Not Our Fault').map(r => <tr key={r.id} style={{ marginBottom: '5px' }}><td>{r.name} </td><td>{r.closedDesc}</td></tr>)}</tbody></table>
                                    }
                                    <h3>Not Our Fault Points: {calculatePointsSumCenter(centersLostThatMonth.filter(r => r.closedType === 'Not Our Fault'))}</h3>
                                    <h3>Not Our Fault Percentage: {statsType === 'YTD' ? churnRates.percentNotFault : ((centersLostThatMonth.filter(r => r.closedType === 'Not Our Fault').length / (totalStatsCenters.length || 1)) * 100).toFixed(1)}%</h3>

                                </div>
                            </div>
                            <div style={{ marginTop: '30px' }}>
                                <h3>Offer Pipeline</h3>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Month</th>
                                            <th>Offer Centers</th>
                                            <th>New Offers</th>
                                            <th>Offer to Offer Closed</th>
                                            <th>Offer to New Center/Ongoing</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {offerStatsRows.map(row => <tr key={row.id}>
                                            <td>{row.monthLabel}</td>
                                            <td>{row.offerCenters}</td>
                                            <td>{row.newOffers}</td>
                                            <td>{row.movedToOfferClosed}</td>
                                            <td>{row.movedFromOfferPositive}</td>
                                        </tr>)}
                                        <tr style={{ borderTop: '1px solid #DCDCDC' }}>
                                            <td><strong>{statsType === 'YTD' ? `Total / Avg (${offerStatsRows.length} months)` : 'Total'}</strong></td>
                                            <td><strong>{statsType === 'YTD' ? averageOfferCenters : offerStatsTotals.offerCenters}</strong></td>
                                            <td><strong>{offerStatsTotals.newOffers}</strong></td>
                                            <td><strong>{offerStatsTotals.movedToOfferClosed}</strong></td>
                                            <td><strong>{offerStatsTotals.movedFromOfferPositive}</strong></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div style={{ marginTop: '30px' }}>
                                <h3>Center Attendance</h3>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Center</th>
                                            <th style={{ cursor: 'pointer', textDecorationLine: centerAttendanceSortBy === 'sessionsAttended' ? 'underline' : 'none' }} onClick={() => setCenterAttendanceSortBy('sessionsAttended')}>Sessions Attended</th>
                                            <th style={{ cursor: 'pointer', textDecorationLine: centerAttendanceSortBy === 'sessionsMissed' ? 'underline' : 'none' }} onClick={() => setCenterAttendanceSortBy('sessionsMissed')}>Sessions Missed</th>
                                            <th style={{ cursor: 'pointer', textDecorationLine: centerAttendanceSortBy === 'sessionsRescheduled' ? 'underline' : 'none' }} onClick={() => setCenterAttendanceSortBy('sessionsRescheduled')}>Sessions Rescheduled</th>
                                            {statsType === 'Month' && <th style={{ cursor: 'pointer', textDecorationLine: centerAttendanceSortBy === 'classesScheduled' ? 'underline' : 'none' }} onClick={() => setCenterAttendanceSortBy('classesScheduled')}>Classes Scheduled</th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {centerAttendanceStatsRows.map(row => <tr key={row.id}>
                                            <td>{row.centerName}</td>
                                            <td>{row.sessionsAttended}</td>
                                            <td>{row.sessionsMissed}</td>
                                            <td>{row.sessionsRescheduled}</td>
                                            {statsType === 'Month' && <td>{row.classesScheduled}</td>}
                                        </tr>)}
                                        <tr style={{ borderTop: '1px solid #DCDCDC' }}>
                                            <td><strong>Total ({centerAttendanceStatsRows.length} centers)</strong></td>
                                            <td><strong>{centerAttendanceStatsRows.map(r => r.sessionsAttended).reduce((sum, count) => sum + count, 0)}</strong></td>
                                            <td><strong>{centerAttendanceStatsRows.map(r => r.sessionsMissed).reduce((sum, count) => sum + count, 0)}</strong></td>
                                            <td><strong>{centerAttendanceStatsRows.map(r => r.sessionsRescheduled).reduce((sum, count) => sum + count, 0)}</strong></td>
                                            {statsType === 'Month' && <td><strong>{centerAttendanceStatsRows.map(r => r.classesScheduled).reduce((sum, count) => sum + count, 0)}</strong></td>}
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </>
        }



        <ModalComp showModal={!!showAssignEquipment} setShowModal={setShowAssignEquipment}>
            <h2>Assign Equipment</h2>


            <Dropdown label={'Choose Type'} options={equipmentCategories.filter(r => showAssignEquipment.id !== 'center' ? r !== 'Other' : true).map(r => ({ label: r, value: r }))} errorFields={[]} value={addEquipmentType} setValue={setAddEquipmentType} />

            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
                {
                    addEquipmentType && equipments.filter(r => r.type === addEquipmentType.value).sort((a, b) => a.priority >= b.priority ? 1 : -1).map(row => <div style={{ width: '150px' }}>
                        <Input type={'number'} bold label={row.name} errors={[]} value={fetchUsersQty(row)} setValue={(v) => updateUsersEquipments(v, row)} />
                    </div>)
                }

            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                <button disabled={!(showAssignEquipment.firstName === 'Stock' && showAssignEquipment.lastName === 'Room') && usersEquipments.find(r => r.qty && parseInt(r.qty) < 0)} onClick={handleSaveUsersEquipment}>Save</button>
                <button className="textButton" style={{ marginTop: '25px' }} onClick={() => setShowAssignEquipment(false)}>Cancel</button>
            </div>
        </ModalComp>

        <ModalComp showModal={!!showTransferEquipment} setShowModal={setShowTransferEquipment}>
            <h2>Transfer Equipment</h2>

            <div style={{ width: '300px', marginRight: '20px' }}>
                <Dropdown label={'Coaches'} options={[centerEquipments, ...returnedUsers].filter(r => r.id !== showTransferEquipment.id).map(r => ({ label: r.firstName + ' ' + r.lastName, value: r.id }))} errorFields={[]} value={receiverUser} setValue={setReceiverUser} />
            </div>

            <>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', marginTop: '20px' }}>

                    {usersEquipments.sort((a, b) => findMatchingEquipmentsAndSortByName(a, b)).map(r => <Checkbox key={r.id} errors={[]} label={`${r.name} (${r.qty})`} value={receiverEquipments.map(r => r.id).includes(r.id)} setValue={(v) => chooseTransferEquipment(r.id, v)} />)}

                </div>

                <h2 style={{ marginBottom: '-10px', marginTop: '40px' }}>Receiver receives</h2>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
                    {
                        receiverEquipments.map(row => <div style={{ width: '150px' }}>
                            <Input type={'number'} bold label={row.name} errors={[]} value={fetchUsersQty(row, receiverEquipments)} setValue={(v) => updateUsersEquipments(v, row, receiverEquipments, setReceiverEquipments)} />
                        </div>)
                    }
                </div>
            </>

            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                <button disabled={!receiverUser || receiverEquipments.length === 0 || receiverEquipments.filter(r => {
                    const matchingEquip = usersEquipments.find(x => x.id === r.id)
                    if (matchingEquip && matchingEquip.qty && r.qty) {
                        return parseInt(matchingEquip.qty) >= parseInt(r.qty)
                    }
                    return false
                }).length === 0} onClick={handleTransferUsersEquipment}>Save</button>
                <button className="textButton" style={{ marginTop: '25px' }} onClick={() => setShowTransferEquipment(false)}>Cancel</button>
            </div>
        </ModalComp>

    </div >
}

export default Calendar
